const _ = {
  BR_ACCESS_TOKEN_INVALID: "登录账号不合法",
  BR_ACCOUNT_BANNED: "账号被禁用",
  BR_ACCOUNT_NOT_EXIST: "账号不存在",
  BR_ACCOUNT_NOT_FOUND: "账号不存在",
  BR_ACCUMULATED_DATA_LENGTH_LIMIT: "发生错误：数据存储的表名长度不要超过30个字符",
  BR_ACTIVATION_CODE_NOT_EXIST: "激活码不存在",
  BR_ACTIVATION_CODE_USED: "该激活码已被使用",
  BR_ACTIVATION_INVALIDE_FORMAT: "激活码格式不正确",
  BR_ACTIVATION_INVALIDE_LENGHTH: "激活长度不合规",
  BR_BINDINGING_FAILURE: "账号绑定失败，请重新绑定",
  BR_CONTAINS_DIRTY_WORDS: "字符串包含敏感词",
  BR_CONTAINS_SPECIAL_CHARS: "字符组合不符合要求",
  BR_DISABLE_LOGIN: "不允许登录",
  BR_DRECTORY_NOT_PREPARED: "目录创建失败",
  BR_DUPLICATE_LEADERBOARD_NAME: "排行榜表名重复，请修改",
  BR_DUPLICATE_NICKNAME: "昵称重复",
  BR_DUPLICATE_SHEET_NAME: "表名重复,请修改",
  BR_EXTENSION_DULICATED_NAME: "重复的插件标示",
  BR_EXTENSION_NOT_FOUND: "插件没找到",
  BR_FF_COST_OVERFLOW: "超过最大Cost上限",
  BR_FF_EXPORT_INVALID_ENTITY: "导出场景物件失败",
  BR_FF_EXPORT_NO_SCENE: "没有找到主场景",
  BR_FF_EXPORT_NO_WORKFLOW: "没有找到全局设置",
  BR_FF_LEADERBOARD_COUNT_LIMIT: "建排行榜数上限",
  BR_FF_SHEET_COUNT_LIMIT: "建表数到上限",
  BR_FF_TELEPORTER_UNPAIRED: "传送物件不匹配",
  BR_FF_WEB_PROXY_HTTP_FAILED: "服务器调用失败",
  BR_FF_WORKSHOP_INVALID_EXPORT_SETTINGS_LENGTH: "地图导出文件超过2.5MB，请修改后再尝试。",
  BR_FF_WORKSHOP_INVALID_MAP_COVER_LENGTH: "地图封面文件大小超过10MB，请修改后再尝试。",
  BR_FF_WORKSHOP_INVALID_MAX_MEMBER_NUM: "地图最大玩家人数超过30，请修改后再尝试。",
  BR_FF_WORKSHOP_INVALID_OPEN_ATTRIBUTES_EXT_LENGTH: "地图参数文件超过2MB，请修改后再尝试。",
  BR_FF_WORKSHOP_INVALID_PROJECT_SETTINGS_LENGTH: "地图工程文件超过2MB，请修改后再尝试。",
  BR_FILE_EXISTED: "文件已存在",
  BR_FILE_IMPORT_ERROR: "文件导入失败",
  BR_FILE_NOT_FOUND: "文件没有找到",
  BR_FILE_OUT_OF_ASSET_FOLDER: "文件不能存储在Assets目录外",
  BR_FILE_OUT_OF_PROJECT_FOLDER: "文件不能存储在工程目录外",
  BR_GAME_ACCOUNT_ALREADY_BOUND: "游戏账号已绑定",
  BR_GAME_ACCOUNT_NOT_BOUND: "游戏账号未绑定",
  BR_GAME_ACCOUNT_NOT_FOUND: "游戏账号不存在",
  BR_INVALID_ARGUMENTS: "参数不合法",
  BR_INVALID_FILE: "文件损坏",
  BR_IPC_CLOSED: "IPC通道已关闭",
  BR_IPC_CONNECTED: "IPC通道已连接",
  BR_IPC_CREATE_CLIENT_FAILED: "IPC通道创建客户端失败",
  BR_IPC_IN_PROGRESS: "IPC通道正在连接中",
  BR_IPC_SAME_ADDR_NOT_ALLOWED: "IPC通道地址重复",
  BR_LEADERBOARD_NAME_LENGTH_LIMIT: "发生错误：数据存储的表名长度不要超过30个字符",
  BR_NICKNAME_ILLEGAL: "昵称不合法，请重新修改",
  BR_NICKNAME_OCCUPIED: "昵称已被占用，请重新修改",
  BR_NOT_IMPLEMENTED: "方法未实现",
  BR_NOT_IN_FOLDER: "文件不在工程中",
  BR_OK: "正常无错误",
  BR_PROJECT_CORRUPTED: "文件已损坏",
  BR_PROJECT_EXISTED: "工程已存在",
  BR_PROJECT_FOLDER_NOT_EMPTY: "工程目录不是空目录",
  BR_PROJECT_INTERNAL_ONLY: "仅限内部使用",
  BR_PROJECT_NOT_FOUND: "工程不存在",
  BR_PROJECT_NOT_OPENED: "工程没有打开",
  BR_SETTINGS_SIZE_INVALID: "设置文件长度不合法",
  BR_SHAREDATA_KEY_NOT_EXIST: "共享数据索引不存在",
  BR_SHEET_NAME_LENGTH_LIMIT: "发生错误：数据存储的表名长度不要超过30个字符",
  BR_STR_ENCODE_INVALID: "字符串编码不合法",
  BR_STR_LENGTH_INVALID: "长度错误",
  BR_USER_CANCEL: "用户取消",
  ECA_DES: "自定义指定UI界面的开启和关闭",
  ECA_DES_1: "为玩家添加任意数量的武器、道具或防具",
  ECA_NAME: "UI开启与关闭",
  ECA_NAME_1: "添加物品",
  FE_00_LOOT_SIGHT_TYPE: "Loot点倍镜类型",
  FE_00_LOOT_WEAPON_TYPE: "Loot点武器类型",
  FE_00_MOVEOBJECT_MOTION_TYPE: "移动物件的移动方式",
  FE_00_M_WS_AITYPE: "AI实体",
  FE_00_ONCLICK: "当按钮被点击时",
  FE_00_RESETABLE_ENTITY: "可重置实体",
  FE_00_T_WS_MUSICTYPE_DRUM_TITLE: "鼓键类型",
  FE_00_T_WS_MUSICTYPE_L1_TITLE: "合成器键类型A",
  FE_00_T_WS_MUSICTYPE_L2_TITLE: "合成器键类型B",
  FE_00_T_WS_MUSICTYPE_L3_TITLE: "合成器键类型C",
  FE_00_T_WS_MUSICTYPE_PIANO_TITLE: "音乐按键类型",
  FE_0_B_BORDER_COLOR: "边框颜色",
  FE_0_B_BORDER_TEXTURE: "边框材质",
  FE_0_B_BUILD_FAILED_CONTENT: "生成工程失败",
  FE_0_B_BUILD_SUCCESS_CONTENT: "构建成功",
  FE_0_B_BUTTON_PUBLISH: "发布",
  FE_0_B_CUSTOMPROP_COLOR_SELECTED: "色彩选择",
  FE_0_B_CUSTOMPROP_NOTADDED: "暂未添加属性",
  FE_0_B_CUSTOMPROP_OPTION: "选项配置",
  FE_0_B_CUSTOMPROP_TYPE_SELECTED: "请选择类型",
  FE_0_B_ECA_MORE: "更多...",
  FE_0_B_ECA_TIP_SAVE_SELECT: "当前场景未被保存，不可选择物件",
  FE_0_B_ECA_TIP_SELECT: "该物体不可被选择",
  FE_0_B_ENSURE_CLOSE_PUBLISH: "确定要关闭发布流程吗",
  FE_0_B_ITEM_HIDE: "躲猫猫",
  FE_0_B_PGC_IN: "策划专用",
  FE_0_B_PGC_INTERNAL: "PGCInternal",
  FE_0_B_POINT_ADD: "添加断点",
  FE_0_B_POINT_CLEAR: "删除全部断点",
  FE_0_B_POINT_DELETE: "删除断点",
  FE_0_B_POINT_DISABLE: "停用断点",
  FE_0_B_POINT_DISABLEALL: "停用全部断点",
  FE_0_B_POINT_ENABLE: "启用断点",
  FE_0_B_POINT_ENABLEALL: "启用全部断点",
  FE_0_B_ROUND_DOING: "阶段进行",
  FE_0_B_ROUND_END: "阶段结束",
  FE_0_B_ROUND_START: "阶段开始",
  FE_0_B_SURFACE_COLOR: "贴图颜色",
  FE_0_B_SURFACE_TEXTURE: "贴图材质",
  FE_0_B_TIP_CUSTOMPROP_COPIED: "已复制到剪切板",
  FE_0_B_TOOL_BUILD: "用户端",
  FE_0_B_UI_ANCHOR_MAX: "锚点最大值",
  FE_0_B_UI_ANCHOR_MIN: "锚点最小值",
  FE_0_B_UI_BACKGROUNDCOLOR: "背景颜色",
  FE_0_B_UI_BOTTOM: "Bottom",
  FE_0_B_UI_CENTER: "Center",
  FE_0_B_UI_CUSTOM: "Custom",
  FE_0_B_UI_HEIGHT: "高度",
  FE_0_B_UI_LETF: "Left",
  FE_0_B_UI_MIDDLE: "Middle",
  FE_0_B_UI_PIVOT: "支点",
  FE_0_B_UI_RATIO: "比例",
  FE_0_B_UI_RIGHT: "Right",
  FE_0_B_UI_STRETCH: "Stretch",
  FE_0_B_UI_TOP: "Top",
  FE_0_B_UI_TRANSFORM: "UITransform",
  FE_0_B_UI_WIDTH: "宽度",
  FE_0_B_UI_X: "PosX",
  FE_0_B_UI_Y: "PosY",
  FE_0_B_WORK_EDIT_VARIABLE: "编辑变量",
  FE_0_F_ACTIVATION_ACCOUNT: "退出激活",
  FE_0_F_ACTIVATION_ENTERCODE: "请输入激活码激活您的账号",
  FE_0_F_ACTIVATION_TITLE: "账号激活",
  FE_0_F_ACTIVATION_WARNING: "请确认是否退出激活",
  FE_0_F_ATTENTION: "注意",
  FE_0_F_BINDING_BUTTON1: "绑定",
  FE_0_F_BINDING_BUTTON2: "去绑定",
  FE_0_F_BINDING_BUTTON3: "解绑",
  FE_0_F_BINDING_CHANGE: "绑定其他账号",
  FE_0_F_BINDING_CONFIRMINFO: "检测到您登陆的Free Fire账号信息，请确认是否绑定此账号？",
  FE_0_F_BINDING_NICKNAME: "昵称：{0}",
  FE_0_F_BINDING_NOTICE: "使用Craftland Studio编辑器，须关联FreeFire游戏账号，以加载该游戏项目文件",
  FE_0_F_BINDING_NULL: "未绑定账号",
  FE_0_F_BINDING_NULL_NOTICE: "尚未绑定账号",
  FE_0_F_BINDING_SUCCESS: "账号绑定成功",
  FE_0_F_BINDING_TIPS: "账号关联中…",
  FE_0_F_BINDING_TITLE: "请选择您的Free Fire登陆方式",
  FE_0_F_BINDING_UNBIND: "账号已解除绑定",
  FE_0_F_BINDING_UNBIND_TIPS: "账号解绑中…",
  FE_0_F_BINDING_WARNING: "Craftland Studio需要关联Free Fire账号才能使用，请先完成账号绑定",
  FE_0_F_BUTTON_CANCEL: "取消",
  FE_0_F_BUTTON_CONFIRM: "确认",
  FE_0_F_ECA_SCRIPT: "ECA脚本",
  FE_0_F_INSTALL_INSERVICE: "Craftland Studio正在运行，点击“确定”关闭",
  FE_0_F_INSTALL_INSTALLING: "正在安装，请稍后…",
  FE_0_F_INSTALL_SETUPLOADING: "安装程序启动中请稍后…",
  FE_0_F_INSTALL_TITLE: "安装Craftland Studio",
  FE_0_F_INSTALL_VERIFING: "正在验证安装包：{0}",
  FE_0_F_ITEM_BARRIER: "障碍物",
  FE_0_F_ITEM_BASIC_STRUCTURE: "基础结构",
  FE_0_F_ITEM_BUILDING: "建筑",
  FE_0_F_ITEM_CAR: "载具",
  FE_0_F_ITEM_COMMON: "常用物件",
  FE_0_F_ITEM_COMMON_NOTI: "暂无常用物件，右键物件添加",
  FE_0_F_ITEM_CONTAINER: "箱型物件",
  FE_0_F_ITEM_DECORATION: "装饰物",
  FE_0_F_ITEM_FENCE: "围栏及围墙",
  FE_0_F_ITEM_FURNITURE: "家具电器",
  FE_0_F_ITEM_GAMEPLAY: "玩法物件",
  FE_0_F_ITEM_HISTORY: "最近使用物件",
  FE_0_F_ITEM_HISTORY_DELETENOTI: "确定要清空最近使用列表?",
  FE_0_F_ITEM_HISTORY_NOTI: "暂无最近使用物件，可以右键添加",
  FE_0_F_ITEM_HUGEHOUSE: "大型房屋",
  FE_0_F_ITEM_INTERACTIVE: "互动物件",
  FE_0_F_ITEM_LOOT_AMMO: "子弹",
  FE_0_F_ITEM_LOOT_AR: "步枪",
  FE_0_F_ITEM_LOOT_ARMOR: "防具及背包",
  FE_0_F_ITEM_LOOT_BAG: "背包",
  FE_0_F_ITEM_LOOT_FRESH: "刷新项数量",
  FE_0_F_ITEM_LOOT_GROUP: "物品组{0}",
  FE_0_F_ITEM_LOOT_GROUPFRESH: "刷新组数量",
  FE_0_F_ITEM_LOOT_HELMET: "护甲",
  FE_0_F_ITEM_LOOT_HG: "手枪",
  FE_0_F_ITEM_LOOT_MAGEZINE: "弹夹",
  FE_0_F_ITEM_LOOT_MELEE: "近战武器",
  FE_0_F_ITEM_LOOT_MUZZLE: "枪口",
  FE_0_F_ITEM_LOOT_NOTRANDOM: "必出",
  FE_0_F_ITEM_LOOT_PARTS: "武器配件",
  FE_0_F_ITEM_LOOT_SG: "霰弹枪",
  FE_0_F_ITEM_LOOT_SMG: "冲锋枪",
  FE_0_F_ITEM_LOOT_SNG: "狙击枪",
  FE_0_F_ITEM_LOOT_VEST: "头盔",
  FE_0_F_ITEM_LOOT_WEAPON: "武器",
  FE_0_F_ITEM_MIDHOUSE: "中型房屋",
  FE_0_F_ITEM_MODENEED: "模式必须",
  FE_0_F_ITEM_MUSICKEY: "音乐物件",
  FE_0_F_ITEM_OTHERS: "其他",
  FE_0_F_ITEM_PAD_NUM: "共{0}个",
  FE_0_F_ITEM_PIPE: "管道",
  FE_0_F_ITEM_PLANT: "植物",
  FE_0_F_ITEM_PORTAL_PROPERTY: "关联传送门",
  FE_0_F_ITEM_SPAWN_PROPERTY: "传送门最多生成人数",
  FE_0_F_ITEM_STREETSCAPE: "街景装饰",
  FE_0_F_ITEM_STRUCTURE: "结构物件",
  FE_0_F_ITEM_TRIGGER: "触发器",
  FE_0_F_ITEM_TYRE_PROPERTY: "弹射距离",
  FE_0_F_LANGUAGE_CNTRA: "繁體中文",
  FE_0_F_LANGUAGE_EN: "English",
  FE_0_F_LAUNCH_ACCOUNTCHECK: "检查账户信息",
  FE_0_F_LAUNCH_SETTING: "启动设置项",
  FE_0_F_LAUNCH_UPDATE: "版本更新中",
  FE_0_F_LAUNCH_VERSIONCHECK: "版本检测中",
  FE_0_F_LOGIN: "用户登录",
  FE_0_F_LOGIN_CANCEL: "登录失败，用户取消登录",
  FE_0_F_LOGIN_PRIVACY_POLICY: "隐私政策",
  FE_0_F_LOGIN_SERVICE: "服务条款",
  FE_0_F_LOGIN_TITLE: "请选择您的Craftland Studio登录方式",
  FE_0_F_LOGOUT_WRANING: "是否退出登录",
  FE_0_F_NAME: "名称",
  FE_0_F_NAME_PROPERTY: "物件属性",
  FE_0_F_NICKNAME_TIPS1: "昵称修改成功",
  FE_0_F_NOT_ADDED: "未添加",
  FE_0_F_NO_CONTENT_ADDED: "未添加内容",
  FE_0_F_PROGRESS: "进度{0}%",
  FE_0_F_PROJECT_ABOUT: "关于",
  FE_0_F_PROJECT_ALL: "全部",
  FE_0_F_PROJECT_AMEND_DATE: "修改日期",
  FE_0_F_PROJECT_BIND: "账号绑定",
  FE_0_F_PROJECT_CLOSE: "确认退出吗？",
  FE_0_F_PROJECT_DECREMENT: "递减",
  FE_0_F_PROJECT_DELETE_LOCAL: "同时删除本地文件",
  FE_0_F_PROJECT_DELETE_TITLE: "删除工程",
  FE_0_F_PROJECT_DELETE_WARNING: "确认要删除{0}工程？",
  FE_0_F_PROJECT_ECA: "ECA 文件",
  FE_0_F_PROJECT_FAVORITE: "收藏夹",
  FE_0_F_PROJECT_FITEM: "fItem 文件",
  FE_0_F_PROJECT_FOLDER: "文件夹",
  FE_0_F_PROJECT_FSCENEPREFAB: "fScenePrefab 文件",
  FE_0_F_PROJECT_IMPORT: "导入",
  FE_0_F_PROJECT_INCREMENT: "递增",
  FE_0_F_PROJECT_IN_SEARCH: "搜索中",
  FE_0_F_PROJECT_LANSET: "语言设置",
  FE_0_F_PROJECT_LARGE: "大",
  FE_0_F_PROJECT_LASTOPEN: "最近打开时间：{0}",
  FE_0_F_PROJECT_LIST: "列表",
  FE_0_F_PROJECT_LOADING: "工程加载中",
  FE_0_F_PROJECT_LOCAL: "打开本地文件",
  FE_0_F_PROJECT_LOGOUT: "退出登录",
  FE_0_F_PROJECT_MANAGE: "创建游戏",
  FE_0_F_PROJECT_MEDIUM: "中",
  FE_0_F_PROJECT_MODE: "模式选择",
  FE_0_F_PROJECT_MYPRO: "我的工程",
  FE_0_F_PROJECT_NAME: "工程名称",
  FE_0_F_PROJECT_NEW: "新建工程",
  FE_0_F_PROJECT_NEW_ECA: "新建ECA",
  FE_0_F_PROJECT_NEW_FOLDER: "新建文件夹",
  FE_0_F_PROJECT_NEW_UI: "新建UI",
  FE_0_F_PROJECT_NEW_WARNING: "项目名称不能为空",
  FE_0_F_PROJECT_NULL_NOTICE: "项目名称不能为空",
  FE_0_F_PROJECT_PATH: "文件位置",
  FE_0_F_PROJECT_PIC: "图示",
  FE_0_F_PROJECT_PREFAB: "Prefab 文件",
  FE_0_F_PROJECT_RENAME_NOTICE: "名称请勿包含*、/\\等字符",
  FE_0_F_PROJECT_RENAME_WARNING: "名称包含敏感字符",
  FE_0_F_PROJECT_SCENE: "Scene 文件",
  FE_0_F_PROJECT_SCRIPT: "脚本文件",
  FE_0_F_PROJECT_SIZE: "大小",
  FE_0_F_PROJECT_SMALL: "小",
  FE_0_F_PROJECT_SORT_BY: "排列方式",
  FE_0_F_PROJECT_TEXT: "文本文档",
  FE_0_F_PROJECT_TEXTURE: "贴图文件",
  FE_0_F_PROJECT_TREE_VIEW: "显示树状图",
  FE_0_F_PROJECT_UI: "UI 文件",
  FE_0_F_PROJECT_UPDATE: "检查更新",
  FE_0_F_RUNTIME_ADDBOT: "添加bot",
  FE_0_F_RUNTIME_CLIENT: "客户端",
  FE_0_F_RUNTIME_COMMAND: "控制指令",
  FE_0_F_RUNTIME_CONSOLE_COMMAND: "正在执行{0}指令",
  FE_0_F_RUNTIME_END_BACK: "返回编辑器",
  FE_0_F_RUNTIME_END_NOTICE: "当前游戏进程出现异常",
  FE_0_F_RUNTIME_END_RESTART: "重新开始",
  FE_0_F_RUNTIME_END_TITLE: "退出运行",
  FE_0_F_RUNTIME_GODMODE: "无敌",
  FE_0_F_RUNTIME_KEYBOARD: "键位提示",
  FE_0_F_RUNTIME_LOADING: "游戏加载中",
  FE_0_F_RUNTIME_PAUSE: "暂停",
  FE_0_F_RUNTIME_RECORD: "日志",
  FE_0_F_RUNTIME_RECOVER: "回复血量",
  FE_0_F_RUNTIME_RUN: "运行",
  FE_0_F_RUNTIME_STOP: "停止",
  FE_0_F_RUNTIME_SUICIDE: "自杀",
  FE_0_F_RUNTIME_TELEPORT: "传送至出生点",
  FE_0_F_SCENE: "场景{0}",
  FE_0_F_SCENE_AUTOFILL: "自动填充",
  FE_0_F_SCENE_EDITOR_ISO: "透视",
  FE_0_F_SCENE_EDITOR_PERSP: "正交",
  FE_0_F_SCENE_ITEM_COMMON: "设为常用物件",
  FE_0_F_SCENE_ITEM_COMMON_REMOVE: "从常用物件中移除",
  FE_0_F_SCENE_ITEM_NEW: "在场景中创建",
  FE_0_F_SCENE_LOADING: "地图加载中",
  FE_0_F_SCENE_NEW: "新建场景",
  FE_0_F_SCENE_SAVE: "保存场景",
  FE_0_F_SCENE_SAVE_ALL: "保存全部场景",
  FE_0_F_SCENE_TYPE: "地图类型",
  FE_0_F_SEARCH_NOTI: "输入关键字搜索",
  FE_0_F_SEARCH_NULL: "未找到相关结果",
  FE_0_F_TRANSFORM: "变换",
  FE_0_F_TRANSFORM_POSITION: "位置",
  FE_0_F_TRANSFORM_ROTATION: "旋转",
  FE_0_F_TRANSFORM_SCALE: "缩放",
  FE_0_F_UNDO_DELETE: "继续操作会删除当前文件{0}，是否确认删除？",
  FE_0_F_UNINSTALL_CONFIRM: "确定卸载Craftland Studio吗？",
  FE_0_F_UNINSTALL_TITLE: "卸载Craftland Studio",
  FE_0_F_UPDATE: "更新",
  FE_0_F_UPDATE_FAILURE: "更新失败",
  FE_0_F_UPDATE_RETRY: "重试",
  FE_0_F_VIEW: "浏览",
  FE_0_HW_BUTTON_CANCEL: "取消",
  FE_0_HW_BUTTON_COPY: "复制",
  FE_0_HW_BUTTON_NO: "否",
  FE_0_HW_BUTTON_OK: "确认",
  FE_0_HW_BUTTON_SAVE: "保存",
  FE_0_HW_BUTTON_UNSAVE: "不保存",
  FE_0_HW_BUTTON_YES: "是",
  FE_0_HW_CAMERA_DISTANCE: "距离",
  FE_0_HW_CAMERA_FOV: "视野范围",
  FE_0_HW_CAMERA_HORIZONTALANGLE: "水平角",
  FE_0_HW_CAMERA_MODE: "摄像机模式",
  FE_0_HW_CAMERA_MODE_1: "FF经典（射击）",
  FE_0_HW_CAMERA_MODE_2: "第三人称",
  FE_0_HW_CAMERA_MODE_3: "第一人称（射击）",
  FE_0_HW_CAMERA_MODE_4: "俯视角",
  FE_0_HW_CAMERA_OFFSET: "偏移量",
  FE_0_HW_CAMERA_TITLE: "摄像机设置",
  FE_0_HW_CAMERA_VERTICALANGLE: "俯仰角",
  FE_0_HW_CANNOT_PREVIEW: "无预览效果",
  FE_0_HW_CATEGORY_COMMON: "常用",
  FE_0_HW_CATEGORY_DATA: "数据",
  FE_0_HW_CATEGORY_ENTITY: "实体",
  FE_0_HW_CATEGORY_EVENT: "事件",
  FE_0_HW_CATEGORY_EXTERNALFUNCTION: "外部函数",
  FE_0_HW_CATEGORY_FUNCTION: "函数",
  FE_0_HW_CATEGORY_GAME: "游戏",
  FE_0_HW_CATEGORY_LOGIC: "逻辑",
  FE_0_HW_CATEGORY_SEARCH: "搜索",
  FE_0_HW_CATEGORY_VARIBLE: "变量",
  FE_0_HW_CTRL_BUTTON: "按钮",
  FE_0_HW_CTRL_GRAPH: "图片",
  FE_0_HW_CTRL_INPUT: "输入框",
  FE_0_HW_CTRL_LAYOUT: "布局",
  FE_0_HW_CTRL_PANEL: "面板",
  FE_0_HW_CTRL_TEXT: "文本",
  FE_0_HW_CUSTOMPROP_HINT: "提示：所有修改将会同步至同类实例",
  FE_0_HW_CUSTOMPROP_NAME: "属性名称",
  FE_0_HW_CUSTOMPROP_NAMEHINT: "请输入属性名",
  FE_0_HW_CUSTOMPROP_SUBTITLE: "配置{0}自定义属性",
  FE_0_HW_CUSTOMPROP_TITLE: "自定义属性",
  FE_0_HW_CUSTOMPROP_TYPE: "类型",
  FE_0_HW_CUSTOMPROP_TYPEHINT: "请输入属性初始值",
  FE_0_HW_CUSTOMPROP_VALUE: "初始值",
  FE_0_HW_DATA_ALL_COMMENT: "全部评论",
  FE_0_HW_EDITOR_FLOW: "流程编辑器",
  FE_0_HW_EDITOR_LOGIC: "逻辑编辑器",
  FE_0_HW_EDITOR_SCENE: "场景编辑器",
  FE_0_HW_EDITOR_UI: "UI编辑器",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_END: "游戏结束",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_FLOW: "流程设置",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PHASE: "游戏阶段",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PLAYER: "玩家设置",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PREPARE: "游戏准备",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_ROUND: "游戏回合",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_START: "游戏开始",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_TEAM: "队伍设置",
  FE_0_HW_GAME_EDITOR_FLOWSETTING: "流程设置",
  FE_0_HW_GAME_EDITOR_FLOW_END: "游戏结束",
  FE_0_HW_GAME_EDITOR_FLOW_PHASE: "游戏阶段",
  FE_0_HW_GAME_EDITOR_FLOW_PREPARE: "游戏准备",
  FE_0_HW_GAME_EDITOR_FLOW_ROUND: "游戏回合",
  FE_0_HW_GAME_EDITOR_FLOW_START: "游戏开始",
  FE_0_HW_GAME_EDITOR_INSPECT_ACTIVESKILL: "主动技能",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGEINFLICTED: "伤害倍率",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGETAKEN: "受到伤害倍率",
  FE_0_HW_GAME_EDITOR_INSPECT_DEFAULTEPPERCENT: "初始EP比例",
  FE_0_HW_GAME_EDITOR_INSPECT_ECA: "逻辑编辑",
  FE_0_HW_GAME_EDITOR_INSPECT_EPQUICKRESTORE: "EP快速转换",
  FE_0_HW_GAME_EDITOR_INSPECT_ID: "ID",
  FE_0_HW_GAME_EDITOR_INSPECT_JUMPHEIGHT: "跳跃高度",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXEP: "EP上限",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXHP: "生命上限",
  FE_0_HW_GAME_EDITOR_INSPECT_MOVESPEED: "移动速度",
  FE_0_HW_GAME_EDITOR_INSPECT_NAME: "名称",
  FE_0_HW_GAME_EDITOR_INSPECT_PASSIVESKILL: "被动技能",
  FE_0_HW_GAME_EDITOR_INSPECT_PLAYERNUMPERTEAM: "每队玩家数量",
  FE_0_HW_GAME_EDITOR_INSPECT_ROUNDCOUNT: "回合数",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET10: "时空屏障（Chrono）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET11: "节奏狂潮（Skyler）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET12: "极限执行者（Xayne）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET13: "心跳节拍（Dimitri）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET4: "幻化术（Wukong）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET5: "仿生躯体（A124）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET6: "旋律与你同在（Alok）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET7: "涂鸦庇护（Steffie）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET8: "足迹侦察（Clu）",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET9: "全面菁英 (K)",
  FE_0_HW_GAME_EDITOR_INSPECT_TEAMNUM: "队伍数量",
  FE_0_HW_GAME_EDITOR_INSPECT_TIME: "时间",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_BASIC: "基础设置",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_SKILL: "技能设置",
  FE_0_HW_GAME_EDITOR_INSPECT_UNLIMITEDAMMO: "弹药限制",
  FE_0_HW_GAME_EDITOR_PLAYERSETTING: "玩家设置",
  FE_0_HW_GAME_EDITOR_TEAMSETTING: "队伍设置",
  FE_0_HW_GENERAL_TEMPLATE: "模板",
  FE_0_HW_GRAPH_ANYTYPE: "任意类型",
  FE_0_HW_GRAPH_AS_TYPE: "为",
  FE_0_HW_GRAPH_BREAK: "中断循环",
  FE_0_HW_GRAPH_CALLRETURN: "返回",
  FE_0_HW_GRAPH_CONTINUE: "继续下一个",
  FE_0_HW_GRAPH_CREATELIST: "定义数组",
  FE_0_HW_GRAPH_ELSE: "否则",
  FE_0_HW_GRAPH_ELSEIF: "否则如果",
  FE_0_HW_GRAPH_EXTERNALCALL: "外部调用",
  FE_0_HW_GRAPH_EXTERNAL_GET: "获取外部",
  FE_0_HW_GRAPH_EXTERNAL_GET_2: "从",
  FE_0_HW_GRAPH_EXTERNAL_SET: "设置外部",
  FE_0_HW_GRAPH_EXTERNAL_SET_3: "为",
  FE_0_HW_GRAPH_FLOAT: "小数",
  FE_0_HW_GRAPH_FOREACH: "对于每个",
  FE_0_HW_GRAPH_FOREACH_2: "取自",
  FE_0_HW_GRAPH_FOR_INDEX: "索引",
  FE_0_HW_GRAPH_FOR_INDEX_1: "从",
  FE_0_HW_GRAPH_FOR_INDEX_2: "至",
  FE_0_HW_GRAPH_FOR_INDEX_3: "逐步",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT: "行为",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN: "返回",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL: "功能",
  FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA: "参数",
  FE_0_HW_GRAPH_GET_CUSTOM_INSP: "获取实体属性",
  FE_0_HW_GRAPH_GLOBAL_GET: "获取全局",
  FE_0_HW_GRAPH_GLOBAL_SET: "获取全局",
  FE_0_HW_GRAPH_GLOBAL_SET_1: "为",
  FE_0_HW_GRAPH_IF: "如果",
  FE_0_HW_GRAPH_INDEX: "索引",
  FE_0_HW_GRAPH_INT: "整数",
  FE_0_HW_GRAPH_LISTAPPEND: "赋值",
  FE_0_HW_GRAPH_LISTAPPEND_1: "为",
  FE_0_HW_GRAPH_LISTGET: "获取",
  FE_0_HW_GRAPH_LISTINSERT: "赋值",
  FE_0_HW_GRAPH_LISTINSERT_1: "为",
  FE_0_HW_GRAPH_LISTINSERT_2: "给",
  FE_0_HW_GRAPH_LISTSET: "设置",
  FE_0_HW_GRAPH_LISTTYPELABEL: "列举",
  FE_0_HW_GRAPH_NONE: "未选择",
  FE_0_HW_GRAPH_NULL: "空",
  FE_0_HW_GRAPH_NUMBER: "数字",
  FE_0_HW_GRAPH_OP_AND: "且",
  FE_0_HW_GRAPH_OP_OR: "或",
  FE_0_HW_GRAPH_PARALLELCALL: "执行",
  FE_0_HW_GRAPH_PICK_ENTITY: "选择场景物件",
  FE_0_HW_GRAPH_PICK_WIDGET: "选择UI控件",
  FE_0_HW_GRAPH_PROPERTY_GET: "获取",
  FE_0_HW_GRAPH_PROPERTY_GET_1: "从",
  FE_0_HW_GRAPH_PROPERTY_SET: "设置",
  FE_0_HW_GRAPH_PROPERTY_SET_2: "为",
  FE_0_HW_GRAPH_RETURN_SENTENSE: "返回",
  FE_0_HW_GRAPH_SERIALCALL: "等待",
  FE_0_HW_GRAPH_SET_CUSTOM_INSP: "设置实体属性",
  FE_0_HW_GRAPH_TEXT: "文本",
  FE_0_HW_GRAPH_UNKOWN_TYPE: "未知类型",
  FE_0_HW_INSPECT_ADD_COMPONENT: "添加组件",
  FE_0_HW_INSPECT_COPY_PROP: "复制属性值",
  FE_0_HW_INSPECT_CUSTOMPROP: "添加自定义属性",
  FE_0_HW_INSPECT_CUSTOM_INSP: "自定义属性",
  FE_0_HW_INSPECT_ECA_FILE: "图元文件",
  FE_0_HW_INSPECT_NAME: "名称",
  FE_0_HW_INSPECT_ONCLICK: "点击事件",
  FE_0_HW_INSPECT_PASTE_PROP: "粘贴属性值",
  FE_0_HW_INSPECT_POSITION: "位置",
  FE_0_HW_INSPECT_RESET_PROP: "重置",
  FE_0_HW_INSPECT_ROTATION: "旋转",
  FE_0_HW_INSPECT_SCALE: "缩放",
  FE_0_HW_INSPECT_TITLE_ANCHOR: "锚点",
  FE_0_HW_INSPECT_TITLE_BUTTON: "按钮",
  FE_0_HW_INSPECT_TITLE_BUTTON_ONCLICKS: "点击回调",
  FE_0_HW_INSPECT_TITLE_IMAGE: "图片",
  FE_0_HW_INSPECT_TITLE_INPUT: "输入框",
  FE_0_HW_INSPECT_TITLE_LAYOUT: "布局",
  FE_0_HW_INSPECT_TITLE_TEXT: "文本",
  FE_0_HW_INSPECT_TITLE_TRANSFORM: "转换",
  FE_0_HW_INSPECT_TYPE: "类型",
  FE_0_HW_INSPECT_VALUE: "初始值",
  FE_0_HW_LABEL_FILE_NAME: "文件名",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_DESC: "模板说明",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_NAME: "模板名称",
  FE_0_HW_LABEL_GRAPH_VARIABLE_NAME: "变量名称",
  FE_0_HW_LABEL_GRAPH_VARIABLE_TYPE: "变量类型",
  FE_0_HW_LABEL_NO_ECA: "未添加",
  FE_0_HW_LABEL_TRASHCAN: "回收站",
  FE_0_HW_LAYOUT_CONSOLE: "控制台",
  FE_0_HW_LAYOUT_CONTROL: "控件",
  FE_0_HW_LAYOUT_GAME: "游戏",
  FE_0_HW_LAYOUT_HIERARCHY: "层级",
  FE_0_HW_LAYOUT_INSPECTOR: "属性",
  FE_0_HW_LAYOUT_MODEL: "物件",
  FE_0_HW_LAYOUT_OVERVIEW: "总览",
  FE_0_HW_LAYOUT_PROJECT: "工程",
  FE_0_HW_LAYOUT_TEMPLATE: "模板",
  FE_0_HW_MENU_ABOUT: "关于",
  FE_0_HW_MENU_ACCOUNT: "账户",
  FE_0_HW_MENU_ADDCHILD: "添加子阶段",
  FE_0_HW_MENU_ADDPHASE: "添加阶段",
  FE_0_HW_MENU_ADDROUND: "添加回合",
  FE_0_HW_MENU_ALIGN_ECA: "对齐图元",
  FE_0_HW_MENU_API: "API文档",
  FE_0_HW_MENU_ASSET: "资源",
  FE_0_HW_MENU_ASSETSTORE: "资源商城",
  FE_0_HW_MENU_CANVAS_BG: "画布背景",
  FE_0_HW_MENU_CANVAS_DARK: "深色",
  FE_0_HW_MENU_CANVAS_LIGHT: "浅色",
  FE_0_HW_MENU_CLEAR_BLOCK: "清空图元",
  FE_0_HW_MENU_COLLAPSE_ECA: "折叠图元",
  FE_0_HW_MENU_COMMENT_ECA: "备注",
  FE_0_HW_MENU_CONTACT: "联系我们",
  FE_0_HW_MENU_COPY: "复制",
  FE_0_HW_MENU_CREATE: "新建",
  FE_0_HW_MENU_CUT: "剪切",
  FE_0_HW_MENU_DEBUG: "开发者工具",
  FE_0_HW_MENU_DEFAULT: "默认",
  FE_0_HW_MENU_DEFAULT_ZOOM: "缩放重置",
  FE_0_HW_MENU_DELETE: "删除",
  FE_0_HW_MENU_DELETELAYOUT: "删除布局",
  FE_0_HW_MENU_DUPLICATE: "快速复制",
  FE_0_HW_MENU_EDIT: "编辑",
  FE_0_HW_MENU_EDITOR: "编辑器",
  FE_0_HW_MENU_EXIT: "退出",
  FE_0_HW_MENU_FILE: "文件",
  FE_0_HW_MENU_FIT_WINDOW: "适应窗口",
  FE_0_HW_MENU_GRID_LINE: "网格线",
  FE_0_HW_MENU_HELP: "帮助",
  FE_0_HW_MENU_LANGUAGE: "语言",
  FE_0_HW_MENU_LANG_EN: "English",
  FE_0_HW_MENU_LANG_SC: "简体中文",
  FE_0_HW_MENU_LANG_TC: "繁體中文",
  FE_0_HW_MENU_LAYOUT: "布局",
  FE_0_HW_MENU_LOCK: "锁定",
  FE_0_HW_MENU_MANUAL: "用户手册",
  FE_0_HW_MENU_NEWPROJECT: "新建工程",
  FE_0_HW_MENU_OPEN: "打开",
  FE_0_HW_MENU_OPENLOG: "打开日志目录",
  FE_0_HW_MENU_OPENPROJECT: "打开工程",
  FE_0_HW_MENU_PASTE: "粘贴",
  FE_0_HW_MENU_PUBLISHPROJECT: "发布工程",
  FE_0_HW_MENU_REDO: "重做",
  FE_0_HW_MENU_RENAME: "重命名",
  FE_0_HW_MENU_SAVELAYOUT: "保存布局",
  FE_0_HW_MENU_SAVEPROJECT: "保存工程",
  FE_0_HW_MENU_SAVE_BLOCK_AS_TEMP: "添加到模板",
  FE_0_HW_MENU_SAVE_WORKSPACE: "保存",
  FE_0_HW_MENU_SETING_COMMON: "设为常用",
  FE_0_HW_MENU_SETTINGS: "设置",
  FE_0_HW_MENU_SKIN: "主题",
  FE_0_HW_MENU_SMART_LINE: "智能辅助线",
  FE_0_HW_MENU_UNCOLLAPSE_ECA: "展开图元",
  FE_0_HW_MENU_UNDO: "撤销",
  FE_0_HW_MENU_UNLOCK: "解锁",
  FE_0_HW_MENU_WIDE: "宽屏",
  FE_0_HW_MENU_WINDOW: "窗口",
  FE_0_HW_MENU_ZOOMIN: "放大",
  FE_0_HW_MENU_ZOOMOUT: "缩小",
  FE_0_HW_POPUP_DELETE_FILE: "是否确认删除{0}文件",
  FE_0_HW_POPUP_NOT_SAVE: "返回后已填写的信息不会保存，是否继续？",
  FE_0_HW_POPUP_NO_ATTENTION: "今后不再提醒",
  FE_0_HW_POPUP_SAVE_FILE: "您有未存储的文件，是否保存？",
  FE_0_HW_POPUP_SENTENCE: "已复制战场码，邀请社群好友，一同上线游玩",
  FE_0_HW_POPUP_TITLE_COMMENT: "评论",
  FE_0_HW_POPUP_TITLE_ITEM: "物品选择",
  FE_0_HW_POPUP_TITLE_MAP_SHARE: "分享战场码",
  FE_0_HW_POPUP_TITLE_ON_PUB: "发布游戏",
  FE_0_HW_POPUP_TITLE_PROP: "道具选择",
  FE_0_HW_POPUP_TITLE_PUB_SUCCESS: "发布成功",
  FE_0_HW_POPUP_TITLE_TIP: "提示",
  FE_0_HW_PROJECT_COMMENT_ORDER: "评论次数",
  FE_0_HW_PROJECT_DATA: "数据中心",
  FE_0_HW_PROJECT_DEFAULT_ORDER: "默认排序",
  FE_0_HW_PROJECT_GAME_DATA: "游戏数据",
  FE_0_HW_PROJECT_GAME_MODE: "游戏模式",
  FE_0_HW_PROJECT_GAME_PUBLISH: "发布时间",
  FE_0_HW_PROJECT_LIKE_ORDER: "点赞次数",
  FE_0_HW_PROJECT_PERSONAL_PAGE: "个人主页",
  FE_0_HW_PROJECT_SUB_ORDER: "收藏次数",
  FE_0_HW_PUBLISH_CREATOR: "创作者",
  FE_0_HW_PUBLISH_DESCRIPTION: "游戏描述",
  FE_0_HW_PUBLISH_GAME_NAME: "游戏名称",
  FE_0_HW_PUBLISH_MODE: "模式",
  FE_0_HW_PUBLISH_PLAYER: "玩家",
  FE_0_HW_PUBLISH_SCREENSHOT: "游戏截图",
  FE_0_HW_SEARCH_NO_RESOURCE: "未找到资源",
  FE_0_HW_SEARCH_NO_TARGET: "未找到目标",
  FE_0_HW_SEARCH_PLACEHOLDER: "搜索",
  FE_0_HW_TEMPLATE_NAME_1: "基础",
  FE_0_HW_TEMPLATE_NAME_2: "歼灭",
  FE_0_HW_TEMPLATE_NAME_3: "积分",
  FE_0_HW_TEMPLATE_NAME_4: "跑酷",
  FE_0_HW_TEMPLATE_NAME_5: "防守生存",
  FE_0_HW_TEXT_ADD_GRAPH_TEMPLATE: "添加图元模板",
  FE_0_HW_TEXT_CUSTOM_GRAPH_TEMPLATE: "自定义模板",
  FE_0_HW_TEXT_DEL_GRAPH_TEMPLATE: "删除图元模板",
  FE_0_HW_TEXT_EDIT_GRAPH_TEMPLATE: "修改图元模板",
  FE_0_HW_TEXT_OFFICIAL_GRAPH_TEMPLATE: "官方模板",
  FE_0_HW_TIP_CHANGE_OWNERTYPE: "是否确认更改当前实体类型？",
  FE_0_HW_TIP_CHOOSE_SLOT: "请选择想要发布游戏的槽位",
  FE_0_HW_TIP_COPIED: "已复制",
  FE_0_HW_TIP_COPY_CODE: "可复制并分享下方战场码给您的朋友：",
  FE_0_HW_TIP_CUSTOMPROP_SAMENAME: "同类型属性已有相同名称",
  FE_0_HW_TIP_CUSTOM_INSP_SAME_NAME: "同类型属性已有相同名称",
  FE_0_HW_TIP_CUSTOM_INSP_STRING_LEN: "String不能超过20个字符",
  FE_0_HW_TIP_GRAPH_DELETE: "是否确定删除模板{0}",
  FE_0_HW_TIP_GRAPH_INPUT_DESC: "请输入模板说明",
  FE_0_HW_TIP_GRAPH_INPUT_NAME: "请输入模板名称",
  FE_0_HW_TIP_GRAPH_TEMPLATE_DESC_LEN: "备注不能超过{0}个字符",
  FE_0_HW_TIP_GRAPH_TEMPLATE_NAME_LEN: "模板名称不能超过{0}个字符",
  FE_0_HW_TIP_INPUT: "请输入",
  FE_0_HW_TIP_NAME_EMPTY: "文件名不能为空",
  FE_0_HW_TIP_NOEXTERNAL: "当前你还没有外部定义的变量或函数，暂时不会在此显示任何内容",
  FE_0_HW_TIP_NO_GAME_PUBLISH: "尚未发布游戏项目",
  FE_0_HW_TIP_PREPARE_PUBLISH: "正在准备发布流程",
  FE_0_HW_TIP_PUBLISH_COVER: "该操作会覆盖原有已发布游戏，是否继续？",
  FE_0_HW_TIP_PUBLISH_SUCCESS: "您的游戏已经成功发布！",
  FE_0_HW_TIP_SAVE_SUCCESS: "保存成功",
  FE_0_HW_TIP_TO_CLEAR_TRASHCAN: "是否确认清空回收站？",
  FE_0_HW_TIP_TO_SAVE: "当前工作区有未保存的修改，是否保存？",
  FE_0_HW_TIP_UNLOCK_SLOT: "请至Free Fire Craftland解锁该槽位",
  FE_0_HW_TIP_VALUE_NOT_MATCH: "输入的初始值和限定类型不匹配",
  FE_0_HW_TIP_WAIT_PUBLISH: "发布中，请耐心等候",
  FE_0_HW_TITLE_PREVIEW: "预览",
  FE_0_HW_TITLE_SAVE_WORK: "保存工作区",
  FE_0_HW_TITLE_SOURCE_MANAGE: "资源选择预览",
  FE_0_HW_TITLE_TIP: "提示",
  FE_0_HW_TOOL_ADSORP_BOTTOM: "向下吸附",
  FE_0_HW_TOOL_ADSORP_LEFT: "向左吸附",
  FE_0_HW_TOOL_ADSORP_RIGHT: "向右吸附",
  FE_0_HW_TOOL_ADSORP_TOP: "向上吸附",
  FE_0_HW_TOOL_ALIGN_BOTTOM: "底端对齐",
  FE_0_HW_TOOL_ALIGN_LEFT: "左对齐",
  FE_0_HW_TOOL_ALIGN_RIGHT: "右对齐",
  FE_0_HW_TOOL_ALIGN_TOP: "顶端对齐",
  FE_0_HW_TOOL_CENTER: "中心",
  FE_0_HW_TOOL_CENTER_HOR: "水平居中",
  FE_0_HW_TOOL_CENTER_VER: "垂直居中",
  FE_0_HW_TOOL_CLIENT: "客户端",
  FE_0_HW_TOOL_DISTRI_HOR: "水平分布",
  FE_0_HW_TOOL_DISTRI_VER: "垂直分布",
  FE_0_HW_TOOL_GLOBAL: "世界空间",
  FE_0_HW_TOOL_GRID: "网格对齐",
  FE_0_HW_TOOL_GROUP: "组合",
  FE_0_HW_TOOL_HAND: "选择",
  FE_0_HW_TOOL_LOCAL: "游戏对象",
  FE_0_HW_TOOL_MOVE: "移动",
  FE_0_HW_TOOL_PIVOT: "枢轴",
  FE_0_HW_TOOL_REDO: "重做",
  FE_0_HW_TOOL_ROTATE: "旋转",
  FE_0_HW_TOOL_SAVE: "保存",
  FE_0_HW_TOOL_SCALE: "缩放",
  FE_0_HW_TOOL_SURF: "表面对齐",
  FE_0_HW_TOOL_TRANS: "变换",
  FE_0_HW_TOOL_UNDO: "撤销",
  FE_0_HW_TOOL_UNGROUP: "取消组合",
  FE_0_HW_TOOL_VERTEX: "顶点对齐",
  FE_0_HW_UI_EDITOR_INSPECT_ACTIVE: "可视",
  FE_0_HW_UI_EDITOR_INSPECT_BACKGROUND: "背景",
  FE_0_HW_UI_EDITOR_INSPECT_CELLSIZE: "子级大小",
  FE_0_HW_UI_EDITOR_INSPECT_COLOR: "颜色",
  FE_0_HW_UI_EDITOR_INSPECT_CONSTRAINT: "限制",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_COLUMN: "限制列数",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_ROW: "限制行数",
  FE_0_HW_UI_EDITOR_INSPECT_DISABLE: "禁用",
  FE_0_HW_UI_EDITOR_INSPECT_DOWN: "下",
  FE_0_HW_UI_EDITOR_INSPECT_FILL_DIRECTION: "填充方向",
  FE_0_HW_UI_EDITOR_INSPECT_FLEX: "灵活",
  FE_0_HW_UI_EDITOR_INSPECT_FONT: "字体",
  FE_0_HW_UI_EDITOR_INSPECT_FONTALIGN: "文本对齐",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSIZE: "字号",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSTYLE: "字体样式",
  FE_0_HW_UI_EDITOR_INSPECT_GRID: "网格布局",
  FE_0_HW_UI_EDITOR_INSPECT_HIGHLIGHT: "悬浮",
  FE_0_HW_UI_EDITOR_INSPECT_HOR: "水平",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT: "左",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_DOWN: "左下",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_UP: "左上",
  FE_0_HW_UI_EDITOR_INSPECT_LINESPACE: "行间距",
  FE_0_HW_UI_EDITOR_INSPECT_MAX: "最大",
  FE_0_HW_UI_EDITOR_INSPECT_MAXLENGTH: "最大长度",
  FE_0_HW_UI_EDITOR_INSPECT_MIN: "最小",
  FE_0_HW_UI_EDITOR_INSPECT_MULTI_LINE: "多行",
  FE_0_HW_UI_EDITOR_INSPECT_NORMAL: "默认",
  FE_0_HW_UI_EDITOR_INSPECT_OFFSET: "偏离",
  FE_0_HW_UI_EDITOR_INSPECT_PIVOT: "中心点",
  FE_0_HW_UI_EDITOR_INSPECT_PLACEHOLDER: "占位文字",
  FE_0_HW_UI_EDITOR_INSPECT_PRESS: "点击",
  FE_0_HW_UI_EDITOR_INSPECT_REVERSE: "翻转",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT: "右",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_DOWN: "右下",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_UP: "右上",
  FE_0_HW_UI_EDITOR_INSPECT_SET_NATIVE: "恢复图片默认大小",
  FE_0_HW_UI_EDITOR_INSPECT_SINGLE_LINE: "单行",
  FE_0_HW_UI_EDITOR_INSPECT_SOURCE: "图片选择",
  FE_0_HW_UI_EDITOR_INSPECT_SPACE: "间隔",
  FE_0_HW_UI_EDITOR_INSPECT_START_CORNER: "初始方向",
  FE_0_HW_UI_EDITOR_INSPECT_TABLE: "填充布局",
  FE_0_HW_UI_EDITOR_INSPECT_TEXTINPUT: "输入文字",
  FE_0_HW_UI_EDITOR_INSPECT_TYPE: "类型",
  FE_0_HW_UI_EDITOR_INSPECT_UNACTIVE: "隐藏",
  FE_0_HW_UI_EDITOR_INSPECT_UP: "上",
  FE_0_HW_UI_EDITOR_INSPECT_VER: "垂直",
  FE_0_HW_UI_EDITOR_INSPECT_WORDWRAP: "换行",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS: "函数的参数与参数类型与最初的参数类型不相同，需要手动确认函数调用的正确性",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE: "函数的返回类型与最初的返回类型不相同，需要手动确认函数调用的正确性",
  FE_0_HW_WARNING_LOCALVAR_NODEFINE: "局部变量未定义错误",
  FE_0_HW_WARNING_LOCALVAR_OOS: "局部变量超出作用域错误",
  FE_0_HW_WARNING_NODEFINE: "未定义错误 {0}",
  FE_0_HW_WARNING_PARAM_NODEFINE: "变量未定义错误{0}",
  FE_0_HW_WARNING_RETURNNOTINFUNCTION: "只有在函数体内才能使用返回语句",
  FE_0_HW_WARNING_TYPEASSIGN: "类型匹配错误",
  FE_0_HW_WORK_CLEAN: "清空回收站",
  FE_0_HW_WORK_CREATE_VARIABLE: "创建变量",
  FE_0_M_SENCE_EDIT_NAMEERROR: "内容含有非法字符，请修改",
  FE_0_Q_FALSE: "假",
  FE_0_Q_SENCE_DEFAULT: "(默认场景)",
  FE_0_Q_SENCE_ENUM: "场景枚举",
  FE_0_Q_SENCE_SETDEFAULT: "设置为默认场景",
  FE_0_Q_TOKEN_EXPIRED: "登陆凭证已过期，需要重新登录",
  FE_0_Q_TRUE: "真",
  FE_0_ZZ_CLEAR: "清除",
  FE_0_ZZ_CREATE_EMPTY: "创建空节点",
  FE_0_ZZ_ECA_NAME_NOT_EMPTY: "变量名称不能为空",
  FE_0_ZZ_ECA_READ_ONLY: "只读",
  FE_0_ZZ_ECA_TO_DEFINE: "跳转至定义",
  FE_0_ZZ_ECA_VALUE_NOT_MATCH: "初始值和限定类型不匹配",
  FE_0_ZZ_GRAPH_NOT_FOUND: "没有找到相关图元",
  FE_0_ZZ_PROJECT_FOLDER_EMPTY: "工程目录应为空目录",
  FE_0_ZZ_PROJECT_PIC_SIZE: "缩略图大小",
  FE_0_ZZ_PROJECT_SERVER_OUT: "连接服务器超时",
  FE_0_ZZ_PROJECT_TYPE: "视图类型",
  FE_0_ZZ_SEARCH_NO_RESULT: "未找到相关结果",
  FE_0_ZZ_SHOW_IN_EXPLORER: "在资源管理器中显示",
  FE_0_ZZ_SKYENV_AMBIENT: "环境光颜色",
  FE_0_ZZ_SKYENV_CUSTOM: "自定义",
  FE_0_ZZ_SKYENV_DARK: "暗度",
  FE_0_ZZ_SKYENV_DAY: "白天",
  FE_0_ZZ_SKYENV_EVE: "黄昏",
  FE_0_ZZ_SKYENV_FLARE: "镜头光晕",
  FE_0_ZZ_SKYENV_FOG: "雾色",
  FE_0_ZZ_SKYENV_LIGHT_COLOR: "光照颜色",
  FE_0_ZZ_SKYENV_LIGHT_INTENSITY: "光照强度",
  FE_0_ZZ_SKYENV_NIGHT: "夜晚",
  FE_0_ZZ_SKYENV_NIGHT_MODE: "黑夜模式",
  FE_0_ZZ_SKYENV_SHADOW: "阴影强度",
  FE_0_ZZ_SKYENV_SKY: "天空盒",
  FE_0_ZZ_SKYENV_WETNESS: "地面湿度",
  FE_38_B_CAMERA_DEFAULT: "默认相机",
  FE_38_B_CHECK: "查看",
  FE_38_B_CHECK_FAILED: "未通过审核",
  FE_38_B_COMPONENTS_CREATECOPY: "创建副本",
  FE_38_B_COMPONENTS_CUSTOM: "自定义组件",
  FE_38_B_COMPONENTS_CUSTOM_CREATE: "创建自定义组件",
  FE_38_B_COMPONENTS_CUSTOM_DELETE: "删除组件",
  FE_38_B_COMPONENTS_EDIT: "配置组件属性",
  FE_38_B_COMPONENTS_MANAGE: "组件管理器",
  FE_38_B_COMPONENTS_OFFICAL: "官方组件",
  FE_38_B_COMPONENTS_PROPERTIES: "属性",
  FE_38_B_COMPONENTS_PROPERTIES_DEFAULT: "默认属性",
  FE_38_B_COMPONENTS_PROPERTIES_REQUIRE: "Require属性",
  FE_38_B_COMPONENTS_RESET: "重置组件",
  FE_38_B_COMPONENTS_TIP_DELETE: "删除该组件会导致Require关系取消，是否确认删除",
  FE_38_B_COMPONENTS_TIP_REQUIRE: "该组件当前被以下组件Require中",
  FE_38_B_DEBUGSETTING_ASSIGN_TEAM: "分配队伍",
  FE_38_B_DEBUGSETTING_AUTO: "自动",
  FE_38_B_DEBUGSETTING_AUTO_TEAM: "自动分配队伍",
  FE_38_B_DEBUGSETTING_DEBUG_MODE: "Debug模式",
  FE_38_B_DEBUGSETTING_LANG: "启动语言",
  FE_38_B_DEBUGSETTING_NAME: "调试设置",
  FE_38_B_DEBUGSETTING_REMOTE: "使用远端服务器",
  FE_38_B_DEBUGSETTING_REMOTE_ADDRESS: "远端服务器地址",
  FE_38_B_DEBUGSETTING_SIDE_NUMBER: "调试端数量",
  FE_38_B_DEBUGSETTING_STRICT_MODE: "严格模式",
  FE_38_B_DEBUGSETTING_TEAM: "队伍{0}",
  FE_38_B_DEBUGSETTING_TEAMUP: "组队",
  FE_38_B_DEBUGSETTING_TOOL: "调试工具",
  FE_38_B_ECA_ADD_WATCH: "添加侦察",
  FE_38_B_ECA_CALL_FUNCTION: "调用函数",
  FE_38_B_ECA_CAMERA_ENTITY: "相机组件",
  FE_38_B_ECA_CLEAR_WATCH: "清除侦察",
  FE_38_B_ECA_CONDITIONAL_STATEMENT: "条件语句",
  FE_38_B_ECA_DEFINE_BEHAVIOR: "定义行为",
  FE_38_B_ECA_DEFINE_FUNCTION: "定义函数",
  FE_38_B_ECA_DEL_WATCH: "删除侦察",
  FE_38_B_ECA_LIST: "ECA列表",
  FE_38_B_ECA_PARALIST: "参数列表",
  FE_38_B_ECA_SET_VARIABLE: "设置变量",
  FE_38_B_ECA_SOUND_ENTITY: "音效实体组件",
  FE_38_B_ECA_TIPSHUD_ENTITY: "文本TIPSHUD组件",
  FE_38_B_GAME_EDITOR_LOCALIZATIONSETTING: "本地化设置",
  FE_38_B_LOCALIZATION_NEW_CSV: "创建CSV",
  FE_38_B_LOCALIZATION_TIPS1: "当前无绑定的本地化文件",
  FE_38_B_LOCALIZATION_TIPS2: "本地化CSV文件的编码格式应为UTF8",
  FE_38_B_LOCALIZATION_TIPS3: "在当前绑定文件中无法找到{0}",
  FE_38_B_LOOT_RESET: "每回合重置",
  FE_38_B_MENU_DELETE: "删除窗口布局{0}",
  FE_38_B_MENU_TIPS1: "请输入布局名称",
  FE_38_B_MENU_TIPS2: "请更改为其他名称",
  FE_38_B_MENU_TIPS3: "命名重复，是否直接替换",
  FE_38_B_MENU_TIPS4: "token过期，请重新登录",
  FE_38_B_MENU_TIPS5: "点击可查看跳转信息",
  FE_38_B_MENU_WORDFILTER: "脏字检测",
  FE_38_B_NEW_PROJECT: "新建项目",
  FE_38_B_POINT_TIPS_EXCEED: "超过了断点上限（1000个）",
  FE_38_B_PROJECTSETTING_COVER: "封面",
  FE_38_B_REVIEW_01: "敏感字检测",
  FE_38_B_REVIEW_02: "正在进行敏感字检测，可在Console中查看详情",
  FE_38_B_REVIEW_03: "已完成敏感字检测，共检测文本{0}条，其中包含敏感字{1}条，请查看报错信息",
  FE_38_B_SLOT_DEFAULT: "默认槽位",
  FE_38_B_SLOT_POPULAR: "热门槽位",
  FE_38_B_SLOT_POPULAR_NONE: "无热门槽位",
  FE_38_B_TIP_DELETE_FAILED: "该组件当前无法删除",
  FE_38_B_TIP_DIRTY_SAVE: "请先将下列组件保存：",
  FE_38_B_TIP_OFFICAL_REQUIRE: "官方组件 require 不能修改",
  FE_38_B_TIP_SAVE_FAILED: "保存失败",
  FE_38_V_CONSOLE_TO_GRAPH: "双击以跳转至定义处",
  FE_38_V_CONSOLE_TO_TARGET: "双击以跳转至目标位置",
  FE_38_V_ECA_COMPONENT_SELECT: "筛选组件",
  FE_38_V_MENU_WORK_AREA: "工作区",
  FE_38_WZY_WS_CLEARPRO_ALL: "清除所有属性因子",
  FE_38_ZQ_INSPECTOR_STATIC: "静态合批",
  FE_38_ZQ_INSPECTOR_STATICTIPS: "勾选此框已标记该对象在场景中是静态的。",
  FE_38_ZQ_LAUNCH_CHECKING: "审核中",
  FE_38_ZQ_LAUNCH_FAILED: "未通过审核，请进入项目并在console中查看详情。",
  FE_38_ZQ_LAUNCH_TIPS: "请在“数据中心”关注审核状态，审核通过后会为您自动发布游戏。",
  FE_38_ZQ_PROJECTSETTING_COVER: "设为封面",
  FE_38_ZQ_PROJECTSETTING_DEFAULTLANG: "默认语言",
  FE_38_ZQ_PROJECTSETTING_DOUBLECHECK: "你确定要放弃本次修改吗？",
  FE_38_ZQ_PROJECTSETTING_INFO: "基础信息",
  FE_38_ZQ_PROJECTSETTING_LANG: "本地化表单",
  FE_38_ZQ_PROJECTSETTING_LANGTIPS: "当没有为Key配置对应的语言文本时，将默认显示该语种下的文本。",
  FE_38_ZQ_PROJECTSETTING_LIMIT: "图片超过200k，无法上传，请重新选择。",
  FE_38_ZQ_PROJECTSETTING_LOC: "本地化",
  FE_38_ZQ_PROJECTSETTING_NAME: "工程设置",
  FE_38_ZQ_PROJECTSETTING_PICTIPS1: "可接受的图片文件：jpg，jpeg，png, bmp。",
  FE_38_ZQ_PROJECTSETTING_PICTIPS2: "推荐尺寸为420*182 px，大小必须在200k以内。",
  FE_38_ZQ_PROJECTSETTING_PICTIPS3: "您的项目会在通过系统审核后，再对其他用户开放。",
  FE_38_ZQ_PROJECTS_IMPORT: "导入",
  FE_38_ZQ_PROJECTS_REFRESH: "刷新",
  FE_38_ZQ_PROJECTS_TIPS: "您无法撤销删除资源操作",
  FE_38_ZZ_CAMERA_ADD: "在当前位置添加摄像机",
  FE_38_ZZ_CAMERA_BLOCK_MODE: "遮蔽模式",
  FE_38_ZZ_CAMERA_CHOOSE: "选择相机模式",
  FE_38_ZZ_CAMERA_CONTROL: "通过操控屏幕控制相机",
  FE_38_ZZ_CAMERA_CUSTOM: "自定义相机",
  FE_38_ZZ_CAMERA_FOCUS_OFFSET_DESC: "朝向偏移量为相机所看向的点相对于玩家中心点的坐标",
  FE_38_ZZ_CAMERA_FOV_DESC: "视野范围为相机的观察角度",
  FE_38_ZZ_CAMERA_INVISICAM: "半透明",
  FE_38_ZZ_CAMERA_OFFSET_DESC: "位置偏移量为相机相对于玩家中心点的坐标",
  FE_38_ZZ_CAMERA_ORTHOGRAPHIC: "正交",
  FE_38_ZZ_CAMERA_PERSPECTIVE: "透视",
  FE_38_ZZ_CAMERA_PREVIEW: "预览",
  FE_38_ZZ_CAMERA_PROJECTION_MODE: "投影模式",
  FE_38_ZZ_CAMERA_SET: "设置游戏内相机",
  FE_38_ZZ_CAMERA_STABLE: "固定",
  FE_38_ZZ_CAMERA_START: "预设相机",
  FE_38_ZZ_CAMERA_START_MODE: "预设相机模式",
  FE_38_ZZ_CAMERA_THIRD: "第三人称（追背）",
  FE_38_ZZ_CAMERA_TRANSVERSE: "横向滚轴",
  FE_38_ZZ_CAMERA_ZOOM: "推进",
  FE_38_ZZ_ECA_COMMON: "公共事件",
  FE_38_ZZ_ECA_COMPONENT_SET: "设定组件类型",
  FE_38_ZZ_ECA_COMPONENT_TYPE: "组件类型",
  FE_38_ZZ_ECA_PRIVATE: "私有事件",
  FE_38_ZZ_ECA_USED: "已使用图元",
  FE_38_ZZ_EMPTY: "空节点",
  FE_39A_B_LOGIN_BACK: "返回",
  FE_39A_B_LOGIN_JOIN: "加入",
  FE_39A_B_LOGIN_LOADING: "加载中",
  FE_39A_B_LOGIN_SIGNIN: "登录",
  FE_39A_B_LOGIN_SIGNINWITH: "{0}登录",
  FE_39A_B_LOGIN_SIGNUP: "注册",
  FE_39A_B_LOGIN_SIGNUPWITH: "{0}注册",
  FE_39A_B_LOGIN_SUCCESS: "成功",
  FE_39A_B_LOGIN_TIPS1: "登录到Craftland Studio",
  FE_39A_B_LOGIN_TIPS10: "绑定Freefire账号后可进行工程发布和访问Freefire projects",
  FE_39A_B_LOGIN_TIPS11: "没有Freefire账号？",
  FE_39A_B_LOGIN_TIPS12: "已有Freefire账号？",
  FE_39A_B_LOGIN_TIPS2: "没有Craftland Studio账号？",
  FE_39A_B_LOGIN_TIPS3: "已有Craftland Studio账号？",
  FE_39A_B_LOGIN_TIPS4: "在弹窗上完成登录，成功登陆后此页面将被刷新",
  FE_39A_B_LOGIN_TIPS5: "正在准备启动Craftland Studio",
  FE_39A_B_LOGIN_TIPS6: "要使用 Carftland studio 和访问Freefire projects，您必须先绑定您的 free fire 帐户",
  FE_39A_B_LOGIN_TIPS7: "绑定失败，请重试",
  FE_39A_B_LOGIN_TIPS8: "提示信息",
  FE_39A_B_LOGIN_TIPS9: "请确认是否对下方FreeFire账号进行绑定，成功后将获取Freefrie projects的信息",
  FE_39A_V_NINE_SLICE: "九宫格",
  FE_39A_ZQ_ATLAS_CLEARFAIL: "清理失败",
  FE_39A_ZQ_ATLAS_CLEARSUC: "已清理",
  FE_39A_ZQ_ATLAS_MEMORY: "UI图集缓存",
  FE_39A_ZQ_FILE_FILEID: "文件ID",
  FE_39A_ZQ_FILE_PATH: "路径",
  FE_39A_ZQ_MESH_SUBMESHCOUNT: "子网格数量",
  FE_39A_ZQ_PERFORMANCE: "性能",
  FE_39_B_ADD: "添加",
  FE_39_B_BAN_DRAG: "禁止拖拽",
  FE_39_B_CHOOSE_ENTITY: "选择实体发送",
  FE_39_B_CHOOSE_TYPE: "选择参数类型",
  FE_39_B_COPY: "副本",
  FE_39_B_CREATE_SIGNAL_PARAMETER: "创建信号参数",
  FE_39_B_CUSTOM_EVENT: "自定义事件",
  FE_39_B_DATA_OPERATE: "数据操作",
  FE_39_B_DELETE_SIGNAL_PARAMETER: "删除信号参数{0}",
  FE_39_B_ENUM: "枚举",
  FE_39_B_ENUM_DETAIL: "枚举详情",
  FE_39_B_GUNSKIN_PROP: "枪械皮肤属性",
  FE_39_B_GUNSKIN_SKILL: "枪械皮肤技能",
  FE_39_B_LOCALIZATION_TIPS1: "本地化文件字符长度不合法",
  FE_39_B_SIGNAL_CONFIG: "预定义信号参数配置",
  FE_39_B_SIGNAL_NAME: "信号名称",
  FE_39_B_SIGNAL_PARAMETER: "预定义信号参数",
  FE_39_B_SIGNAL_RECEIVE: "接收信号{0}时",
  FE_39_B_SIGNAL_SEND: "发射信号{0}",
  FE_39_B_SIGNAL_TIPS1: "信号名称不能重复",
  FE_39_B_SIGNAL_TIPS2: "自定义信号事件失败",
  FE_39_B_TAG_EDIT: "标签编辑",
  FE_39_B_TAG_TIPS1: "是否确认删除此标签？",
  FE_39_B_TARGET_ENTITY: "目标实体",
  FE_39_M_ACCOUNTID: "玩家账号",
  FE_39_M_ADDTEMPLATE: "添加模板",
  FE_39_M_ASC: "升序",
  FE_39_M_BLOCKLY: "图元预览",
  FE_39_M_CLEAR: "清空数据",
  FE_39_M_CLEAR1: "清空表内数据，不可撤销。是否确认？",
  FE_39_M_CLEAR2: "将清空所有数据，不可撤销。是否确认？",
  FE_39_M_CLEAR3: "删除这条数据，不可撤销。是否确认？",
  FE_39_M_COMPONENT: "组件预览",
  FE_39_M_COMPONENTDESC: "组件说明",
  FE_39_M_COMPONENTLIST: "组件列表",
  FE_39_M_DATA: "数据存储",
  FE_39_M_DATAMAX: "数据表已达最大数量",
  FE_39_M_DATAMODEDESC: "启用该模组后就可以调用对应的组件和图元。注意存储功能有严格的性能要求和请求频率限制，请控制好你的数据操作逻辑",
  FE_39_M_DATANAMEREPEAT: "存在相同的数据表名称",
  FE_39_M_DATANAMESIZE: "数据表名称不得超过12个字符",
  FE_39_M_DATAOFF: "数据存储功能未开启",
  FE_39_M_DATASTORAGEOFF: "存储模组已经关闭",
  FE_39_M_DATASTORAGEON: "存储模组已经打开",
  FE_39_M_DESC: "降序",
  FE_39_M_FUNON: "功能开启",
  FE_39_M_INPUTNAME: "请输入数据表名称",
  FE_39_M_MANAGE: "存档管理",
  FE_39_M_OFF: "关闭",
  FE_39_M_ORDIDATA: "普通数据表",
  FE_39_M_RANKDATA: "排行数据表",
  FE_39_M_RANKING: "排名",
  FE_39_M_RANKSHEETTIPS: "可以建立排行数据表，表内数据自动排序",
  FE_39_M_SHEETTIPS: "可以建立普通数据表，存储任意数据信息",
  FE_39_M_STATUS: "功能状态",
  FE_39_M_TABLENULL: "当前数据表为空",
  FE_39_M_TABLESET: "数据表设置",
  FE_39_SP_ENUM01: "枚举设置",
  FE_39_SP_ENUM02: "设置自定义枚举",
  FE_39_SP_ENUM03: "枚举管理器",
  FE_39_SP_ENUM04: "自定义枚举",
  FE_39_SP_ENUM05: "官方枚举",
  FE_39_SP_ENUM06: "数据类型",
  FE_39_SP_ENUM07: "枚举内容",
  FE_39_SP_ENUM08: "创建副本",
  FE_39_V_ALIGN_STYLE: "对齐方式",
  FE_39_V_BUTTON_DOUBLE_CLICK: "按钮双击",
  FE_39_V_BUTTON_DOUBLE_CLICK_DESC: "在双击实体后执行",
  FE_39_V_BUTTON_PRESS: "按钮按下",
  FE_39_V_BUTTON_PRESS_DESC: "在按下实体后执行",
  FE_39_V_BUTTON_RELEASE: "按钮释放",
  FE_39_V_BUTTON_RELEASE_DESC: "在实体抬起后执行",
  FE_39_V_INPUT_TEXT_ACTIVE: "激活文本内容",
  FE_39_V_INPUT_TEXT_DEFAULT: "占位文本内容",
  FE_39_V_PATH_COPY: "复制控件名称/路径",
  FE_39_V_PROFILER_ASSESS: "预测移动端的内存使用占比",
  FE_39_V_PROFILER_CURRENT: "当前",
  FE_39_V_PROFILER_DOWN: "下载",
  FE_39_V_PROFILER_DRAWCALL: "绘制调用",
  FE_39_V_PROFILER_LOG: "查看性能日志",
  FE_39_V_PROFILER_MEMORY: "内存",
  FE_39_V_PROFILER_NET: "网络流量",
  FE_39_V_PROFILER_OTHER: "其他",
  FE_39_V_PROFILER_PEAK: "最大",
  FE_39_V_PROFILER_PRESSURE: "发布压力",
  FE_39_V_PROFILER_PRESSURE_ASSESS: "移动端的预计性能压力",
  FE_39_V_PROFILER_PRESSURE_HIGH: "高",
  FE_39_V_PROFILER_PRESSURE_LOW: "低",
  FE_39_V_PROFILER_PRESSURE_MEDIUM: "中",
  FE_39_V_PROFILER_RENDER: "渲染",
  FE_39_V_PROFILER_TIME_LOAD: "加载时间",
  FE_39_V_PROFILER_TIME_RUN: "运行时间",
  FE_39_V_PROFILER_TIPS: "性能监控窗口",
  FE_39_V_PROFILER_TRIS: "面数",
  FE_39_V_PROFILER_UP: "上传",
  FE_39_V_TERRAIN_BRUSH_RADIUS: "笔刷半径",
  FE_39_V_TERRAIN_BRUSH_SET: "笔刷设置",
  FE_39_V_TERRAIN_BRUSH_SIZE: "笔刷大小",
  FE_39_V_TERRAIN_BRUSH_STRENGTH: "强度",
  FE_39_V_TERRAIN_BUILD: "创建",
  FE_39_V_TERRAIN_BUILD_LIMIT: "当前仅支持创建1块地形",
  FE_39_V_TERRAIN_CHANGE: "替换",
  FE_39_V_TERRAIN_DELETE: "删除",
  FE_39_V_TERRAIN_DRAW: "绘制",
  FE_39_V_TERRAIN_FLAT: "平整",
  FE_39_V_TERRAIN_FLAT_BOTH: "全部",
  FE_39_V_TERRAIN_FLAT_MODE: "平整模式",
  FE_39_V_TERRAIN_FLAT_TARGET: "平整目标",
  FE_39_V_TERRAIN_GENERATE: "生成",
  FE_39_V_TERRAIN_IMPORT: "导入",
  FE_39_V_TERRAIN_LOWER: "降低",
  FE_39_V_TERRAIN_NAME: "地形",
  FE_39_V_TERRAIN_NEW: "新建",
  FE_39_V_TERRAIN_PLANT_BRUSH: "植被刷",
  FE_39_V_TERRAIN_PLANT_CHOOSE: "植被选择",
  FE_39_V_TERRAIN_PLANT_DENSITY: "笔刷密度",
  FE_39_V_TERRAIN_RAISE: "升高",
  FE_39_V_TERRAIN_RANDOM_ANGLE: "随机角度",
  FE_39_V_TERRAIN_SCULPT: "雕刻",
  FE_39_V_TERRAIN_SET: "地形设置",
  FE_39_V_TERRAIN_SIZE: "尺寸",
  FE_39_V_TERRAIN_SMOOTH: "平滑",
  FE_39_V_TERRAIN_TEXTURE: "纹理",
  FE_39_V_TERRAIN_TEXTURE_CHANGE: "替换贴图",
  FE_39_V_TERRAIN_TEXTURE_CHOOSE: "纹理选择",
  FE_39_V_TERRAIN_TEXTURE_COVER_ALL: "全部覆盖",
  FE_39_V_TERRAIN_TEXTURE_DEIETE: "删除贴图",
  FE_39_V_TERRAIN_TEXTURE_IMPORT: "导入贴图",
  FE_39_V_TERRAIN_TEXTURE_LIMIT: "当前仅支持导入4种纹理",
  FE_39_V_TYPO: "文字排版",
  FE_39_XYL_ISTRIGGERHIDE: "隐藏触发器",
  FE_39_XYL_MOVESTRAIGHT1: "直线移动A",
  FE_39_XYL_MOVESTRAIGHT2: "直线移动B",
  FE_39_XYL_TELEPORTTYPE: "自动传送",
  FE_39_ZQ_COLLIDER_ACTIVE: "碰撞盒启用",
  FE_39_ZQ_COLLIDER_BOX: "盒体碰撞盒",
  FE_39_ZQ_COLLIDER_CAPSULE: "胶囊体碰撞盒",
  FE_39_ZQ_COLLIDER_COLLIDER: "碰撞盒",
  FE_39_ZQ_COLLIDER_COLLIDERNUM: "碰撞盒{0}",
  FE_39_ZQ_COLLIDER_EDIT: "编辑碰撞盒",
  FE_39_ZQ_COLLIDER_ERROR: "碰撞盒已损坏，请检查后重试",
  FE_39_ZQ_COLLIDER_MESH: "网格体碰撞盒",
  FE_39_ZQ_COLLIDER_RADIUS: "半径",
  FE_39_ZQ_COLLIDER_SPHERE: "球体碰撞盒",
  FE_39_ZQ_COLLIDER_TRIGGER: "是触发器",
  FE_39_ZQ_COLLIDER_TYPE: "碰撞盒类型",
  FE_39_ZQ_FILETYPE_ALL: "所有文件",
  FE_39_ZQ_FILETYPE_FBX: "FBX文件",
  FE_39_ZQ_FILETYPE_MATERIAL: "材质文件",
  FE_39_ZQ_FILETYPE_SOUND: "音频文件",
  FE_39_ZQ_FILE_OUTPUT: "导出",
  FE_39_ZQ_FILE_UNLEGAL: "非法的文件类型，请检查后重试",
  FE_39_ZQ_IMAGE_ERROR: "图片已损坏",
  FE_39_ZQ_IMAGE_FORMAT: "格式",
  FE_39_ZQ_IMAGE_RESOURCESIZE: "资源大小",
  FE_39_ZQ_IMAGE_ROUTE: "路径",
  FE_39_ZQ_IMAGE_WARNINGRULE: "图片不符合尺寸规则，必须满足为2的整次幂才能正常显示",
  FE_39_ZQ_IMAGE_WARNINGSIZE: "图片尺寸超过限制2048x2048，请调整图片尺寸",
  FE_39_ZQ_INSPECTOR_ACTIVE: "可用性",
  FE_39_ZQ_MATERIAL_BRIGHTNESS: "亮度",
  FE_39_ZQ_MATERIAL_DIFFUSEINTENSITY: "漫射强度",
  FE_39_ZQ_MATERIAL_ERROR: "材质已损坏，请检查后重试",
  FE_39_ZQ_MATERIAL_GLOBALILLUMINATION: "双面全局照明",
  FE_39_ZQ_MATERIAL_GPUINSTANCING: "启动GPU实例化",
  FE_39_ZQ_MATERIAL_LIGHTINGON: "灯光开启",
  FE_39_ZQ_MATERIAL_LOSTQUOTE: "引用丢失",
  FE_39_ZQ_MATERIAL_LOWQUALITY: "低画质",
  FE_39_ZQ_MATERIAL_MAINCOLOR: "主色",
  FE_39_ZQ_MATERIAL_MAINMAP: "主贴图",
  FE_39_ZQ_MATERIAL_MATERIAL: "材质",
  FE_39_ZQ_MATERIAL_NORMALMAP: "法线贴图",
  FE_39_ZQ_MATERIAL_OFFSET: "偏移",
  FE_39_ZQ_MATERIAL_RENDERQUEUE: "渲染器队列",
  FE_39_ZQ_MATERIAL_SHADER: "着色器",
  FE_39_ZQ_MATERIAL_SHININESS: "光泽",
  FE_39_ZQ_MATERIAL_SPECULARCOLOR: "高光色",
  FE_39_ZQ_MATERIAL_SPECULARINTENSITY: "高光强度",
  FE_39_ZQ_MATERIAL_SPECULARMASK: "高光遮罩",
  FE_39_ZQ_MATERIAL_TILING: "平铺",
  FE_39_ZQ_MATH_EQUAL: "等于",
  FE_39_ZQ_MATH_GREATER: "大于",
  FE_39_ZQ_MATH_GREATEREQUAL: "大于等于",
  FE_39_ZQ_MATH_LESS: "小于",
  FE_39_ZQ_MATH_LESSEQUAL: "小于等于",
  FE_39_ZQ_MATH_NOTEQUAL: "不等于",
  FE_39_ZQ_MESH_ERROR: "网格已损坏，请检查后重试",
  FE_39_ZQ_MESH_MESH: "网格",
  FE_39_ZQ_PACKAGE_ERROR: "Package已损坏，请检查后重试",
  FE_39_ZQ_PACKAGE_EXPORTFAIL: "导出失败",
  FE_39_ZQ_PACKAGE_EXPORTSUCCESS: "导出成功",
  FE_39_ZQ_PACKAGE_IMPORTFAIL: "导入失败",
  FE_39_ZQ_PACKAGE_IMPORTSUCCESS: "导入成功",
  FE_39_ZQ_PACKAGE_IMPUTPACKAGE: "导入Package",
  FE_39_ZQ_PACKAGE_INCLUDEDEPENDENCY: "包含依赖项",
  FE_39_ZQ_PACKAGE_LOSTQUOTE: "丢失{0}引用",
  FE_39_ZQ_PACKAGE_NEWID: "有文件ID相同但不同名的文件，继续操作可能导致该文件的引用关系丢失",
  FE_39_ZQ_PACKAGE_OUTPUTPACKAGE: "导出为Package",
  FE_39_ZQ_PACKAGE_WARNING: "此文件和项目中文件ID相同，继续导入将会全部替换目标文件。",
  FE_39_ZQ_PART_CONE: "圆锥体",
  FE_39_ZQ_PART_CUBE: "立方体",
  FE_39_ZQ_PART_CYLINDER: "圆柱体",
  FE_39_ZQ_PART_PART: "几何体",
  FE_39_ZQ_PART_SPHERE: "球体",
  FE_39_ZQ_PART_WEDGE: "楔形",
  FE_39_ZQ_PREFAB_APPLY: "应用",
  FE_39_ZQ_PREFAB_APPLYALL: "应用全部",
  FE_39_ZQ_PREFAB_ERROR: "Prefab错误，请检查后重试",
  FE_39_ZQ_PREFAB_NEWPREFAB: "新建预制体",
  FE_39_ZQ_PREFAB_NOOVERRIDE: "无覆盖内容",
  FE_39_ZQ_PREFAB_OVERRIDE: "覆盖",
  FE_39_ZQ_PREFAB_PREFAB: "预制体",
  FE_39_ZQ_PREFAB_RESTORE: "还原",
  FE_39_ZQ_PREFAB_RESTOREALL: "还原全部",
  FE_39_ZQ_PREFAB_UNPACK: "脱离",
  FE_39_ZQ_PREFAB_UNPACKALL: "脱离所有",
  FE_39_ZQ_RENDER_RENDER: "渲染",
  FE_39_ZQ_SHADER_ALWAYS: "总是",
  FE_39_ZQ_SHADER_COLORMASK: "颜色遮罩",
  FE_39_ZQ_SHADER_CUTOFF: "裁剪",
  FE_39_ZQ_SHADER_FADEFACTOR: "衰减因子",
  FE_39_ZQ_SHADER_NEVER: "从不",
  FE_39_ZQ_SHADER_TINTCOLOR: "色彩",
  FE_39_ZQ_VISIBLE_CURRENTLAYER: "所在层级",
  FE_39_ZQ_VISIBLE_DEFAULTLAYER: "默认层级",
  FE_39_ZQ_VISIBLE_LAYER: "层级",
  FE_40A_B_ECA_TIPS1: "本地化key不支持连接",
  FE_40A_B_SETTING_BASIC: "基础设置",
  FE_40A_B_SETTING_BUILD: "生成",
  FE_40A_B_SETTING_BUILDAIM: "生成目的",
  FE_40A_B_SETTING_BUILDSETTING: "生成设置",
  FE_40A_B_SETTING_CAMERA_INDENTATION: "摄像头缩进",
  FE_40A_B_SETTING_CAMERA_ROTATE: "摄像头旋转",
  FE_40A_B_SETTING_CAMERA_TRANSLATE: "摄像头平移",
  FE_40A_B_SETTING_COMMON: "通用操作",
  FE_40A_B_SETTING_COMMONBUILD: "常规生成",
  FE_40A_B_SETTING_DOWN10PX: "下移动10px",
  FE_40A_B_SETTING_DOWN1PX: "下移动1px",
  FE_40A_B_SETTING_EDITORSWITCH: "编辑器切换",
  FE_40A_B_SETTING_FOCUS: "聚焦",
  FE_40A_B_SETTING_LEFT10PX: "左移动10px",
  FE_40A_B_SETTING_LEFT1PX: "左移动1px",
  FE_40A_B_SETTING_LEFTMOUSE: "鼠标左键",
  FE_40A_B_SETTING_LOG: "打印LOG",
  FE_40A_B_SETTING_MANY: "多个多选对象",
  FE_40A_B_SETTING_MIDMOUSE: "鼠标中键",
  FE_40A_B_SETTING_MIDMOUSE_HOLD: "按住鼠标中键",
  FE_40A_B_SETTING_PREFERENCES: "偏好设置",
  FE_40A_B_SETTING_PROJECT: "工程操作",
  FE_40A_B_SETTING_RIGHT10PX: "右移动10px",
  FE_40A_B_SETTING_RIGHT1PX: "右移动1px",
  FE_40A_B_SETTING_RIGHTMOUSE: "鼠标右键",
  FE_40A_B_SETTING_SCENE_ROAMING: "场景漫游",
  FE_40A_B_SETTING_SHORTCUTKEYS: "快捷键",
  FE_40A_B_SETTING_SINGLE: "单个多选对象",
  FE_40A_B_SETTING_UP10PX: "上移动10px",
  FE_40A_B_SETTING_UP1PX: "上移动1px",
  FE_40A_B_SETTING_WEBBUILD: "pre-package，用于给Web工具组上传发布",
  FE_40A_HJ_DEBUG_NETWORKDELAY: "延迟：",
  FE_40A_HJ_DEBUG_PACKETLOSS: "丢包率：",
  FE_40A_V_ECA_CLEAR_HISTORY: "清空历史",
  FE_40A_V_ECA_COPY_SINGLE: "复制单行",
  FE_40A_V_ECA_DELETE_MULTIPLE: "删除多行",
  FE_40A_V_ECA_NO_HISTORY: "暂无搜索历史",
  FE_40A_XYL_COLORFULCUBE: "染色方块",
  FE_40A_XYL_REFCUBE: "镜面方块",
  FE_40A_XYL_TOYCUBE: "乐园方块",
  FE_40A_ZQ_BATCH_BATCH_STATIC: "静态",
  FE_40A_ZQ_BATCH_BUTTON_SETTING: "前往项目设置",
  FE_40A_ZQ_BATCH_CONSOLE_SCRIPT: "当前节点{0}的ECA脚本文件{1}将不能正常应用，请注意是否保持当前状态。",
  FE_40A_ZQ_BATCH_TIPS_BADINHERIT: "渲染性能优化错误，该对象暂不支持合批或合并模型功能。",
  FE_40A_ZQ_BATCH_TIPS_COLLIDER: "已开启静态属性，该属性将不再生效，且将自动切换为默认碰撞。",
  FE_40A_ZQ_BATCH_TIPS_INHERIT: "继承静态属性",
  FE_40A_ZQ_BATCH_TIPS_INSPECTOR: "已开启静态属性，该属性将不再生效。",
  FE_40A_ZQ_BATCH_TIPS_INVALID: "静态合批启用，以下部分属性可能因此失效。",
  FE_40A_ZQ_BATCH_TIPS_STATICBATCHING: "启用静态合批后，将会使应用的对象的大部分逻辑失效。",
  FE_40A_ZQ_BATCH_TIPS_UNAVAILABLE: "官方物件的自身逻辑仍然生效。",
  FE_40A_ZQ_SETTINGS_GOTOSETTINGS: "去设置...",
  FE_40A_ZQ_SETTINGS_INPUTTIPS: "在此处输入",
  FE_40_B_DATA_SEARCH_ACCOUNTID: "搜索玩家账号",
  FE_40_B_DATA_SEARCH_KEY: "搜索key",
  FE_40_B_DATA_SEARCH_VALUE: "搜索value",
  FE_40_B_DATA_TIPS1: "当前数据表暂不支持编辑，请发布地图后重试",
  FE_40_B_DATA_TIPS2: "此类型数据暂不支持编辑",
  FE_40_B_DATA_TIPS3: "普通数据表的搜索必须同时指定玩家账号和key",
  FE_40_B_DATA_TIPS4: "是否保存之前的编辑",
  FE_40_B_DATA_TIPS5: "尚有编辑未保存",
  FE_40_B_ECA_MISSING: "ECA脚本丢失",
  FE_40_B_LOGIN_TIPS1: "你现在使用的是游客帐号，请先登录Craftland Studio帐号",
  FE_40_B_RECONNECT_OFF: "关闭断线重连",
  FE_40_B_SCRIPT: "脚本",
  FE_40_B_SCRIPT_MISSING: "代码脚本丢失",
  FE_40_B_TERRAIN_TIPS1: "此地形块支持贴图已达上限4种",
  FE_40_B_VERSION_TIPS1: `发现不兼容的版本（编辑器版本：{0}，项目版本：{1}）
是否继续？`,
  FE_40_JH_AVALTOKENID: "生效的TokenID",
  FE_40_JH_DISPLAYLABEL: "展示标签",
  FE_40_JH_DISPLAYLABELDESC: "展示在FreeFire游戏中的标签",
  FE_40_JH_DISPLAYLABELMAX: "展示标签已达数量上限",
  FE_40_JH_GAMETYPEDESC: "为该地图选择合适的游戏类型",
  FE_40_JH_GAMETYPENAME: "游戏类型",
  FE_40_JH_GETTOKENID: "TokenID",
  FE_40_JH_HIDETAGLIMIT: "选择的游戏类型总数已达到上限",
  FE_40_JH_NUM: "数量",
  FE_40_JH_TOKENALIVE: "设置对局内生效的Token",
  FE_40_JH_TOKENGET: "需要带入对局中的Token",
  FE_40_JH_TOKENSET: "Token设置",
  FE_40_JH_TOKENSET1: "是否启用Token相关功能",
  FE_40_JH_TOKENSET2: "是否将局外Token带入局内",
  FE_40_JH_TOKENSETERROR: "可拾取Token功能未开启",
  FE_40_JH_TOKENSETNAME: "Token设置",
  FE_40_M_UPDATELOG: "更新日志",
  FE_40_SD_EMPTYWARNING: "当前父节点不为空，请注意是否继续使用",
  FE_40_SD_FIND_IN_SCENE: "查找场景中的引用",
  FE_40_SD_FIND_IN_UI: "查找UI中的引用",
  FE_40_SD_FIND_IN_WORKFLOW: "查找流程中的引用",
  FE_40_SD_NOTE: "注释",
  FE_40_SD_NOT_FIND: "未发现引用",
  FE_40_V_UI_COLUMN_LIMIT: "限制列数",
  FE_40_V_UI_PANEL_CONSTRAINNOTCLIP: "约束拖拽但不剪辑",
  FE_40_V_UI_PANEL_MASK: "纹理遮罩",
  FE_40_V_UI_PANEL_SOFTCLIP: "柔化剪辑",
  FE_40_V_UI_ROW_LIMIT: "限制行数",
  FE_40_V_UI_SCROLLBAR: "滚动条",
  FE_40_V_UI_SCROLLBAR_DRAGGING: "拖动显示",
  FE_40_V_UI_SCROLLBAR_SHOW: "总是显示",
  FE_40_V_UI_SCROLLVIEW: "滚动视图",
  FE_40_V_UI_SCROLLVIEW_DIRECTION_UNRESTRAINED: "自由拖动",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUM: "惯性拖动",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUMNSPRING: "惯性和弹性拖动",
  FE_40_XXJ_CLOTHESTYPE: "服装类型",
  FE_40_XXJ_ISEXPORT: "是否导出",
  FE_40_XXJ_PARENTERROR: "设置父节点失败",
  FE_40_XXJ_WEASKINSTYPE: "枪皮类型",
  FE_40_XYL_CUSTOMMINIMAP: "自定义小地图",
  FE_40_XYL_NOCUSTOMMINIMAP: "自定义小地图未开启",
  FE_40_ZQ_COMPONENT_CUSTOMOBJECT: "自定义物件",
  FE_40_ZQ_COMPONENT_CUSTOMRENDER: "自定义渲染组件",
  FE_40_ZQ_GAME_EXITCONFIRM: "确认退出该游戏吗？",
  FE_40_ZQ_GAME_EXITOPTION: "允许中途退出",
  FE_40_ZQ_GAME_KICKOUT: "您已长时间未操作，已退回大厅。",
  FE_40_ZQ_GAME_KICKOUTTIME: "挂机判断时间（单位：分钟）",
  FE_40_ZQ_GAME_TIPS: "提示",
  FE_40_ZQ_LD_LDTIPS: `已将Assetbundle放入LD目录！
配置mapinfos.csv后，请点击此处【刷新】，不然需要重新打开项目刷新。`,
  FE_41A_B_RENAME_TIPS1: "不可使用{0}字符",
  FE_41A_B_RENAME_TIPS2: "字符数限制{0}",
  FE_41A_B_RENAME_TIPS3: "名称不符合规范，修改失败",
  FE_41A_B_RENAME_TIPS4: "名称不能为空，修改失败",
  FE_41A_B_RENAME_TIPS5: "游戏名称字符长度应为{0}至{1}",
  FE_41A_M_FEEDBACK: "您的建议很重要！",
  FE_41B_HZY_CHECK_TIPS: "请先勾选同意",
  FE_41B_HZY_COMPARE_NOTSAME: "左右两侧类型不匹配",
  FE_41B_HZY_CREATE_PARENTLEVEL: "创建空父节点",
  FE_41B_HZY_PRIVACY_POLICY: "我已阅读并同意[服务条款](https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html)和[隐私政策](https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html)",
  FE_41B_HZY_PROJECT_FAVORITE_TIPS: "收藏搜索词",
  FE_41B_M_DEFAULTVALUE: "默认值",
  FE_41B_M_RANGE: "取值范围",
  FE_41_B_CONSOLE_TIPS1: "双击查看报错",
  FE_41_B_DATA_ACCUMULATED_SHEET: "统计数据表",
  FE_41_B_DATA_CLEAR_AWARD: "清空时发奖",
  FE_41_B_DATA_CLEAR_CYCLE: "周期清空",
  FE_41_B_DATA_CLEAR_CYCLE_INTERVAL: "周期间隔",
  FE_41_B_DATA_CLEAR_SETTING: "清空设置",
  FE_41_B_DATA_CLEAR_SHEET: "清空数据表",
  FE_41_B_DATA_CLEAR_TIME: "清空时间",
  FE_41_B_DATA_CLEAR_TIMING: "定时清空",
  FE_41_B_DATA_CLEAR_TIPS1: "清零这条数据，不可撤销，是否确认？",
  FE_41_B_DATA_CLEAR_TIPS2: "清零表内数据，不可撤销，是否确认？",
  FE_41_B_DATA_DAY: "天",
  FE_41_B_DATA_HOUR: "小时",
  FE_41_B_DATA_KEY_MANAGE: "key管理",
  FE_41_B_DATA_NOTOPEN: "不开启",
  FE_41_B_DATA_TIMEZONE: "时区",
  FE_41_B_DATA_TIPS1: "统计数据表内key总数目已达上限",
  FE_41_B_DATA_TIPS2: "可以建立统计数据表，表内数据由后台累加不易丢失",
  FE_41_B_DATA_TIPS3: "已添加至发奖梯度数量上限",
  FE_41_B_DATA_TIPS4: "清空时间需晚于当前时间",
  FE_41_B_DATA_WEEK: "周",
  FE_41_B_ECA_LISTTANY: "任意列表",
  FE_41_B_LABEL_COPY: "复制脚本名",
  FE_41_B_LABEL_EDIT: "修改脚本名",
  FE_41_B_LABEL_FUNCTION: "图元函数",
  FE_41_B_LABEL_FUNCTION_PARA: "图元函数参数",
  FE_41_B_LABEL_SCRIPTNAME: "脚本名",
  FE_41_B_LABEL_TIPS1: "脚本名只能由字母、数字、下划线组成，且第一位不能是数字",
  FE_41_B_LABEL_TIPS2: "脚本名已被占用",
  FE_41_B_LABEL_TIPS3: "脚本名不能为内置关键字",
  FE_41_B_LABEL_TIPS4: "编译失败",
  FE_41_B_LABEL_VARIBLE: "图元变量",
  FE_41_HJ_AC_STATENOTEXIST: "动画控制器中不存在状态{0}",
  FE_41_HZY_FILE_TERRAIN: "Terrain 文件",
  FE_41_HZY_POINT_CONTEXTLIST: "上下文列表",
  FE_41_HZY_POINT_ID: "编号",
  FE_41_HZY_POINT_LIST: "断点列表",
  FE_41_HZY_POINT_VALUE: "值",
  FE_41_HZY_SEARCH_NO_FILE: "未找到对应文件",
  FE_41_JH_AI_SELFIMPORTERROR: "错误：不能重复导入当前工程文件中的自定义节点",
  FE_41_JH_BT_ACTIONNODE: "Action",
  FE_41_JH_BT_BEEDITOR: "AI编辑器",
  FE_41_JH_BT_BTNAME: "行为树",
  FE_41_JH_BT_COMPOSITE: "Composite",
  FE_41_JH_BT_CONDITIONNODE: "Conditon",
  FE_41_JH_BT_CREATENODE: "创建节点",
  FE_41_JH_BT_DECORATORNODE: "Decorator",
  FE_41_JH_BT_EDITNODE: "编辑节点",
  FE_41_JH_BT_NODENAME: "节点名称",
  FE_41_JH_BT_NODENAMETIP: "节点名称不能为空",
  FE_41_JH_BT_NODES: "节点",
  FE_41_JH_BT_NODESCRIPT: "节点脚本",
  FE_41_JH_BT_NODESX: "节点变量",
  FE_41_JH_BT_NODETYPE: "节点类型",
  FE_41_JH_BT_NODEVARNUM: "变量值",
  FE_41_JH_BT_NODEVARTYPE: "节点变量类型",
  FE_41_JH_BT_ROOTNODE: "根节点",
  FE_41_JH_HACK_ANTIHACKCONTROL: "是否开启防作弊功能",
  FE_41_SD_LOGICFRAME_SETTING: "低逻辑帧模式（30降至15）",
  FE_41_V_PROJECT_ANIM: "动画",
  FE_41_V_PROJECT_CSV: "CSV 文件",
  FE_41_V_PROJECT_ECATEMP: "ECA 模板",
  FE_41_V_PROJECT_UITEMP: "UI 模板",
  FE_41_V_PROJECT_XBT: "行为树文件",
  FE_41_V_PROJECT_XBTTEMP: "XBT 模板",
  FE_41_V_UI_CONTAINER: "3D内容装载器",
  FE_41_V_UI_CONTAINER_EFFECT: "特效",
  FE_41_V_UI_CONTAINER_MESH: "模型",
  FE_41_V_UI_PANEL_TIPS: "该类始终被置于UI层级的最上层",
  FE_41_V_UI_PANEL_TYPE: "Panel类",
  FE_41_V_UI_PROFILE: "头像",
  FE_41_V_UI_PROFILE_NICKNAME: "玩家昵称",
  FE_41_V_UI_PROFILE_PIN: "纪念章",
  FE_41_V_UI_PROFILE_PRANKED_TYPE: "段位类型",
  FE_41_V_UI_PROFILE_RANKED: "段位",
  FE_41_V_UI_PROFILE_TYPE_ONE: "类型一",
  FE_41_V_UI_PROFILE_TYPE_TWO: "类型二",
  FE_41_V_UI_TEXTURE: "贴图",
  FE_41_V_UI_TEXTURE_CENTER_INVISIBLE: "中心不可见",
  FE_41_V_UI_TEXTURE_FILLED: "填充",
  FE_41_V_UI_TEXTURE_FILL_AMOUNT: "填充量",
  FE_41_V_UI_TEXTURE_FILL_DIR: "填充方向",
  FE_41_V_UI_TEXTURE_FILL_HOR: "水平填充",
  FE_41_V_UI_TEXTURE_FILL_INVERT: "填充翻转",
  FE_41_V_UI_TEXTURE_FILL_RADIAL: "径向填充",
  FE_41_V_UI_TEXTURE_FILL_VER: "垂直填充",
  FE_41_V_UI_TEXTURE_FIT: "自适应",
  FE_41_V_UI_TEXTURE_GRADIENT: "渐变",
  FE_41_V_UI_TEXTURE_GRADIENT_DIR: "方向",
  FE_41_V_UI_TEXTURE_SIMPLE: "简单",
  FE_41_V_UI_TEXTURE_TILED: "平铺",
  FE_41_V_UI_TEXTURE_TILED_TRIM: "裁剪",
  FE_41_V_UI_WIDGET_TYPE: "Widget类",
  FE_41_XYL_IMPORT_NOTICE001: "该功能不支持Craftland Studio的战场码导入",
  FE_41_XYL_IMPORT_NOTICE002: "战场码已过期，无法导入",
  FE_41_XYL_INPUTMAP: "线上地图",
  FE_41_XYL_NAVMESH: "静态导航网格",
  FE_41_XYL_NAVMESHTIPS: "勾选此项的物件只会在开局生成静态的导航网格",
  FE_41_XYL_PREFABGENERATOR: "模板（Prefab）",
  FE_41_ZQ_AC_ANIMCONTROLLER: "动画控制器",
  FE_41_ZQ_AC_ANIMEDITOR: "动画",
  FE_41_ZQ_AC_CLIP: "片段",
  FE_41_ZQ_AC_CLIPNO: "片段数量",
  FE_41_ZQ_AC_LOOP: "循环",
  FE_41_ZQ_AC_LOOPTIPS: "上一片段开启循环，此后片段将不会自动播放。",
  FE_41_ZQ_AC_NEWCLIP: "新建动画片段",
  FE_41_ZQ_AC_NEWSTATE: "新建状态",
  FE_41_ZQ_AC_NOCLIP: "未挂载动画片段",
  FE_41_ZQ_AC_PLAYSPEED: "播放速度",
  FE_41_ZQ_AC_STATE: "状态",
  FE_41_ZQ_ANIM_LENGTH: "长度",
  FE_41_ZQ_BUILD_DYNAMIC: "动态加载",
  FE_41_ZQ_BUILD_DYNAMIC_TIP: "启用此选项，该资源将在玩家进入游戏后才开始加载。",
  FE_41_ZQ_BUILD_FILE: "手动选择打包记录",
  FE_41_ZQ_BUILD_LAUNCH: "游戏已提交审核，本次打包记录已生成。请在“数据中心”关注审核状态，审核通过后会为您自动发布游戏。",
  FE_41_ZQ_BUILD_PACKAGERULE: "打包规则",
  FE_41_ZQ_BUILD_REPACKAGE: "原生打包方式",
  FE_41_ZQ_OPEN_PACKAGE_HISTORY: "打开记录目录",
  FE_41_ZQ_PACKAGE_RECORD: "打包记录",
  FE_42A_HJ_HUD_COMMONHUDSWITCH: "局内通用按钮",
  FE_42A_HJ_HUD_COUNTDOWN: "阶段倒计时",
  FE_42A_HJ_HUD_COUNTDOWNREMIND: "计时提示",
  FE_42A_HJ_HUD_FACTIONINFO: "阵营信息",
  FE_42A_HJ_HUD_FIVECOUNTDOWN: "5秒倒计时",
  FE_42A_HJ_HUD_MATCHINFO: "比赛子标题",
  FE_42A_HJ_HUD_MATCHINFOSIMPLE: "两队比赛信息简版",
  FE_42A_HJ_HUD_ROUNDRESULT: "回合结束横幅",
  FE_42A_HJ_HUD_ROUNDTRANSITION: "回合开始横幅",
  FE_42A_HJ_HUD_TITLEBANNER: "标题横幅",
  FE_42A_HJ_HUD_TWOTEAMMATCHINFO: "两队比分",
  FE_42A_HJ_HUD_TWOTEAMSCORE: "两队回合开始",
  FE_42A_HJ_HUD_TWOTEAMSTART: "两队对抗横幅",
  FE_42A_HJ_HUD_TYPE: "内置HUD",
  FE_42A_HZY_ECAMOUNT_TIP: "该实体上不存在以下组件类型，可能会导致部分代码不生效：{0}",
  FE_42A_HZY_WS_FUNCTIONCALL_D: `等待：串行调用。
执行：并行调用。`,
  FE_42A_HZY_WS_LOCALVAR_D: "定义并初始化一个局部变量",
  FE_42A_XYL_LOOTSWITCH: "启用地图默认战利品刷新点",
  FE_42A_ZQ_ASSET_PICCONTROL: "{0}超过2048x2048，请修改后重新导入。",
  FE_42A_ZQ_ASSET_PICREDUCE: "原文件过大，已按原比例压缩在2048以内。",
  FE_42A_ZQ_ASSET_SIZECONTROL: "{0}超过限制大小，请修改后重新导入。",
  FE_42A_ZQ_ASSET_SOUNDCONTROL: "{0} fmod超过10,000,000，请修改后重新导入。",
  FE_42A_ZQ_BATCH_OFFLINE: "离线合批",
  FE_42A_ZQ_BATCH_OFFLINETIPS: "导出时进行静态合批，可能会导致玩家下载额外的资源。",
  FE_42A_ZQ_BATCH_RUNNING: "运行时合批",
  FE_42A_ZQ_BATCH_RUNNINGTIPS: "运行时进行静态合批，不会生成新的资源。",
  FE_42A_ZQ_EFRAME_ADD: "添加事件帧",
  FE_42A_ZQ_EFRAME_COPY: "复制事件帧",
  FE_42A_ZQ_EFRAME_DTL: "删除事件帧",
  FE_42A_ZQ_EFRAME_PASTE: "粘贴事件帧",
  FE_42A_ZQ_EFRAME_SLT: "选择事件帧",
  FE_42A_ZQ_MESH_FACECONTROL: "{0}网格面数超过3万面，请减面后重新导入。",
  FE_42A_ZQ_PCK_ROOT: "选择根目录",
  FE_42A_ZQ_PCK_ROOTERROR: "无效路径",
  FE_42A_ZQ_P_OPENING: "正在打开...",
  FE_42A_ZQ_P_RUNNING: "项目运行中",
  FE_42A_ZQ_P_RUNNINGV: "项目运行中：{0}",
  FE_42A_ZQ_WEB_LAUNCH: "去发布",
  FE_42A_ZQ_WEB_LAUNCHERROR: "发布失败，请稍后重试。",
  FE_42A_ZQ_WEB_LAUNCHSUC: "已上传至【创作者官网】，请前往【创作者中心】进行发布。",
  FE_42_B_ECA_NORMAL: "普通ECA",
  FE_42_B_ECA_STATIC: "静态ECA",
  FE_42_B_SCRIPT_ECARELATED: "ECA依赖项",
  FE_42_B_SCRIPT_EXPORTPACKAGE: "导出",
  FE_42_B_SCRIPT_QUICKNAME: "快捷脚本名命名",
  FE_42_B_SCRIPT_TIPS1: "请选择需导出模组，当前名与脚本名重复的部分将会自动跳过",
  FE_42_B_SCRIPT_TIPS10: "自动全选并运行",
  FE_42_B_SCRIPT_TIPS2: "包含自定义组件名和自定义属性名",
  FE_42_B_SCRIPT_TIPS3: "包含自定义枚举名和自定义枚举属性名",
  FE_42_B_SCRIPT_TIPS4: "包含自定义事件名",
  FE_42_B_SCRIPT_TIPS5: "包含ECA文件名、变量名、函数名和函数返回值",
  FE_42_B_SCRIPT_TIPS6: "已完成快捷脚本名命名，共成功命名脚本{0}条，失败{1}条，请查看报错信息",
  FE_42_B_SCRIPT_TIPS7: "脚本名命名：{0}不符合规范，命名失败",
  FE_42_B_SCRIPT_TIPS8: "脚本名命名：{0}与其他命名重复，命名失败",
  FE_42_B_SCRIPT_TIPS9: "脚本名命名：{0}与内置关键字重复，命名失败",
  FE_42_HJ_API_INTERNAL: "内部版图元",
  FE_42_HJ_API_TEST: "测试版图元",
  FE_42_HJ_BLOCKDESCINTERNAL: "内部版图元",
  FE_42_HJ_BLOCKDESCTEST: "测试版图元",
  FE_42_HJ_DEBUG_ENTITYNUM: "实体数量",
  FE_42_HJ_DEBUG_ENTITYPROPNUM: "实体同步数量",
  FE_42_HJ_DEBUG_LOGICDEBUG: "逻辑调试",
  FE_42_HJ_DEBUG_NETWORKDOWNLOAD: "网络流量（下载）",
  FE_42_HJ_DEBUG_NETWORKUPLOAD: "网络流量（上传）",
  FE_42_HJ_DEBUG_SCENERYDEBUG: "场景调试",
  FE_42_HJ_DEBUG_WATCHLIST: "监视列表",
  FE_42_HJ_VFX_BLACKHOLE: "黑洞",
  FE_42_HJ_VFX_BLACKHOLEEXPLOSION: "黑洞爆炸",
  FE_42_HJ_VFX_CRYSTALBALL: "水晶球",
  FE_42_HJ_VFX_INK: "水墨",
  FE_42_HJ_VFX_SPLASH: "水花",
  FE_42_HZY_SEARCH_BLOCK: "全局图元搜索",
  FE_42_HZY_SEARCH_BLOCKNAME: "以该图元名称进行搜索",
  FE_42_HZY_SEARCH_GLOBAL: "查找全局中的引用",
  FE_42_HZY_SEARCH_TIPS: "请输入，按回车进行搜索",
  FE_42_HZY_TERRAIN_DELETE_TIPS: `选中植被刷进行绘制
选中植被刷+Shift：擦除范围内全部植被
选中植被刷+Ctrl：仅擦除当前所选植被`,
  FE_42_HZY_TIP_DELETE_SLOT: "该槽位地图已过期不能发布，请前往Free Fire Craftland进行删除",
  FE_42_JH_AIEDITOR_ACTIONFUNCNAME: "执行行为",
  FE_42_JH_AIEDITOR_TICKFUNCNAME: "Tick",
  FE_42_JH_AI_ADDTONEWNODE: "复制成新节点",
  FE_42_JH_AI_CLEAREDITOR: "清空",
  FE_42_JH_AI_DELETEINPUT: "删除节点输入",
  FE_42_JH_AI_DELETENODE: "删除自定义节点",
  FE_42_JH_AI_DELETEOUTPUT: "删除节点输出",
  FE_42_JH_AI_DRWAERROR: "画布未初始化",
  FE_42_JH_AI_FILELOADER: "文件加载错误",
  FE_42_JH_AI_NODEID: "节点ID",
  FE_42_JH_AI_NOROOTNODE: "请先创建根节点",
  FE_42_JH_AI_SETUP: "节点基本信息",
  FE_42_JH_ECANAME1: "行为树-执行行为",
  FE_42_JH_ECANAME2: "行为树-条件判断",
  FE_42_JH_SCODE_ERROR1: "该短号战场码位数不符合要求",
  FE_42_JH_SCODE_ERROR2: "在此填写该地图的短号战场码，必须为6位。仅支持输入大写字母和数字",
  FE_42_JH_SCODE_ERROR3: "该短号战场码已被占用",
  FE_42_JH_SCODE_ERROR5: "你可以输入6位数字或大写字母来生成该地图的短号战场码。短号战场码会取代原有的战场码",
  FE_42_JH_SCODE_ERROR6: "该地图已配置短号战场码，不可修改",
  FE_42_JH_SCODE_RANDOMSCODE: "随机生成",
  FE_42_JH_SCODE_SCODENAME: "短号战场码",
  FE_42_JH_WS_CUSTOMNODEDESC: "节点描述",
  FE_42_JH_WS_DELETECUSTOMNODE: "删除节点",
  FE_42_JH_WS_DELETENODEPANEL: "请确认是否要清空画布",
  FE_42_JH_WS_EXSEQUENCE: "顺序执行所有链接的子节点，当所有子节点均返回true时，该节点返回true。否则均返回false",
  FE_42_JH_WS_EXWAIT: "等待指定的时间，可以在设置的等待时间之后触发下一行为",
  FE_42_JH_WS_INVERTER: "对子节点的执行结果取相反值",
  FE_42_JH_WS_MAXS: "限制子节点的最大执行时长为设置的时长",
  FE_42_JH_WS_MENPRIORITY: "功能与Priority节点相同，但会存档子节点执行情况，下一次执行该节点时从存档执行",
  FE_42_JH_WS_MENSEQUENCE: "功能与sequence节点相同，但会存档子节点执行情况，下一次执行该节点时从存档执行",
  FE_42_JH_WS_PRIORITY: "顺序执行所有链接的子节点，当任一子节点返回true时，该节点返回true。否则该节点返回false",
  FE_42_JH_WS_REPEATX: "重复执行子节点，直到达到设置的执行次数",
  FE_42_JH_WS_REPETFAIL: "重复执行子节点，直到返回值为false",
  FE_42_JH_WS_REPETSUCC: "重复执行子节点，直到返回值为true",
  FE_42_M_BOMBER: "炸弹人",
  FE_42_M_ShutdownDelay: "服务器关闭延迟时间",
  FE_42_M_StartTimeout: "服务器启动超时时间",
  FE_42_SD_FCG_VSIX_INSTALL: "缺少IDE开发环境，是否安装VSCode作为IDE？",
  FE_42_V_ACTION_ABOARD: "上车",
  FE_42_V_ACTION_ABOARD_DRIVER: "作为司机上车",
  FE_42_V_ACTION_ABOARD_OFF: "上/下车",
  FE_42_V_ACTION_ABOARD_PASSENGER: "作为乘客上车",
  FE_42_V_ACTION_BACK: "向后移动",
  FE_42_V_ACTION_CROUCH: "下蹲",
  FE_42_V_ACTION_DIVE: "空中俯冲",
  FE_42_V_ACTION_FIRE: "开火",
  FE_42_V_ACTION_FORWARD: "向前移动",
  FE_42_V_ACTION_GRENADE: "发射榴弹",
  FE_42_V_ACTION_HUD_HIDE: "隐藏UI",
  FE_42_V_ACTION_INTERACT: "局内交互",
  FE_42_V_ACTION_JUMP: "跳跃",
  FE_42_V_ACTION_LEFT: "向左移动",
  FE_42_V_ACTION_MOUSE_LOCKED: "锁定鼠标",
  FE_42_V_ACTION_MOVE: "移动",
  FE_42_V_ACTION_OFF: "下车",
  FE_42_V_ACTION_PICKUP: "拾取",
  FE_42_V_ACTION_PRONE: "俯卧",
  FE_42_V_ACTION_QUICK_SWITCH: "快速切换武器",
  FE_42_V_ACTION_RELOAD: "换弹",
  FE_42_V_ACTION_RIGHT: "向右移动",
  FE_42_V_ACTION_RUN: "奔跑",
  FE_42_V_ACTION_SKILL: "角色技能",
  FE_42_V_ACTION_SWITCH: "切换武器",
  FE_42_V_ACTION_ZOOM: "开镜",
  FE_42_V_INPUT_ACTION: "映射操作",
  FE_42_V_INPUT_CLICK: "点击",
  FE_42_V_INPUT_DOUBLE_CLICK: "双击",
  FE_42_V_INPUT_DOWN: "按住",
  FE_42_V_INPUT_KEY: "输入键位",
  FE_42_V_INPUT_KEYBOARD: "键盘",
  FE_42_V_INPUT_LIST: "映射列表",
  FE_42_V_INPUT_MODE: "输入手势",
  FE_42_V_INPUT_MOUSE: "鼠标",
  FE_42_V_INPUT_NUM: "映射数量",
  FE_42_V_INPUT_PRESS: "按下",
  FE_42_V_INPUT_RELEASE: "释放",
  FE_42_V_INPUT_SYSTEM: "输入设置",
  FE_42_V_INPUT_SYSTEM_TIPS: "配置映射前请先将当前工作区内容保存为UI文件",
  FE_42_XXJ_FILEMISSING: "文件资源丢失",
  FE_42_XXJ_INVAR: "输入值",
  FE_42_XXJ_NORETURN: "无返回值错误",
  FE_42_XXJ_OUTVAR: "输出值",
  FE_42_ZQ_ANIM_ADDANIMEVENT: "添加动画事件",
  FE_42_ZQ_ANIM_ANIMEVENT: "动画事件",
  FE_42_ZQ_ANIM_ANIMTIPS: "双击动画文件或将动画文件拖入可打开。",
  FE_42_ZQ_ANIM_CANNOTEDIT: "该类型事件不可修改",
  FE_42_ZQ_ANIM_COPYANIMEVENT: "复制动画事件",
  FE_42_ZQ_ANIM_DELETEANIMEVENT: "删除动画事件",
  FE_42_ZQ_ANIM_DURATION: "持续",
  FE_42_ZQ_ANIM_EFRAME: "事件帧",
  FE_42_ZQ_ANIM_EVENTNUM: "动画事件{0}",
  FE_42_ZQ_ANIM_EVENTSELECT: "事件选择",
  FE_42_ZQ_ANIM_FRAME: "帧",
  FE_42_ZQ_ANIM_MODELTIPS: "没有可预览的模型，请拖入一个模型至此区域。",
  FE_42_ZQ_ANIM_NOANIMEVENT: "无动画事件",
  FE_42_ZQ_ANIM_PARANUM: "参数{0}",
  FE_42_ZQ_ANIM_PASTEANIMEVENT: "粘贴动画事件",
  FE_42_ZQ_ANIM_TIME: "时间",
  FE_42_ZQ_ASSET_CANNOTEDIT: "引用资源，不可编辑",
  FE_42_ZQ_BATCH_DYNAMICBATCH: "动态合批",
  FE_42_ZQ_BATCH_DYNAMICTIPS: "动态合批后仍然可以创建、销毁、修改位移旋转缩放材质等属性",
  FE_42_ZQ_ECA_TIP_BONE_EDITOR_DIS_SELECT: "当前场景为外观编辑器，不可选择物件。",
  FE_42_ZQ_EVENT_NOTIPICALEVENT: "无指定事件种类",
  FE_42_ZQ_IMPORT_CANCEL: "取消导入",
  FE_42_ZQ_IMPORT_TARGETFILE: "目标文件夹",
  FE_42_ZQ_LOGIN_GOLOGIN: "请先登录",
  FE_42_ZQ_MIPMAP: "是否启用Mipmap",
  FE_42_ZQ_MIPMAP_TIP: "开启Mipmap可能会稍微增加内存和渲染的开销，但会带来更平滑的纹理过渡和更好的细节显示效果。",
  FE_42_ZQ_OPAQUE: "去除透明度",
  FE_42_ZQ_OPAQUE_TIP: "勾选此选项将导致其Alpha通道不会被读取（不影响图集）。",
  FE_42_ZQ_SK_APPEARENCE: "外观",
  FE_42_ZQ_SK_APPEARENCEGROUP: "外观组",
  FE_42_ZQ_SK_BINDMETHOD: "绑定方式",
  FE_42_ZQ_SK_BONESELECT: "骨骼选择",
  FE_42_ZQ_SK_CONNECT: "连接",
  FE_42_ZQ_SK_ENABLE: "启用",
  FE_42_ZQ_SK_GROUP: "互斥组",
  FE_42_ZQ_SK_GROUPCONTROL: "互斥组管理",
  FE_42_ZQ_SK_MUTUALTIPS: "同一互斥组下，改变指定的外观组会使其他外观组失效。",
  FE_42_ZQ_SK_NEWAPPEARENCE: "新建外观",
  FE_42_ZQ_SK_NEWAPPEARENCEGROUP: "新建外观组",
  FE_42_ZQ_SK_NOBONE: "未找到对应骨骼",
  FE_42_ZQ_SK_NORMALMESH: "普通网格",
  FE_42_ZQ_SK_PARENTSK: "父节点骨架",
  FE_42_ZQ_SK_SK: "骨架",
  FE_42_ZQ_SK_SKINFO: "骨骼信息",
  FE_42_ZQ_SK_SKINNED: "蒙皮",
  FE_42_ZQ_SK_SKINNEDMESH: "蒙皮网格",
  FE_42_ZQ_SK_SKSELECT: "骨架选择",
  FE_42_ZQ_SK_WARNING: "{1} not found in {0}",
  FE_42_ZQ_STORE_ADDED: "已添加至资源库",
  FE_42_ZQ_STORE_ADDFILE: "请添加文件",
  FE_42_ZQ_STORE_ASSETS: "资源库",
  FE_42_ZQ_STORE_AUTHOR: "发布者",
  FE_42_ZQ_STORE_BUILDFAIL: "导出失败",
  FE_42_ZQ_STORE_BUILDPCK: "发布资源包",
  FE_42_ZQ_STORE_BUILDPLACE: "资源正在发布中！可前往【我的资源 - 我的发布】查看。",
  FE_42_ZQ_STORE_BUILDSUC: "操作成功！",
  FE_42_ZQ_STORE_BUILDTIPS: "资源生成成功！是否立即前往发布？",
  FE_42_ZQ_STORE_CHANGEFILE: "更换文件",
  FE_42_ZQ_STORE_CHOOSEPCK: "选择下载的资源类型",
  FE_42_ZQ_STORE_CLOSE: "工程正被其它进程占用着，请关闭其它进程后再试。如果已关闭，请稍后再试。",
  FE_42_ZQ_STORE_CURRENT_PROJECT_ONLY: "只能导入正在打开中的项目",
  FE_42_ZQ_STORE_DESCRIPTION: "描述",
  FE_42_ZQ_STORE_DOWNLOAD: "下载资源",
  FE_42_ZQ_STORE_DOWNLOADED: "已下载",
  FE_42_ZQ_STORE_FREE: "免费",
  FE_42_ZQ_STORE_FULLPCK: "完整包",
  FE_42_ZQ_STORE_FULLPCKSUC: "成功通知工程导入整包。",
  FE_42_ZQ_STORE_FULLPCKTIPS: "支持自由编辑，包体更大。",
  FE_42_ZQ_STORE_GET: "获取",
  FE_42_ZQ_STORE_IMPORT: "导入至项目",
  FE_42_ZQ_STORE_MYASSET: "我的资源",
  FE_42_ZQ_STORE_MYUPLOAD: "我的发布",
  FE_42_ZQ_STORE_NAME: "标题",
  FE_42_ZQ_STORE_NOASSET: "未获取任何资源",
  FE_42_ZQ_STORE_NORESULT: "无相关内容，请尝试其他关键词。",
  FE_42_ZQ_STORE_NOTDOWNLOAD: "未下载",
  FE_42_ZQ_STORE_NOTUPLOADED: "未发布",
  FE_42_ZQ_STORE_NOUPLOAD: "未上传任何资源",
  FE_42_ZQ_STORE_OPENPROJECT: "需要打开新项目后导入整包。",
  FE_42_ZQ_STORE_OWNED: "已获取",
  FE_42_ZQ_STORE_PICTIPS: "推荐尺寸为{0}px，大小必须在{1}以内。",
  FE_42_ZQ_STORE_PICWARNING: "文件尺寸超过了{0}。",
  FE_42_ZQ_STORE_PRICE: "售价",
  FE_42_ZQ_STORE_REDOWNLOAD: "重新下载",
  FE_42_ZQ_STORE_RELOAD: "正在替换引用包，需要重新载入项目。",
  FE_42_ZQ_STORE_RENEWAL: "最近更新",
  FE_42_ZQ_STORE_RESNAME: "名称字符长度应为{0}至{1}",
  FE_42_ZQ_STORE_RESPCK: "引用包",
  FE_42_ZQ_STORE_RESPCKSUC: "成功导入引用包。",
  FE_42_ZQ_STORE_RESPCKTIPS: "不支持编辑，包体更小更快。",
  FE_42_ZQ_STORE_SELECTFILE: "选择文件",
  FE_42_ZQ_STORE_SELECTIMPORT: "选择资源",
  FE_42_ZQ_STORE_UPDATE: "点击此处更新资源",
  FE_42_ZQ_STORE_UPDATEANDUPLOAD: "更新并发布",
  FE_42_ZQ_STORE_UPDATECONFIRM: "是否要更新资源包，确认后其他用户将会需要更新资源。",
  FE_42_ZQ_STORE_UPDATEDOWNLOAD: "更新下载",
  FE_42_ZQ_STORE_UPLOAD: "上传",
  FE_42_ZQ_STORE_UPLOADCANCEL: "这将不会保存你所填写的内容，确定取消上传吗？",
  FE_42_ZQ_STORE_UPLOADED: "已发布",
  FE_42_ZQ_STORE_UPLOADING: "发布中",
  FE_43A_HZY_ACCOUNT_BOUNDTIP: "已检测到登录的Free Fire账号，退出绑定流程将清空检测到的Free Fire账号信息！",
  FE_43A_HZY_ACCOUNT_UNBOUND: "未绑定",
  FE_43A_HZY_ERROR_TIP1: "可能无法转换成",
  FE_43A_HZY_ERROR_TIP2: "没有找到",
  FE_43A_HZY_PROJECT_SCREEN: "筛选器",
  FE_43A_HZY_PROJECT_SCREENRESET: "筛选重置",
  FE_43A_HZY_SCENE_ALIGNMENT: "对齐",
  FE_43A_HZY_SCENE_ALIGNMENTSET: "对齐设置",
  FE_43A_HZY_SCENE_ALIGNMENTTIP: "长按Ctrl可快速启用/关闭",
  FE_43A_HZY_SCENE_CAMERASPEED: "调整场景摄像机移动速度",
  FE_43A_HZY_SCENE_OPERATETIP: "操作提示",
  FE_43A_HZY_SCENE_OPERATE_TIP1: "选择/框选",
  FE_43A_HZY_SCENE_OPERATE_TIP10: "取消新建地形",
  FE_43A_HZY_SCENE_OPERATE_TIP11: "取消绘制",
  FE_43A_HZY_SCENE_OPERATE_TIP12: "擦除所选植被",
  FE_43A_HZY_SCENE_OPERATE_TIP13: "擦除全部植被",
  FE_43A_HZY_SCENE_OPERATE_TIP2: "转视角",
  FE_43A_HZY_SCENE_OPERATE_TIP3: "移动/缩放视角",
  FE_43A_HZY_SCENE_OPERATE_TIP4: "快速拖拽物件",
  FE_43A_HZY_SCENE_OPERATE_TIP5: "自由移动",
  FE_43A_HZY_SCENE_OPERATE_TIP6: "上下移动",
  FE_43A_HZY_SCENE_OPERATE_TIP7: "加速移动",
  FE_43A_HZY_SCENE_OPERATE_TIP8: "摆放物件",
  FE_43A_HZY_SCENE_OPERATE_TIP9: "退出摆放",
  FE_43A_M_TASKS: "平台任务设置",
  FE_43A_M_TASKS2: "任务设置",
  FE_43A_M_TASKS3: "进度",
  FE_43A_SD_CLOTH_RES: "服装",
  FE_43A_SD_CSV_RES: "CSV表",
  FE_43A_SD_ECAC_RES: "客户端ECA",
  FE_43A_SD_ECA_RES: "服务器ECA",
  FE_43A_SD_EFFECT_RES: "特效",
  FE_43A_SD_EMOTE_RES: "emote动作",
  FE_43A_SD_FCGC_RES: "客户端FCG",
  FE_43A_SD_INTERNALHUD_RES: "内置HUD",
  FE_43A_SD_ITEM_RES: "道具",
  FE_43A_SD_MOD_RES: "物件",
  FE_43A_SD_OTHER_RES: "其他资产注册",
  FE_43A_SD_QUIT_INFOR: "以下文件尚未存储，是否保存？",
  FE_43A_SD_SOUND_RES: "音效",
  FE_43A_SD_TABM_CLOSE: "关闭",
  FE_43A_SD_TABM_CLOSEOTHER: "关闭其他选项卡",
  FE_43A_SD_TABM_CLOSERIGHT: "关闭右侧选项卡",
  FE_43A_SD_TABM_LOCATIONOPEN: "打开本地文件位置",
  FE_43A_SD_TABM_LOCATIONVIEW: "查看文件位置",
  FE_43A_SD_TABM_SAVEALL: "保存全部选项卡",
  FE_43A_SD_TABM_SAVECURRENT: "保存当前文件",
  FE_43A_SD_TEXTURE_RES: "贴图文件",
  FE_43A_SD_VEHICLESKIN_RES: "车皮",
  FE_43A_SD_WEAPONSKIN_RES: "枪皮",
  FE_43_HJ_NFPP_3CRESOURCE: "3C资源下载",
  FE_43_HJ_NFPP_SWITCH: "使用新版第一人称资源",
  FE_43_HZY_COMPLIANT_TIP: `发现不兼容的版本（编辑器版本：{0}，资源版本：{1}）
部分功能可能缺失，是否继续？`,
  FE_43_HZY_UPDATE: "版本更新",
  FE_43_HZY_UPDATE_CANCEL: "暂不更新",
  FE_43_HZY_UPDATE_CONFIRM: "立即更新",
  FE_43_HZY_UPDATE_MENU_TEST: "检查更新",
  FE_43_HZY_UPDATE_NETWORKERROR: "网络异常，请稍后重试",
  FE_43_HZY_UPDATE_RETRY_TIP: "重新下载将清除当前下载进程。如网络连接正常，但下载进度长时间未刷新时，建议重新下载",
  FE_43_HZY_UPDATE_SAVE: "保存并更新",
  FE_43_HZY_UPDATE_TEST: "检查版本信息",
  FE_43_HZY_UPDATE_TIP: "当前编辑器版本过低，需更新后才可使用发布功能，更新前请先保存文件",
  FE_43_HZY_UPDATE_TIP1: "当前编辑器已是最新版本",
  FE_43_HZY_UPDATE_TIP2: `版本验证失败
未连接到服务器，请检查网络后重试`,
  FE_43_HZY_UPDATE_W_CLOSETIP: "正在下载Craftland Studio {0}，确定要退出吗",
  FE_43_HZY_UPDATE_W_DEFAULT: `1.修复了一些bug
2.优化了一些体验细节`,
  FE_43_HZY_UPDATE_W_DETAIL: "{0}更新内容",
  FE_43_HZY_UPDATE_W_LOAD: "下载中...",
  FE_43_HZY_UPDATE_W_RECONNECT: "网络重连中...",
  FE_43_HZY_UPDATE_W_RETRY: "重新下载",
  FE_43_HZY_UPDATE_W_TIP1: "提示：当前编辑器版本为{0}，检测到有新的版本发布，推荐更新",
  FE_43_HZY_UPDATE_W_TIP2: "提示：当前编辑器版本为{0}，版本过低需更新后继续使用",
  FE_43_HZY_UPDATE_W_WEB: "查看官网",
  FE_43_M_BOMBERSCRIPT: "炸弹人（脚本）",
  FE_43_SD_ASSETS: "资源",
  FE_43_SD_ASSETS_IMPACK: "导入package",
  FE_43_SD_ASSETS_IMPORT: "导入",
  FE_43_SD_ASSETS_OUTPACK: "导出为package",
  FE_43_SD_ASSETS_PACKSHOP: "资源商店",
  FE_43_SD_ASSETS_UPLOADPACK: "生成资源包并上传",
  FE_43_SD_EDIT: "编辑",
  FE_43_SD_EDIT_COPY: "复制",
  FE_43_SD_EDIT_DELETE: "删除",
  FE_43_SD_EDIT_DUPLICATE: "快速复制",
  FE_43_SD_EDIT_FOCUS: "聚焦",
  FE_43_SD_EDIT_PASTE: "粘贴",
  FE_43_SD_EDIT_REDO: "重做",
  FE_43_SD_EDIT_RENAME: "重命名",
  FE_43_SD_EDIT_SAVE: "保存",
  FE_43_SD_EDIT_UNDO: "撤销",
  FE_43_SD_ERROR_DIVISOR: "除数不能为0",
  FE_43_SD_ERROR_KEY_NOTINMAP: "指定的key在Map中不存在：{0}",
  FE_43_SD_ERROR_LIST_OUTRANGE: " List下标超出范围：{0}",
  FE_43_SD_FCG_ASSETLOST: "文件丢失，子级注册内容失效",
  FE_43_SD_FCG_ASS_RES: "资产注册",
  FE_43_SD_FCG_DELETE_TEXT_B: "是否确定删除该资产注册？",
  FE_43_SD_FCG_DELETE_TEXT_F: "您已经注册了该资产内的子节点，删除该资产注册后将使子节点注册失效。",
  FE_43_SD_FCG_DELETE_WIN: "注意",
  FE_43_SD_FCG_ENTITYSELETE: "实体选择",
  FE_43_SD_FCG_FCG_RES: "服务器FCG",
  FE_43_SD_FCG_FILESELETE: "文件选择",
  FE_43_SD_FCG_KEY_NAMEINL: "key命名不合规",
  FE_43_SD_FCG_N_DICT: "脚本变量名",
  FE_43_SD_FCG_N_ENUM: "枚举名称",
  FE_43_SD_FCG_N_GRAPH: "graph名称",
  FE_43_SD_FCG_OBJ_RES: "场景物件注册",
  FE_43_SD_FCG_PREFAB_RES: "prefab文件",
  FE_43_SD_FCG_SCE_RES: "场景文件",
  FE_43_SD_FCG_SCE_WAITRESIST: "请先注册场景文件",
  FE_43_SD_FCG_SYN_DES: "引用语法",
  FE_43_SD_FCG_UI_RES: "UI文件",
  FE_43_SD_FCG_UI_WAITRESIST: "请先注册UI文件",
  FE_43_SD_FCG_UI_WID_RES: "UI控件注册",
  FE_43_SD_FCG_WINDOWNAME: "脚本资产注册",
  FE_43_SD_FILE: "文件",
  FE_43_SD_FILE_BUILD: "生成",
  FE_43_SD_FILE_EXIT: "退出",
  FE_43_SD_FILE_MODULE: "系统设置",
  FE_43_SD_FILE_NEW: "新建工程",
  FE_43_SD_FILE_OPEN: "打开工程",
  FE_43_SD_FILE_PUBLISH: "发布工程",
  FE_43_SD_FILE_QUITRUN: "退出运行",
  FE_43_SD_FILE_RUN: "运行",
  FE_43_SD_FILE_SAVE: "保存工程",
  FE_43_SD_HELP: "帮助",
  FE_43_SD_HELP_ABOUT: "关于",
  FE_43_SD_HELP_ACCOUNT: "账号管理",
  FE_43_SD_HELP_APIMANUAL: "API文档",
  FE_43_SD_HELP_CONTACT: "联系我们",
  FE_43_SD_HELP_SUGGEST: "建议与反馈",
  FE_43_SD_HELP_UPDATE: "版本更新",
  FE_43_SD_HELP_UPDATELOG: "更新日志",
  FE_43_SD_HELP_USERMANUAL: "用户手册",
  FE_43_SD_MODULE_ENTRY: "系统设置",
  FE_43_SD_SINGLEFILE_SAVE: "保存文件",
  FE_43_SD_TOOLS: "工具",
  FE_43_SD_TOOLS_COMPONENT: "组件管理器",
  FE_43_SD_TOOLS_DEBUG: "调试设置",
  FE_43_SD_TOOLS_DEVELOPER: "开发者工具",
  FE_43_SD_TOOLS_ENUM: "枚举管理器",
  FE_43_SD_TOOLS_FCG: "脚本化工具",
  FE_43_SD_TOOLS_FCG_NAME: "快捷脚本名命名",
  FE_43_SD_TOOLS_FCG_REGISTER: "脚本资产注册",
  FE_43_SD_TOOLS_LOC: "本地化设置",
  FE_43_SD_TOOLS_OPENLOG: "打开日志目录",
  FE_43_SD_TOOLS_PREFER: "偏好设置",
  FE_43_SD_TOOLS_SEARCH: "全局搜索",
  FE_43_SD_TOOLS_WORDFILTER: "脏字检测",
  FE_43_SD_WINDOW: "窗口",
  FE_43_SD_WINDOW_DECK: "工作区",
  FE_43_SD_WINDOW_FULL: "全屏",
  FE_43_SD_WINDOW_LAYOUT: "布局",
  FE_43_SD_WINDOW_LAYOUT_DEF: "默认",
  FE_43_SD_WINDOW_LAYOUT_DEL: "删除布局",
  FE_43_SD_WINDOW_LAYOUT_SAVE: "保存布局",
  FE_43_TYC_ENABLE_UGC_SPECTATOR: "启用UGC观战功能",
  FE_43_TYC_FREE_PERSPECTIVE: "自由视角",
  FE_43_TYC_FREE_PERSPECTIVE_WITH_REBOUND: "带有回弹的自由视角",
  FE_43_TYC_KEEP_TARGET_PERSPECTIVE: "保持目标玩家视角",
  FE_43_TYC_ONLY_ALLOW_SPECTATING_SELF: "仅允许观看自己",
  FE_43_TYC_ONLY_SPECTATING_ALLIES: "仅允许观看友方玩家",
  FE_43_TYC_ONLY_SPECTATING_SAME_FACTION: "仅允许观战同阵营玩家",
  FE_43_TYC_ONLY_SPECTATING_SAME_TEAM: "仅允许观战同队玩家",
  FE_43_TYC_PHYSICS_DESC_ANG: "如果脚下地面与重力水平面的夹角大小超过这个角度，就无法走上去，角色控制器会开始滑落。这个值是角度制的。",
  FE_43_TYC_PHYSICS_DESC_G: "角色控制器受到的重力加速度。",
  FE_43_TYC_PHYSICS_DESC_H: "胶囊体高度，这个高度含有半球体高度。",
  FE_43_TYC_PHYSICS_DESC_MAX_V: "角色控制器的绝对速度大小不能超过这个值。",
  FE_43_TYC_PHYSICS_DESC_MIN_D: "如果角色控制器将要移动的距离小于这个值，则完全不会移动。",
  FE_43_TYC_PHYSICS_DESC_OFFSET: "从Transform中心到胶囊体中心位置的偏移向量。",
  FE_43_TYC_PHYSICS_DESC_R: "胶囊体半径，这个半径不能超过高度的1/2。",
  FE_43_TYC_PHYSICS_DESC_SKIN_W: "为了避免抖动或者卡住，允许其他物体嵌入到该角色控制胶囊体的深度。",
  FE_43_TYC_PHYSICS_DESC_VTD: "上（下）楼梯时允许向上（下）偏移这么多距离而不脱离地面或被阻挡。常见于楼梯地形的移动情景。",
  FE_43_TYC_SHOW_LOBBY_BUTTON: "展示退出到大厅按钮",
  FE_43_TYC_SPECTATING_ANY_TARGET: "允许观看任意目标",
  FE_43_TYC_SPECTATOR_CAMERA_CONTROL_SETTING: "观战时相机操作设定",
  FE_43_TYC_SPECTATOR_SETTINGS: "观战设置",
  FE_43_TYC_SPECTATOR_TARGET_SETTING: "可观战对象设定",
  FE_43_TYC_UIED_TEXT_CLIPPING_SETTING: "剪裁设置",
  FE_43_TYC_UIED_TEXT_DIRECT_CLIPPING: "直接剪裁",
  FE_43_TYC_UIED_TEXT_NO_CLIPPING: "无裁剪",
  FE_43_TYC_UIED_TEXT_REDUCE_FONT_SIZE: "缩小字体",
  FE_43_TYC_UIED_TEXT_SHADOW_COLOR: "投影颜色",
  FE_43_TYC_UIED_TEXT_SHADOW_ENABLED: "启用投影效果",
  FE_43_TYC_UIED_TEXT_SHADOW_OFFSET: "投影偏移",
  FE_43_TYC_UNEDITABEL_INTERNAL_TEXTURE: "FreeFire资源，不可编辑",
  FE_43_XXJ_COPYCOMPONENT: "复制组件",
  FE_43_XXJ_GETVECTOR2COMPONENT: "获取二维向量分量",
  FE_43_XXJ_GETVECTOR3COMPONENT: "获取三维向量分量",
  FE_43_XXJ_MODULEUNOPENED: "以下模组未开启，请开启后重试",
  FE_43_XXJ_PASTECOMPNEW: "粘贴为新组件",
  FE_43_XXJ_PASTECOMPVALUE: "粘贴组件值",
  FE_43_XXJ_PHYSICS_ISCONVEX: "凸多边形",
  FE_43_XXJ_REQUIRECOMP: "需求组件",
  FE_43_XXJ_SETVECTOR2COMPONENT: "设置二维向量分量",
  FE_43_XXJ_SETVECTOR3COMPONENT: "设置三维向量分量",
  FE_43_XXJ_VECTOR2OPERATIONS: "二维向量运算",
  FE_43_XXJ_VECTOR3OPERATIONS: "三维向量运算",
  FE_43_XYL_AUTORENDERING: "自动合并渲染实例",
  FE_43_XYL_BATCHING: "合批",
  FE_43_XYL_CLIENT: "客户端",
  FE_43_XYL_CLIENTFCG: "客户端fcg",
  FE_43_XYL_CLINETECA: "客户端ECA",
  FE_43_XYL_CROSSEND: "是否跨端发送",
  FE_43_XYL_CULLBACK: "背面裁剪",
  FE_43_XYL_CULLMODE: "裁剪模式",
  FE_43_XYL_CULLOFF: "不裁剪",
  FE_43_XYL_ECACTEMPLATE: "ECAC模板",
  FE_43_XYL_EVENTTARGETSIDE: "事件所属端",
  FE_43_XYL_INHERITRENDERINGOPT: "继承渲染能优化的父节点设置",
  FE_43_XYL_MASKCOLOR: "遮罩颜色",
  FE_43_XYL_MASKTEXTURE: "遮罩贴图",
  FE_43_XYL_MERGEMODELS: "自动合并模型",
  FE_43_XYL_NOTIFYCLIENT: "通知客户端",
  FE_43_XYL_OFFLINECHILD: "离线合并子节点模型",
  FE_43_XYL_ONLINECHILD: "运行时合并子节点模型",
  FE_43_XYL_PREFORMANCEOPT: "地图性能优化",
  FE_43_XYL_REDUCTION: "自动减面比例",
  FE_43_XYL_RENDERINGOPT: "渲染性能优化",
  FE_43_XYL_SERVER: "服务器",
  FE_43_XYL_SERVERCLIENT: "客户端+服务器",
  FE_43_XYL_SERVERECA: "服务器ECA",
  FE_43_XYL_SERVERFCG: "服务器fcg",
  FE_43_XYL_STREAMINGDIST: "加载距离",
  FE_43_XYL_STREAMINGDIVD: "区域划分尺寸",
  FE_43_YU_WS_MODULEOPERATION: "装载后，才可以进行模组操作",
  FE_43_YU_WS_MODULE_ALL: "全部",
  FE_43_YU_WS_MODULE_BELONGEDMODULEDISABLE: "该模组所依赖的模组未生效",
  FE_43_YU_WS_MODULE_BELONGEDMODULEMISS: "所属模组未开启：",
  FE_43_YU_WS_MODULE_CANCEL: "取消",
  FE_43_YU_WS_MODULE_CANNOTINSTALLEDMODULES: "live版本不能装测试模组：",
  FE_43_YU_WS_MODULE_CANNOTINSTALLINTERNALMODULE: "您没有权限装载该模组：",
  FE_43_YU_WS_MODULE_CONFIRMTHEUNINSTALL: "该功能卸载后会导致所有使用过的模组内的API、事件、资源都失效，是否确认卸载？",
  FE_43_YU_WS_MODULE_CUSTOMCURRENCY: "自定义货币",
  FE_43_YU_WS_MODULE_CUSTOMMINIMAP: "自定义小地图",
  FE_43_YU_WS_MODULE_DEATHWATCH: "观战",
  FE_43_YU_WS_MODULE_DEFAULTMINIMAP: "默认小地图",
  FE_43_YU_WS_MODULE_DELETIONFAILED: "删除模组配置失败",
  FE_43_YU_WS_MODULE_DESCRIPTION: "说明",
  FE_43_YU_WS_MODULE_DISABLE: "禁用",
  FE_43_YU_WS_MODULE_DISABLEMODULE: "该模组所依赖的模组未生效，将它们都开启才能保证功能的正常运行。依赖且未生效的模组：",
  FE_43_YU_WS_MODULE_EXCLUSIVEMODULE: "存在与该模组互斥的已开启模组，请确定与该模组互斥的模组都未开启。互斥且开启的模组：",
  FE_43_YU_WS_MODULE_EXITEXCLUSIVEMODULE: "存在互斥模组",
  FE_43_YU_WS_MODULE_FUNCTIONSTATUS: "功能开启",
  FE_43_YU_WS_MODULE_LOADED: "已装载",
  FE_43_YU_WS_MODULE_LOADING: "装载",
  FE_43_YU_WS_MODULE_LOADINGTIPS: "装载提示",
  FE_43_YU_WS_MODULE_MARKEDDISCARD: "该模组已被标记废弃，未来版本将不再支持功能。请不要再使用，避免该模组失效带来的风险。",
  FE_43_YU_WS_MODULE_MINIMAPTYPE: "小地图类型",
  FE_43_YU_WS_MODULE_MODMOVED: "此模组已删除",
  FE_43_YU_WS_MODULE_MODULEMANAGEMENT: "模组管理器",
  FE_43_YU_WS_MODULE_NAME: "模组",
  FE_43_YU_WS_MODULE_NOTLOADED: "未装载",
  FE_43_YU_WS_MODULE_NUMBEROFPLAYERS: "玩家数量",
  FE_43_YU_WS_MODULE_ONECLICKLOADING: "一键装载",
  FE_43_YU_WS_MODULE_ONLINEDATAMANAGEMENT: "在线管理",
  FE_43_YU_WS_MODULE_OPENTHEMOD: "开启模组：",
  FE_43_YU_WS_MODULE_PRESETTYPE: "预设角色类型",
  FE_43_YU_WS_MODULE_REGISTRATIONFAILED: "注册失败",
  FE_43_YU_WS_MODULE_SCENE: "场景",
  FE_43_YU_WS_MODULE_SETTINGS: "设置",
  FE_43_YU_WS_MODULE_SPECIALSETTINGS: "特殊设置",
  FE_43_YU_WS_MODULE_TYPESELECTION: "类型选择",
  FE_43_YU_WS_MODULE_UNINSTALL: "卸载",
  FE_43_YU_WS_MODULE_UNINSTALLED: "模组已成功卸载",
  FE_43_YU_WS_MODULE_UNINSTALLPROMPT: "卸载提示",
  FE_43_YU_WS_MODULE_UNLOADEDDEPENDENCYFEATURES: "该模组存在依赖的模组，它所有依赖的模组都装载并开启才能保证该模组的功能正常。目前该模组所依赖的模组中未装载的有：",
  FE_43_YU_WS_MODULE_WARNING1: "配表信息不存在对应条目",
  FE_43_YU_WS_MODULE_WARNING2: "配表信息有误",
  FE_43_ZQ_PLAYER_ACTION: "动作",
  FE_43_ZQ_PLAYER_ADDACTION: "添加角色动作",
  FE_43_ZQ_PLAYER_ATTACK1FIST: "左手攻击",
  FE_43_ZQ_PLAYER_ATTACK2FIST: "右手攻击",
  FE_43_ZQ_PLAYER_ATTACK2GUN: "开火（持长枪）",
  FE_43_ZQ_PLAYER_ATTACK2PISTOL: "开火（持手枪）",
  FE_43_ZQ_PLAYER_BONETIPS: "部分骨骼与Free Fire角色骨骼不匹配，可能导致无法正常播放动画。",
  FE_43_ZQ_PLAYER_CACTION: "角色动作",
  FE_43_ZQ_PLAYER_CHANGECLIPGUN: "换弹（持长枪）",
  FE_43_ZQ_PLAYER_CHANGECLIPPISTOL: "换弹（持手枪）",
  FE_43_ZQ_PLAYER_CHANGEWEAPON: "切换武器",
  FE_43_ZQ_PLAYER_CMESH: "角色模型",
  FE_43_ZQ_PLAYER_CRAWIDLEFIST: "俯卧",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPGUN: "俯卧换弹（持长枪）",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPPISTOL: "俯卧换弹（持手枪）",
  FE_43_ZQ_PLAYER_CRAWLCHANGEWEAPON: "俯卧切换武器",
  FE_43_ZQ_PLAYER_CRAWLFFIST: "俯卧移动",
  FE_43_ZQ_PLAYER_CRAWLFGUN: "俯卧移动（持长枪）",
  FE_43_ZQ_PLAYER_CRAWLFIREGUN: "俯卧瞄准（持长枪）",
  FE_43_ZQ_PLAYER_CRAWLFIREPISTOL: "俯卧瞄准（持手枪）",
  FE_43_ZQ_PLAYER_CRAWLFIRINGGUN: "俯卧开火（持长枪）",
  FE_43_ZQ_PLAYER_CRAWLFIRINGPISTOL: "俯卧开火（持手枪）",
  FE_43_ZQ_PLAYER_CRAWLFPISTOL: "俯卧移动（持手枪）",
  FE_43_ZQ_PLAYER_CRAWLIDLEGUN: "俯卧（持长枪）",
  FE_43_ZQ_PLAYER_CRAWLIDLEPISTOL: "俯卧（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHATTACK1FIST: "蹲下左手攻击",
  FE_43_ZQ_PLAYER_CROUCHATTACK2FIST: "蹲下右手攻击",
  FE_43_ZQ_PLAYER_CROUCHATTACK2GUN: "蹲下开火（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHATTACK2PISTOL: "蹲下开火（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHBGUN: "瞄准时蹲下向后移动（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHBPISTOL: "瞄准时蹲下向后移动（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPGUN: "蹲下换弹（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPPISTOL: "蹲下换弹（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHCHANGEWEAPON: "蹲下切换武器",
  FE_43_ZQ_PLAYER_CROUCHFFIST: "蹲下移动",
  FE_43_ZQ_PLAYER_CROUCHFGUN: "蹲下移动（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHFPISTOL: "蹲下移动（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHIDLEFIST: "蹲下",
  FE_43_ZQ_PLAYER_CROUCHIDLEGUN: "蹲下（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHIDLEPISTOL: "蹲下（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHLGUN: "瞄准时蹲下向左移动（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHLPISTOL: "瞄准时蹲下向左移动（持手枪）",
  FE_43_ZQ_PLAYER_CROUCHRGUN: "瞄准时蹲下向右移动（持长枪）",
  FE_43_ZQ_PLAYER_CROUCHRPISTOL: "瞄准时蹲下向右移动（持手枪）",
  FE_43_ZQ_PLAYER_CUSTOMP: "玩家数据",
  FE_43_ZQ_PLAYER_DACTION: "默认动作",
  FE_43_ZQ_PLAYER_DASHRUNFFIST: "奔跑",
  FE_43_ZQ_PLAYER_DASHRUNFGUN: "奔跑（持长枪）",
  FE_43_ZQ_PLAYER_DASHRUNFPISTOL: "奔跑（持手枪）",
  FE_43_ZQ_PLAYER_DRIVERIDLE: "作为司机坐姿",
  FE_43_ZQ_PLAYER_FEMALE: "女",
  FE_43_ZQ_PLAYER_GENDER: "性别",
  FE_43_ZQ_PLAYER_GETRIG: "可点击此处获取默认Rig。",
  FE_43_ZQ_PLAYER_HIT: "受击",
  FE_43_ZQ_PLAYER_IDLE: "待机",
  FE_43_ZQ_PLAYER_INCARIDLE: "作为乘客坐姿",
  FE_43_ZQ_PLAYER_JUMPDOWNFIST: "跳跃下落",
  FE_43_ZQ_PLAYER_JUMPDOWNGUN: "跳跃下落（持长枪）",
  FE_43_ZQ_PLAYER_JUMPDOWNPISTOL: "跳跃下落（持手枪）",
  FE_43_ZQ_PLAYER_JUMPLANDFIST: "跳跃落地",
  FE_43_ZQ_PLAYER_JUMPLANDGUN: "跳跃落地（持长枪）",
  FE_43_ZQ_PLAYER_JUMPLANDPISTOL: "跳跃落地（持手枪）",
  FE_43_ZQ_PLAYER_JUMPUPFIST: "跳跃开始",
  FE_43_ZQ_PLAYER_JUMPUPGUN: "跳跃开始（持长枪）",
  FE_43_ZQ_PLAYER_JUMPUPPISTOL: "跳跃开始（持手枪）",
  FE_43_ZQ_PLAYER_LINE: "下划线",
  FE_43_ZQ_PLAYER_MALE: "男",
  FE_43_ZQ_PLAYER_MOVE: "移动",
  FE_43_ZQ_PLAYER_NEARDEATHIDLE: "倒地",
  FE_43_ZQ_PLAYER_NEARDEATHMOVE: "倒地向前爬",
  FE_43_ZQ_PLAYER_NEWCUSTOMP: "新建预设角色",
  FE_43_ZQ_PLAYER_NORMALDEAD: "死亡",
  FE_43_ZQ_PLAYER_ONLYADDEDANIM: "只播放增添动作",
  FE_43_ZQ_PLAYER_PLATFORM: "平台角色",
  FE_43_ZQ_PLAYER_PREVIEWTIPS: "请先添加模型！",
  FE_43_ZQ_PLAYER_RIG: "获取默认Rig",
  FE_43_ZQ_PLAYER_RIGTIPS: "若想要更改角色模型，建议使用官方的Rig，并在其他建模软件中导入使用，即可正常播放所有默认动画。",
  FE_43_ZQ_PLAYER_RUNFFIST: "向前移动",
  FE_43_ZQ_PLAYER_RUNFGUN: "向前移动（持长枪）",
  FE_43_ZQ_PLAYER_RUNFPISTOL: "向前移动（持手枪）",
  FE_43_ZQ_PLAYER_SHOOTIDLEGUN: "站立瞄准（持长枪）",
  FE_43_ZQ_PLAYER_SHOOTIDLEPISTOL: "站立瞄准（持手枪）",
  FE_43_ZQ_PLAYER_STANDIDLEFIST: "站立",
  FE_43_ZQ_PLAYER_STANDIDLEGUN: "站立（持长枪）",
  FE_43_ZQ_PLAYER_STANDIDLEPISTOL: "站立（持手枪）",
  FE_43_ZQ_PLAYER_WALKBGUN: "瞄准时向后移动（持长枪）",
  FE_43_ZQ_PLAYER_WALKBPISTOL: "瞄准时向后移动（持手枪）",
  FE_43_ZQ_PLAYER_WALKFGUN: "瞄准时向前移动（持长枪）",
  FE_43_ZQ_PLAYER_WALKFPISTOL: "瞄准时向前移动（持手枪）",
  FE_43_ZQ_PLAYER_WALKLGUN: "瞄准时向左移动（持长枪）",
  FE_43_ZQ_PLAYER_WALKLPISTOL: "瞄准时向左移动（持手枪）",
  FE_43_ZQ_PLAYER_WALKRGUN: "瞄准时向右移动（持长枪）",
  FE_43_ZQ_PLAYER_WALKRPISTOL: "瞄准时向右移动（持手枪）",
  FE_43_ZQ_REMOVE_REMOVE: "移除",
  FE_43_ZQ_REVIEW_LINEROW: "检测到{0}中的{1}行{2}列“{3}“为敏感词，请修改后重试。",
  FE_43_ZQ_REVIEW_MEANNING: "检测到{0}中语义存在敏感信息，请修改后重试。",
  FE_43_ZQ_STORE_BACK: "上一步",
  FE_43_ZQ_STORE_CHANGEPROJECT: "该引用资源来源于此工程，请尝试替换其他工程。",
  FE_43_ZQ_STORE_CODE: "资源识别码",
  FE_43_ZQ_STORE_CODECHANGE: "资源识别码已更改！",
  FE_43_ZQ_STORE_CREATE: "新建资源",
  FE_43_ZQ_STORE_DELETEPURCHASE: "从资源库中移除",
  FE_43_ZQ_STORE_DETAIL: "Detail界面",
  FE_43_ZQ_STORE_DOWN: "下架",
  FE_43_ZQ_STORE_EDIT: "操作界面",
  FE_43_ZQ_STORE_ESTSIZE: "预估大小",
  FE_43_ZQ_STORE_FABCANNOT: "该资源不可打包为商店资源。",
  FE_43_ZQ_STORE_HIGHVERSION: "商店资源版本号大于当前版本号。",
  FE_43_ZQ_STORE_NEEDLOGIN: "必须登录后才能上传",
  FE_43_ZQ_STORE_NEWRES: "发布新资源",
  FE_43_ZQ_STORE_NEWRESTIPS: "在资源商店中新增资源",
  FE_43_ZQ_STORE_NEXT: "下一步",
  FE_43_ZQ_STORE_NOSEARCH: "未检测到相关资源。",
  FE_43_ZQ_STORE_OPENED: "已存在打开中的项目，当前无法退出Craftland Studio！",
  FE_43_ZQ_STORE_PUBSET: "发布设置",
  FE_43_ZQ_STORE_QUOTECANNOT: "该资源或其引用中含引用包中资源，不可打包为商店资源。",
  FE_43_ZQ_STORE_REMOVEMYASSET: "将从【资源库】中移除该资源但不会删除本地文件，是否继续？",
  FE_43_ZQ_STORE_REMOVEMYUPLOAD: "将从【我的发布】中移除该资源，是否继续？",
  FE_43_ZQ_STORE_RESDETAIL: "资源详情",
  FE_43_ZQ_STORE_RESERRORTIPS: "操作异常，保存失败！",
  FE_43_ZQ_STORE_RESSCENETIPS: "该资源为引用资源，无法保存，再次进入将复原。",
  FE_43_ZQ_STORE_TRANSFERTIPS: "正在传输资源中，继续退出将会中断操作，是否继续？",
  FE_43_ZQ_STORE_TYPE: "资源类型",
  FE_43_ZQ_STORE_UNPUB: "已下架",
  FE_43_ZQ_STORE_UNPUBCONFIRM: "下架后其他用户将无法再获取该资源，是否继续？",
  FE_43_ZQ_STORE_UPDATERES: "更新资源",
  FE_43_ZQ_STORE_UPDATERESTIPS: "覆盖已在资源商店中发布的资源",
  FE_43_ZQ_STORE_UPDATETIME: "更新时间",
  FE_43_ZQ_STORE_UPLOAD: "上传界面",
  FE_43_ZQ_STORE_UPTIME: "上传时间",
  FE_43_ZQ_STORE_VERSION: "编辑器版本",
  FE_44A_HJ_ERRORCODE1: "自定义事件错误",
  FE_44A_HJ_ERRORCODE2: "自定义类型错误",
  FE_44A_SD_SETTING_UNITTESTBUILD: "单元测试构建，用于QA单元测试",
  FE_44A_SD_UNITTEST_BUILD: "单元测试构建",
  FE_44A_XXJ_ACTION: "行为",
  FE_44A_XXJ_BASIC: "基础",
  FE_44A_XXJ_COMPCONFLICK: "该组件与其他组件冲突：{0}",
  FE_44A_XXJ_CONDITION: "条件",
  FE_44A_XXJ_CSVDATA: "CSV数据",
  FE_44A_XXJ_DEPENDMISS: "该组件依赖的组件未添加：{0}",
  FE_44A_XXJ_SUPPLY: "物品",
  FE_44A_XXJ_VARIABLE: "变量",
  FE_44A_XXJ_WARNING_COMPCONFLICK: "{0}:组件{1}与组件{2}冲突",
  FE_44A_XXJ_WARNING_COMPDEPENDMISS: "{0}:组件{1}所依赖的组件{2}未添加",
  FE_44_HZY_BLADEBALL: "躲避球",
  FE_44_HZY_BLOCKINVALID_TIP1: "该图元在服务器端不支持	",
  FE_44_HZY_BLOCKINVALID_TIP2: "该图元在客户端不支持	",
  FE_44_HZY_BLOCKPERMISSION_CONCSOLE: "使用了超出您账号权限的图元，将不允许发布",
  FE_44_HZY_BLOCKPERMISSION_WARNING: "您没有权限使用该图元",
  FE_44_HZY_GUNKING: "武器大师",
  FE_44_HZY_HIERARCHY_MOUNTSCRIPT: "已挂载脚本",
  FE_44_HZY_INSPECTOR_ADDCOMPONENT: "添加组件",
  FE_44_HZY_INSPECTOR_TEXTURE: "纹理",
  FE_44_HZY_INSPECTOR_TILLING: "平铺",
  FE_44_HZY_INSPECTOR_TYPE: "类型",
  FE_44_HZY_MAPCOVER_PERMISIONTIP: "您无权限使用自定义封面资源",
  FE_44_HZY_PERMISSIONTIPS1: "该工程可能包含您无权编辑的资源，可能会导致发布时出错",
  FE_44_HZY_PERMISSIONTIPS2: "工程内包含您无权编辑的资源，无法发布",
  FE_44_HZY_PROJECT_BASICOBJECT: "基础物件",
  FE_44_HZY_PROJECT_CREATIONTIME: "按创建时间排序",
  FE_44_HZY_PROJECT_LASTEDITTIME: "按上次打开时间排序",
  FE_44_HZY_PVE: "僵尸大战",
  FE_44_HZY_REVIEW_BASE: "Basic Info",
  FE_44_HZY_REVIEW_ROOMPAR: "Custom Room Parameter",
  FE_44_HZY_SEARCH_FUNCTIONNAME: "以该函数名称进行搜索",
  FE_44_HZY_SEARCH_VARIABLENAME: "以该变量名称进行搜索",
  FE_44_HZY_SNIPER: "SNIPER",
  FE_44_M_WS_LOCALVAR: "局部变量",
  FE_44_SD_CUSRESULT: "上传自定义结算信息",
  FE_44_SD_EDIT_SELECT_ALL: "全选",
  FE_44_SD_EDIT_SELECT_CHILD: "选择所有子节点",
  FE_44_SD_EDIT_SELECT_INV: "反选",
  FE_44_SD_EDIT_SELECT_PARENT: "选择父节点",
  FE_44_SD_FCG_COMPILE: "脚本编译中",
  FE_44_SD_FCG_ENV: "手动部署FCG环境",
  FE_44_SD_TIPSFCG: "脚本语法",
  FE_44_TYC_ACTIVE: "激活状态",
  FE_44_TYC_ADD_ANIMATION_CLIP: "请添加动画动作",
  FE_44_TYC_ARROR: "方向箭头",
  FE_44_TYC_DRAG_RADIUS: "拖拽半径",
  FE_44_TYC_INACTIVE: "非激活状态",
  FE_44_TYC_JOYSTICK: "摇杆",
  FE_44_TYC_JOYSTICK_BG: "摇杆背景",
  FE_44_TYC_JOYSTICK_CAP: "摇杆键帽",
  FE_44_TYC_KEEP_PRESSED_OUTSIDE: "允许拖拽至范围外",
  FE_44_TYC_OFFSET: "偏移",
  FE_44_TYC_PLAYER_ANIMATION_NEED_SSS: "请为Stand、Stand(Rifle)、Stand(Pistol)添加动作",
  FE_44_TYC_RADIUS: "半径",
  FE_44_TYC_TOGGLE: "切换按钮",
  FE_44_TYC_TOUCHPAD: "触摸板",
  FE_44_TYC_TRANSPARENCY: "透明度",
  FE_44_TYC_WARNING_SERVER_DRIVEN_DISABLED: "UGC角色控制器{0}的属性“允许服务器驱动”未启用，所以相关的服务端API没有生效",
  FE_44_XXJ_ASSETTYPE: "资产类型",
  FE_44_XXJ_COMPOBSOLETE: "该组件已废弃，为保险起见请移去该组件",
  FE_44_XXJ_EDITCCTSHAPE: "编辑CCT形状",
  FE_44_XXJ_GAMERESULT: "游戏结算",
  FE_44_XXJ_GETRIGISTERASSETBYKEY: "根据key获取已注册资产",
  FE_44_XXJ_MODULEERROR: "由于存在互斥模组，导致导出失败，请检查模组管理器的设置后重试",
  FE_44_XXJ_PREPARING: "内容准备中",
  FE_44_XXJ_ROUNFPHASEINDEX: "回合与阶段索引",
  FE_44_XXJ_TIPCONTENTHIDE: "{0} 项目已经隐藏，因为并非所有的列表都有如此多项",
  FE_44_XXJ_WOWEMPTY: "是空的诶~",
  FE_44_XXJ_WS_RIGISTERRESNAME: "Key",
  FE_44_XYL_AUTOLOD0: "不自动生成Lod",
  FE_44_XYL_AUTOLOD1: "模型尺寸>15m",
  FE_44_XYL_AUTOLOD2: "2m<模型尺寸<15m",
  FE_44_XYL_AUTOLOD3: "模型尺寸<2m",
  FE_44_XYL_AUTOREDUCTION: "自动LOD简化",
  FE_44_XYL_DYNAMICNAVBLOCK: "动态导航网格障碍",
  FE_44_XYL_DYNAMICNAVBLOCKDESC: "会根据所勾选的物件的增删状态，动态的增删可以阻碍网格寻路的障碍，使用前需要先开启全局的设置动态导航网格",
  FE_44_XYL_PREVIEWANIM: "请选择可预览的动画文件",
  FE_44_XYL_REDUCTIONLIST: "自动减面Mesh文件列表",
  FE_44_XYL_SERVERSLOADAREA: "服务器信息加载区域",
  FE_44_XYL_SERVERSLOADAREACHILD: "区域",
  FE_44_XYL_SERVERSLOADCHOOSE: "启用场景内服务器加载区域功能",
  FE_44_XYL_SERVERSLOADDESC: "勾选后，可以在Hierarchy面板和场景内编辑服务器加载区域（百慕大、卡拉哈里、未来城、索拉等大型地图暂不支持此功能）",
  FE_44_XYL_SERVERSLOADSETTING: "服务器加载设置",
  FE_44_XYL_SERVERTOCLIENT: "同步到客户端",
  FE_44_XYL_SERVERTOCLIENTDESC: "勾选此项的物件的服务端逻辑操作会同步至客户端",
  FE_44_XYL_STREAMING0: "始终加载",
  FE_44_ZQ_IMPORT_PCKWARNING: "检测到该项目已有该资源包，重复导入可能导致部分资源被覆盖或引用关系丢失。是否继续导入？",
  FE_44_ZQ_PREVIEW_RUNGAME: "该资源暂不支持预览，请运行游戏查看。",
  FE_44_ZQ_PREVIEW_SELECT: "请选择用以预览的模型",
  FE_44_ZQ_RES_LOST: "引用资源：{0}已丢失",
  FE_44_ZQ_RES_NOEDIT: "来自引用资源：{0}，不可编辑",
  FE_44_ZQ_RES_PHASETIPS: "使用了阶段索引的图元，不可被导出进引用包内。",
  FE_44_ZQ_RES_PREECA: "预设脚本",
  FE_44_ZQ_RES_PRESFROM: "引用自 {0}",
  FE_44_ZQ_RES_RESENUM: "来自引用包的枚举",
  FE_45A_M_MODIFICATION: "是否确认修改数据？",
  FE_45A_M_SAVEFAILED: "修改数据有错误，保存失败",
  FE_45A_SD_ISSTATIC: "是否为静态",
  FE_45A_SD_NAME_ECA: "图元文件 ",
  FE_45A_SD_NAME_ECAC: "客户端图元文件 ",
  FE_45A_SD_NAME_FCC: "自定义库文件 ",
  FE_45A_SD_NAME_FCG: "脚本文件 ",
  FE_45A_SD_NAME_FCGC: "客户端脚本文件 ",
  FE_45A_SD_NAME_OTHER: "其他编程文件 ",
  FE_45A_SD_SCRIPTNAME_CURRENT: "当前名称",
  FE_45A_SD_SCRIPTNAME_HOLDER: "请输入文本",
  FE_45A_SD_SCRIPTNAME_TYPE: "类型",
  FE_45A_SD_STATICTIPS: "静态脚本会自动挂载到全局实体上，并在运行时执行。",
  FE_45A_SD_STATIC_FILE: "静态脚本",
  FE_45A_XXJ_ERRORCODE: "状态码",
  FE_45A_XXJ_OVERLIMIT: "存储超出限制",
  FE_45A_XXJ_PARAMERROR: "存储参数错误",
  FE_45A_XXJ_TIMEOUT: "存储超时",
  FE_45A_XYL_FEBRUSHGRASS: "草数量上限",
  FE_45A_XYL_FEBRUSHROCK: "石头数量上限",
  FE_45A_XYL_FEBRUSHSHRUB: "灌木数量上限",
  FE_45A_XYL_FEBRUSHTREE: "树数量上限",
  FE_45A_XYL_FEBRUSHWARN: "无法同时编辑引用相同资源的地形",
  FE_45A_XYL_FETIPS1: "退出雕刻",
  FE_45A_XYL_FETIPS2: "减小笔刷",
  FE_45A_XYL_FETIPS3: "放大笔刷",
  FE_45A_XYL_FETIPS4: "植被刷数量",
  FE_45A_XYL_FETIPS5: "植被刷数量已达到上限，需要删减",
  FE_45A_XYL_FETIPS6: "地形文件",
  FE_45_HJ_PLATFORM_ADDFRIEND: "添加好友按钮",
  FE_45_HJ_PLATFORM_BRIGHT: "按钮样式一",
  FE_45_HJ_PLATFORM_DARK: "按钮样式二",
  FE_45_HJ_PLATFORM_PERMISSIONTIPS1: "使用了超出您账号权限的UI控件，将不允许发布",
  FE_45_HJ_PLATFORM_REPORT: "举报按钮",
  FE_45_HJ_PLATFORM_SEETING: "好友申请通知类型",
  FE_45_HJ_PLATFORM_SEETINGMESSAGE: "留言板通知",
  FE_45_HJ_PLATFORM_SEETINGTYPE: "是否弹出好友申请弹窗",
  FE_45_HJ_PLATFORM_SEETINGWINDOW: "局内弹窗通知",
  FE_45_HJ_PLATFORM_WIDGET: "平台功能控件",
  FE_45_HZY_FOURFRIENDS: "FOUR FRIENDS",
  FE_45_HZY_FOURFRIENDS_D: "第一视角沉浸式解谜玩法，寻找线索解开谜题！",
  FE_45_HZY_SCENE_OPERATE_TIP14: "X/Y/Z轴旋转",
  FE_45_HZY_SCENE_OPERATE_TIP15: "连续摆放",
  FE_45_SD_AIS_AI: "AI搜索",
  FE_45_SD_AIS_BTN: "使用AI搜索",
  FE_45_SD_AIS_DEF: "默认搜索",
  FE_45_SD_AIS_NORESULT: "AI搜索未找到新增结果",
  FE_45_SD_BASICTEMPLATE: "基础模板",
  FE_45_SD_BERMUDA: "百慕大",
  FE_45_SD_CREATE: "创建",
  FE_45_SD_DESC_BERMUDA: "不含任何代码，默认地形为百慕大的工程",
  FE_45_SD_DESC_BLADEBALL: "解锁能力，赢得刀球胜利。",
  FE_45_SD_DESC_BOMBER: "放置炸弹攻击敌人，但小心别炸到自己。",
  FE_45_SD_DESC_BOMBERSCRIPT: "脚本化示例工程。放置炸弹攻击敌人，但小心别炸到自己。",
  FE_45_SD_DESC_EMPTYMAP: "不含任何代码，默认地形为空地图的工程",
  FE_45_SD_DESC_GUNKING: "使用各种武器消灭最多的敌人。",
  FE_45_SD_DESC_ISLANDL: "不含任何代码，默认地形为冠军岛的工程（小岛，面积为50*50）",
  FE_45_SD_DESC_ISLANDS: "不含任何代码，默认地形为初始岛的工程（大岛，面积为100*100）",
  FE_45_SD_DESC_PVE: "获得强大的效果，消灭最终 Boss！",
  FE_45_SD_DESC_SNIPER: "从这里活着出去，成为最佳狙击手！",
  FE_45_SD_EMPTYMAP: "空地图",
  FE_45_SD_GAMEPLAYTEMPLATE: "玩法模板",
  FE_45_SD_ISLAND_L: "初始岛",
  FE_45_SD_ISLAND_S: "冠军岛",
  FE_45_SD_NEWPROJECT: "工程管理",
  FE_45_SD_PROJECTLOST: "工程的本地文件不存在",
  FE_45_SD_REGIST_DYNAMIC: "动态调用语法",
  FE_45_SD_REGIST_LOST: "无法找到在 {0} 位置，资产类型为 {1} 的文件，该资产脚本名为 {2}",
  FE_45_SD_REGIST_STATIC: "静态调用语法",
  FE_45_SD_SPECIALTEMPLATE: "特殊模板",
  FE_45_SD_SPRITE_RES: "精灵文件",
  FE_45_SD_TEXTURE_RES: "纹理文件",
  FE_45_SD_TIMEOFMODIFY: "修改时间",
  FE_45_SD_VERSION: "版本",
  FE_45_TYC_CCT_COLLISION_THRESHOLD: "角色控制器碰撞阈值 ",
  FE_45_TYC_CCT_COLLISION_THRESHOLD_ANNOT: "这个参数用于判断角色控制器与刚体接触时，需要多强的相撞才会发生碰撞的阈值，未达到这个阈值时，角色控制器会尽可能稳定地推动刚体，而不是剧烈地碰撞",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH: "启用自定义推力",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH_ANNOT: "开启后，角色控制器推动刚体物件的力量大小可自定义",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY: "朝向跟随重力",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY_ANNOT: "开启后，角色控制器会跟随重力旋转自身的朝向",
  FE_45_TYC_CCT_PUSH_FORCE: "自定义推力力量 ",
  FE_45_TYC_CCT_PUSH_FORCE_ANNOT: "角色控制器推动刚体物件的力量大小",
  FE_45_TYC_COLLIDER_CONVEX: "凸形物理碰撞",
  FE_45_TYC_COLLIDER_CONVEX_ANNOT: "物理碰撞计算中将此网格视为凸形状",
  FE_45_TYC_COLLIDER_GEN: "生成碰撞器",
  FE_45_TYC_COLLIDER_GEN_ANNOT: "将网格拖入场景以创建物体时，自动添加并配置物理碰撞器组件",
  FE_45_TYC_COLLIDER_OPTIMIZATION: "优化物理碰撞",
  FE_45_TYC_COLLIDER_OPTIMIZATION_ANNOT: "通过简省信息来优化此网格用于物理碰撞时的效能",
  FE_45_TYC_MESH_SCALE_FACTOR: "网格缩放比例",
  FE_45_TYC_MESH_SCALE_FACTOR_ANNOT: "此文件中包含的网格大小将会按照此参数进行缩放",
  FE_45_TYC_MIDAIR_MOVE: "空中移动",
  FE_45_TYC_MIDAIR_MOVE_ANNOT: "开启后，玩家可以空中改变运动的速度和朝向",
  FE_45_TYC_MULTI_JUMP_HEIGHT: "多段跳的高度",
  FE_45_TYC_MULTI_JUMP_HEIGHT_ANNOT: "在空中进行多段跳上升的高度",
  FE_45_TYC_MULTI_JUMP_MAX: "多段跳的最大次数",
  FE_45_TYC_MULTI_JUMP_MAX_ANNOT: "在空中连续进行多段跳的最大次数",
  FE_45_TYC_OPTIMIZATION_NONE: "无",
  FE_45_XXJ_DELETECUSTOMEVENT: "删除信号{0}",
  FE_45_XXJ_EDITCUSTOMEVENT: "编辑信号{0}",
  FE_45_XXJ_WARNING_EDITVARTYPE: "修改类型可能会导致已使用的图元或代码出现报错",
  FE_45_XXJ_WORKFLOWLOGIC: "流程内预置逻辑",
  FE_45_XXJ_WORKFLOWLOGICENABLE: "启用流程的内置逻辑",
  FE_45_XXJ_WORKFLOWLOGICENABLE_D: "是否启用在回合开始时的内置逻辑，例如玩家无敌效果、回合开始音效",
  FE_45_XYL_STOREBAN_1: "功能即将开放，敬请期待",
  FE_45_XYL_STOREBAN_2: "错误，该功能暂未开放使用",
  FE_46A_HZY_PROJECT_EMCTIP: "该工程为网络工程，请保存至本地使用",
  FE_46A_HZY_REVIEW_PUBLISH: "敏感字检测不通过，请查看具体报错信息",
  FE_46_ERRORCODE_UNKONW_PROP: "Property is unknown on {1}: {0}.待确认",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE: "Custom Type '{0}' Has Errors.",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE_LOOP: "Custom Type Required Loops: {0}.",
  FE_46_HJ_ERRORCODE_FUNCTION_SIGNATURE: "Mismatched function signature: {0}.",
  FE_46_HJ_ERRORCODE_GFILEE: "GFile is invalid for {1}: {0}.",
  FE_46_HJ_ERRORCODE_IMAGE: "Image file fallbacks to Texture since ambiguous type: {0}.",
  FE_46_HJ_ERRORCODE_MISSGRAPH: "Block Script is missing.",
  FE_46_HJ_ERRORCODE_NOTENTITY: "Cannot convert Type '{0}' to type 'Entity'.",
  FE_46_HJ_ERRORCODE_NOTENUM: "Cannot convert Type '{0}' to type 'Enum'.",
  FE_46_HJ_ERRORCODE_NOTFIND_FILE: "Cannot Find File: {0}.",
  FE_46_HJ_ERRORCODE_NOTFIND_GRAPH: "Cannot find Block Script '{0}'.",
  FE_46_HJ_ERRORCODE_NOTVALUE: "Value is not {0}.",
  FE_46_HJ_ERRORCODE_NOTVALUE_P: "Value is not {0} for {1}.",
  FE_46_HJ_ERRORCODE_NOTVALUE_RANGE: "Value ({0}) is not in range [{1}, {2}) for {3}.",
  FE_46_HJ_ERRORCODE_NULLPARAM: "The 'parameter' is null.",
  FE_46_HJ_ERRORCODE_REFEREDFILE: "Refered file is not a valid item bytes file: {0}.",
  FE_46_HJ_ERRORCODE_TYPEABSTRACT: "The type '{0}' is abstract.",
  FE_46_HJ_ERRORCODE_TYPE_ERROR: "Cannot convert 'unknown type' to type '{0}'.",
  FE_46_HJ_ERRORCODE_TYPE_ERROR_P: "Cannot convert type '{1}' to type '{0}'.",
  FE_46_HJ_ERRORCODE_UNKNOW_API1: "API Not Defined in Config :{0}.",
  FE_46_HJ_ERRORCODE_UNKNOW_API2: "API Not Defined : {0}.",
  FE_46_HJ_ERRORCODE_UNKNOW_APIID: "API ID not defined: {0}.",
  FE_46_HJ_ERRORCODE_UNKNOW_ENTITY_P: "Entity is unknown for {1}: {0}.",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENT: "Custom Event not defined.",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENTID: "Custom Event '{0}' not defined.",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE: "Unknown Type: '{0}'.",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPEASSIGNING: "The property is unkonwn.",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE_P: "Unknown '{1}' type: '{0}'.",
  FE_46_HJ_ERRORCODE_UNKNOW_VALUE_P: "Value is unknown for {1}: {0}.",
  FE_46_HJ_ERRORCODE_UNKONW_ACTION: "The Block '{0}' is unknown.",
  FE_46_HJ_ERRORCODE_UNKONW_ENTITY: "The 'type of parameter' is unknown.",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM: "The enum item '{0}' is unknown in enum '{1}'.",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM_P: "The enum item '{0}' is invalid in enum '{1}'.",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION: "The Block '{0}' is unknown.",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION2: "Unknown custom function/action define: {0}.",
  FE_46_HJ_ERRORCODE_UNKONW_PROP: "The property '{0}' is unkonwn in type '{1}'.",
  FE_46_HJ_ERRORCODE_UNKONW_PROPID: "The property '{0}' is invalid in type '{1}'.",
  FE_46_HJ_ERRORCODE_UNKONW_PROP_P: "The property '{0}' is unkonwn.",
  FE_46_HJ_ERRORCODE_UNKONW_VAR: "The variable '{0}' is unknown.",
  FE_46_HJ_ERRORCODE_UNKONW_VARLOCAL: "The local variable '{0}' is unknown.",
  FE_46_HJ_ERRORCODE_UNSPPPORTFILE: "Unsupported file export, type {1}: {0}.",
  FE_46_HJ_ERRORCODE_UPSUPPORTTYPE: "Value Type is unsupport for {1}: {0}.",
  FE_46_HZY_SHOW_INASSETS: "在Assets中显示",
  FE_46_HZY_SOUNDTYPE_CUSTOM: "自定义音频",
  FE_46_LJY_NUMTOSTRING5: "千位分隔符",
  FE_46_SD_BUTTON_DOUBLECLICK: "按钮双击时",
  FE_46_SD_NODELETE_WHEN_OPENED: "待删除文件已被打开，删除将关闭文件页签",
  FE_46_SD_NODELETE_WHEN_OPENED_2: "待删除文件已被打开，删除将关闭文件页签，且无法撤销删除操作",
  FE_46_SD_NODELETE_WHEN_OPENED_CONSOLE: "已被打开的待删除文件为：{0}",
  FE_46_SD_RESTORE_FILE_MISS: "{0} 的恢复文件未找到，无法恢复",
  "FE_46_SD_RESTORE_FILE_NO_PERMISSION ": "{0} 无法写入",
  "FE_46_SD_RESTORE_FILE_OVERRIDE ": "{0} 已存在，将被恢复文件覆盖",
  "FE_46_SD_RESTORE_FILE_PATH_ERROR ": "{0} 非本工程资产文件，不进行恢复",
  FE_46_SD_UNDOREDOING: "正在执行操作",
  "FE_46_SD_UNREDO_RENAME_NOT_FIND ": "{0} 未找到，不可移动或重命名 ",
  FE_46_SD_UNSELECTCALLBACK: "请选择回调",
  FE_46_TYC_CUSTOM_UI_DEPTH: "渲染层级",
  FE_46_TYC_CUSTOM_UI_DEPTH_DESC: "这个属性决定此自定义UI的绘制顺序，若与其他渲染层级产生冲突则可能导致渲染顺序穿插。自定义UI内控件的渲染顺序依据此属性自动设置。我们建议您为可能穿插的自定义UI预留合理的渲染层级间隔 ",
  FE_46_TYC_ENABLEAOIFILTER: "启用关注区域过滤",
  FE_46_TYC_ENABLEAOIFILTER_DESC: "关闭此功能则对所有物体都进行同步；启用此功能则意味着自动忽略距离过远的物体从而优化流量开销",
  FE_46_TYC_NO_COLLIDERS_TIPS: "未添加任何物理碰撞盒",
  FE_46_TYC_PANEL_DEPTH: "渲染层级",
  FE_46_TYC_PANEL_DEPTH_CONFLICT: "渲染层级冲突: ",
  FE_46_TYC_PANEL_DEPTH_DESC: "这个属性决定此控件的绘制顺序，若与其他渲染层级产生冲突则可能导致渲染顺序穿插。你不能直接更改它，这个属性按照自定义UI的渲染层级自动设置。",
  FE_46_TYC_PANEL_DEPTH_TOTAL: "总计渲染层级",
  FE_46_TYC_PANEL_DEPTH_TOTAL_DESC: "此自定义UI以及包含的控件所占据的所有渲染层级，若与其他渲染层级产生冲突则可能导致渲染顺序穿插",
  FE_46_XXJ_ADDOERSONA: "添加智能体",
  FE_46_XXJ_DYNAMICRES: "动态加载资源",
  FE_46_XXJ_FORMAT: "格式",
  FE_46_XXJ_FORMATVALUE: "位数",
  FE_46_XXJ_MUSTRES: "必须资源",
  FE_46_XXJ_NOFOUND: "未找到对应的智能体",
  FE_46_XXJ_NOPERMISSIONTOUSE: "无权使用",
  FE_46_XXJ_NUMTOFLOAT: "数字转字符串",
  FE_46_XXJ_NUMTOFLOAT1: "保留小数点后位数",
  FE_46_XXJ_NUMTOFLOAT2: "常规",
  FE_46_XXJ_NUMTOFLOAT3: "科学计数法",
  FE_46_XXJ_NUMTOFLOAT4: "百分比",
  FE_46_XXJ_PERSONALIMIT: "添加的智能体数量已达上限",
  FE_46_XXJ_PLAYERDIAMOND: "玩家拥有钻石量",
  FE_46_XXJ_PLAYERPREMIUM: "为玩家开启会员",
  FE_46_XXJ_PLEASEENTER: "请输入智能体ID",
  FE_46_XXJ_PREMIUMSETTING: "会员设置",
  FE_46_XXJ_RESCOLLECT: "资源收集",
  FE_46_XXJ_SEARCH: "查找",
  FE_46_XXJ_WARNINGMATCHRESULT: `RESULTWARNING
原结算逻辑已废弃，建议使用自定义结算，即勾选该项。自定义结算：游戏结束后直接玩家将直接返回大厅，如有需要可自制结算界面或使用相关模板。`,
  FE_46_XYL_FINDINCLASSIFICATION: "在分类中显示该物件",
  FE_46_XYL_FINDUGCDOCS: "查看使用说明",
  FE_46_XYL_NAVMESHSHOW: "显示场景内预览",
  FE_47A_HZY_BOMBERSCRIPT_LEVEL: "专业-炸弹人（脚本）",
  FE_47A_HZY_BOMBER_LEVEL: "专业-炸弹人",
  FE_47A_HZY_SNIPER_LEVEL: "进阶-狙击手",
  FE_47A_MX_CUSTOMEVENT_TIP: "删除该自定义事件将导致对应图元失效，是否确认删除?",
  FE_47_GT_USERMANUAL: "用户手册",
  FE_47_HJ_FOG_DENSITY: "雾效增长速率",
  FE_47_HJ_FOG_ENABLEFOG: "是否启用雾效",
  FE_47_HJ_FOG_ENDDISTANCE: "雾效结束距离",
  FE_47_HJ_FOG_EXPONENTIAL: "指数",
  FE_47_HJ_FOG_EXPONENTIALSQUARED: "指数平方",
  FE_47_HJ_FOG_FOGMODE: "雾效模式",
  FE_47_HJ_FOG_LINEAR: "线性",
  FE_47_HJ_FOG_STARTDISTANCE: "雾效开始距离",
  FE_47_HL_FREE_VIEW: "切换玩家视角/自由视角",
  FE_47_HZY_BLOCK_CATEGORY: "分类",
  FE_47_HZY_BLOCK_CUSTOMVARIABLE: "自定义变量",
  FE_47_HZY_BLOCK_DESC: "描述",
  FE_47_HZY_BLOCK_ID: "图元ID",
  FE_47_HZY_BLOCK_INPUT: "输入",
  FE_47_HZY_BLOCK_MODULE: "所属模组",
  FE_47_HZY_BLOCK_NAME: "图元名称",
  FE_47_HZY_BLOCK_OUTPUT: "输出",
  FE_47_HZY_BLOCK_OWNERTYPE: "可触发实体",
  FE_47_HZY_BLOCK_PARADESC: "参数说明",
  FE_47_HZY_BLOCK_RETURNDESC: "返回值描述",
  FE_47_HZY_BLOCK_RETURNTYPE: "返回类型",
  FE_47_HZY_CLIENTNUM_D: "设置客户端数量",
  FE_47_HZY_CUSTOMSTORE: "自定义商店",
  FE_47_HZY_CUSTOMSTORE_ADDCUSTOM: "添加自定义商品",
  FE_47_HZY_CUSTOMSTORE_ADDITEM: "拖拽至此处添加物品",
  FE_47_HZY_CUSTOMSTORE_ADDSHELVE: "新建货架",
  FE_47_HZY_CUSTOMSTORE_COVER: "封面图",
  FE_47_HZY_CUSTOMSTORE_CURRENCY: "货币类型",
  FE_47_HZY_CUSTOMSTORE_DELETETIP1: "是否确认删除该自定义商店，该操作不支持撤销",
  FE_47_HZY_CUSTOMSTORE_DELETETIP2: "是否清空商品并删除货架",
  FE_47_HZY_CUSTOMSTORE_DELETETIP3: "自定义商店实体删除后不可恢复，是否确认删除？",
  FE_47_HZY_CUSTOMSTORE_DOWN: "向下一层",
  FE_47_HZY_CUSTOMSTORE_EDIT: `自定义商店编辑
`,
  FE_47_HZY_CUSTOMSTORE_ENTITY: "商店实体",
  FE_47_HZY_CUSTOMSTORE_FFITEM: "FF物品库",
  FE_47_HZY_CUSTOMSTORE_INFO: "商品信息",
  FE_47_HZY_CUSTOMSTORE_LIMIT: "限售",
  FE_47_HZY_CUSTOMSTORE_LIMITNUM: "限售数量",
  FE_47_HZY_CUSTOMSTORE_PRODUCTCONTENT: "商品内容",
  FE_47_HZY_CUSTOMSTORE_PRODUCTNAME: "商品名",
  FE_47_HZY_CUSTOMSTORE_PROP: "商品属性",
  FE_47_HZY_CUSTOMSTORE_SHELVES: "货架",
  FE_47_HZY_CUSTOMSTORE_UP: "向上一层",
  FE_47_HZY_MODULE_CUSTOMRESULT_D: "勾选后，将不会显示默认结算界面",
  FE_47_HZY_MODULE_D: "管理模组及设置模组相关参数",
  FE_47_HZY_MODULE_LOGICFRAME_D: "勾选后开启低逻辑帧模式（帧率由30将为15）",
  FE_47_HZY_MODULE_LOOTSWITCH_D: "勾选后，百慕大、卡拉哈里、未来城、索拉等大型地图会启用经典模式内地面刷新的道具",
  FE_47_HZY_MODULE_NAVMESH_D: "勾选后，物件属性可以选择动态生成寻路障碍，该属性可以让物件创建或删除时，同时创建或删除碰撞区域相似的寻路障碍物",
  FE_47_HZY_MODULE_NFPP_D: "勾选后，将使用新版的第一人称资源",
  FE_47_HZY_SCENESWITCH_TIP: "该场景暂不支持切换",
  FE_47_HZY_SCENE_ALIGNMENTLOCK_D: "解锁后，可分别设置x,y,z轴的固定移动距离",
  FE_47_HZY_SCENE_ALIGNMENTRESET_D: "重置为默认数值",
  FE_47_HZY_SCENE_ALIGNMENTSET_D: "使用对齐功能，可以实现按固定距离移动、旋转、缩放场景物件",
  FE_47_HZY_SERVERSLOAD_BERMUDA: "该场景暂不支持分区加载",
  FE_47_HZY_TERRAIN_DOWN_D: "降低区域内的地形的高度",
  FE_47_HZY_TERRAIN_FLAT_D: "统一区域内的地形高度",
  FE_47_HZY_TERRAIN_SMOOTH_D: "使区域内的地形高低差变得平滑，消除锯齿起伏，让地形更加流畅自然",
  FE_47_HZY_TERRAIN_TEXTURE_CHANGE_D: "将当前选中的贴图替换为新贴图",
  FE_47_HZY_TERRAIN_TEXTURE_COVERALL_D: "勾选后，绘制当前所选贴图将覆盖整个地形",
  FE_47_HZY_TERRAIN_TEXTURE_DEL_D: "删除当前选中的贴图",
  FE_47_HZY_TERRAIN_TEXTURE_INPUT_D: "导入新的贴图样式",
  FE_47_HZY_TERRAIN_TEXTURE_TIP: "选中贴图进行绘制",
  FE_47_HZY_TERRAIN_UP_D: "提高区域内的地形的高度",
  FE_47_HZY_UI_3D_D: "此控件可显示Prefab等3D内容",
  FE_47_HZY_UI_AVATAR_D: "此控件可显示玩家的头像",
  FE_47_HZY_UI_BUTTON_D: "此控件可响应点击操作并触发事件逻辑",
  FE_47_HZY_UI_EMPTY_D: "此控件不可见，可用于组织控件父子级关系",
  FE_47_HZY_UI_JOYSTICK_D: "此控件模拟摇杆响应拖拽输入（仅限客户端）",
  FE_47_HZY_UI_LAYOUT_D: "此控件自动对子控件进行排列",
  FE_47_HZY_UI_PANEL_D: "此面板可承载其他子控件",
  FE_47_HZY_UI_PICTURE_D: "此控件用于显示图像",
  FE_47_HZY_UI_PLATFORM_D: "此面板可以使用“添加好友”和“举报”功能",
  FE_47_HZY_UI_SCROLLVIEW_D: "此面板的子控件可以被直接拖拽滚动",
  FE_47_HZY_UI_TEXTBOX_D: "此控件可获取用户输入的文本信息",
  FE_47_HZY_UI_TEXTURE_D: "此控件用于显示贴图",
  FE_47_HZY_UI_TEXT_D: "此控件用于显示文字内容",
  FE_47_HZY_UI_TOGGLE_D: "此控件与按钮类似，点击后会在激活和非激活状态之间切换",
  FE_47_HZY_UI_TOUCHPAD_D: "此控件可响应触摸拖拽输入（仅限客户端）",
  FE_47_JH_WS_ROOMMINPLAYERCNT: "最小开局人数（房间内）",
  FE_47_TYC_ANIM_BLEND_TIME: "混合淡入时长",
  FE_47_TYC_AOI_FILTER_ALWAYS: "始终过滤",
  FE_47_TYC_AOI_FILTER_AUTO: "自动",
  FE_47_TYC_AOI_FILTER_D: "AOI过滤决定此物体的过滤设置。自动：系统会根据物体是否静态决定是否启用过滤。不过滤：此物体始终同步，如同没有开启AOI。始终过滤：此物体始终被过滤，即当距离较远时不再同步",
  FE_47_TYC_AOI_FILTER_NEVER: "不过滤",
  FE_47_TYC_AOI_FILTER_T: "AOI过滤",
  FE_47_TYC_CCT_ENABLED_D: "不开启，则使用原生玩家角色控制器，此时玩家与物理刚体的交互可能不正确；开启后，则使用UGC角色控制器",
  FE_47_TYC_CCT_HEIGHT_D: "此角色控制器的胶囊体的高度。请注意胶囊体高度必须大于半径的两倍",
  FE_47_TYC_CCT_RADIUS_D: "此角色控制器的胶囊体的半径。请注意胶囊体高度必须大于半径的两倍",
  FE_47_TYC_GLOBAL_GRAVITY_D: "所有物理刚体受到的重力大小",
  FE_47_TYC_HINT_COLOR_TEXTURE_RESTRICTION: "不支持使用内置贴图或大于256*256px的贴图作为变色纹理",
  FE_47_TYC_PHYSICS_DEFAULT_MAT: "物理碰撞和刚体未设置物理材质时，将默认使用此处的物理材质",
  FE_47_TYC_PHYSICS_SLEEP_THRESHOLD_D: "若刚体的动能/质量<此值，则该刚体将自动进入休眠状态（可减少性能开销）",
  FE_47_TYC_PLAYER_PHYSICS_LAYER_D: "玩家角色所在的物理层级",
  FE_47_TYC_PTC: "粒子发射器",
  FE_47_TYC_PTC_A_ACCELERATION: "加速度",
  FE_47_TYC_PTC_A_ACCELERATION_D: "这个属性决定粒子如何随时间加速",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS: "加速度随机量",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS_D: "粒子加速度的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_ANGLE: "角度",
  FE_47_TYC_PTC_A_ANGLE_D: "粒子初始旋转角度（以随机轴为旋转轴心）",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS: "旋转角度随机量",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS_D: "粒子初始旋转角度的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY: "角速度",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_D: "粒子随着时间不断旋转（以随机轴为旋转轴心）",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS: "角速度随机量",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS_D: "粒子旋转速度的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_BOX: "立方体",
  FE_47_TYC_PTC_A_BOX_D: "从盒体体积内发射粒子，朝向为盒体垂直底面向上",
  FE_47_TYC_PTC_A_CIRCLE: "圆片面",
  FE_47_TYC_PTC_A_CIRCLE_D: "在这个圆形片面上向辐射方向射粒子",
  FE_47_TYC_PTC_A_COLOR: "粒子颜色",
  FE_47_TYC_PTC_A_COLOR_D: "此属性影响粒子变色",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME: "生命周期颜色",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME_D: "粒子颜色随着时间渐变",
  FE_47_TYC_PTC_A_CONE: "锥体",
  FE_47_TYC_PTC_A_CONE_D: "从锥体的底部为起点向外发射粒子（不是从体积内任意一点发射）",
  FE_47_TYC_PTC_A_DAMPING: "阻尼",
  FE_47_TYC_PTC_A_DAMPING_D: "粒子速度阻尼，这个值越大，摩擦力越大",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS: "阻尼随机量",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS_D: "粒子速度阻尼的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_DURATION: "持续时间",
  FE_47_TYC_PTC_A_DURATION_D: "粒子发射器运行一个周期的时间长度",
  FE_47_TYC_PTC_A_FINAL_VALUE: "最终值 ",
  FE_47_TYC_PTC_A_HEMISPHERE: "半球体",
  FE_47_TYC_PTC_A_HEMISPHERE_D: "从这个半球体的内部和表面为起点，以向外辐射为方向发射粒子",
  FE_47_TYC_PTC_A_INITIAL_VALUE: "初始值 ",
  FE_47_TYC_PTC_A_LIFETIME: "粒子寿命",
  FE_47_TYC_PTC_A_LIFETIME_D: "单个粒子存在和运行的时间",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS: "粒子寿命随机量",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS_D: "粒子寿命的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_LOOP: "自动重播",
  FE_47_TYC_PTC_A_LOOP_D: "如果启用此属性，粒子发射器将在发射完成自动重复播放",
  FE_47_TYC_PTC_A_MATERIAL: "粒子材质",
  FE_47_TYC_PTC_A_MATERIAL_D: "适用于粒子的渲染材质",
  FE_47_TYC_PTC_A_MAX_PARTICLES: "最大粒子数量",
  FE_47_TYC_PTC_A_MAX_PARTICLES_D: "同时允许的最多粒子数；如果达到限制，则不再生成新的粒子",
  FE_47_TYC_PTC_A_MESH: "自定义网格",
  FE_47_TYC_PTC_A_MESH_D: "从提供的任意网格顶点处向外发射粒子",
  FE_47_TYC_PTC_A_MODE: "发射模式",
  FE_47_TYC_PTC_A_MODE_D: "这个属性决定发射粒子的次序",
  FE_47_TYC_PTC_A_RATE_OVER_TIME: "发射速度",
  FE_47_TYC_PTC_A_RATE_OVER_TIME_D: "粒子发射器每秒发射多少个粒子",
  FE_47_TYC_PTC_A_RENDER_MODE: "渲染模式",
  FE_47_TYC_PTC_A_RENDER_MODE_D: "决定粒子使用哪种渲染模式",
  FE_47_TYC_PTC_A_SHAPE: "发射形状",
  FE_47_TYC_PTC_A_SHAPE_D: "这个属性决定粒子发射的初始位置和方向取枚举值。每种发射形状可能包含不同的附属选项",
  FE_47_TYC_PTC_A_SIMULATION_SPACE: "坐标系",
  FE_47_TYC_PTC_A_SIMULATION_SPACE_D: "此属性决定粒子运动所参考的坐标系",
  FE_47_TYC_PTC_A_SIMULATION_SPEED: "模拟速度",
  FE_47_TYC_PTC_A_SIMULATION_SPEED_D: "调整粒子发射器和粒子的总体速度",
  FE_47_TYC_PTC_A_SIZE: "大小",
  FE_47_TYC_PTC_A_SIZE_D: "粒子初始的缩放值",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS: "大小随机量",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS_D: "粒子初始大小的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_SORT_MODE: "排序模式",
  FE_47_TYC_PTC_A_SORT_MODE_D: "此属性决定粒子的绘制顺序的计算方式",
  FE_47_TYC_PTC_A_SPHERE: "球体",
  FE_47_TYC_PTC_A_SPHERE_D: "从这个球体的内部和表面为起点，以向外辐射为方向发射粒子",
  FE_47_TYC_PTC_A_START_SPEED: "初始发射速度 ",
  FE_47_TYC_PTC_A_START_SPEED_D: "粒子朝发射方向的初始速度 ",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS: "初始发射速度随机量",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS_D: "初始发射速度的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_A_TEXTURE: "变色纹理",
  FE_47_TYC_PTC_A_TEXTURE_D: "这个纹理影响粒子变色，从对应位置发射的粒子会采样此处的颜色变色",
  FE_47_TYC_PTC_A_TRANSFORM: "发射形状变换",
  FE_47_TYC_PTC_A_TRANSFORM_D: "此变换对发射形状适用，不会影响粒子形态",
  FE_47_TYC_PTC_A_VELOCITY: "速度",
  FE_47_TYC_PTC_A_VELOCITY_D: "粒子初始速度",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS: "速度随机量",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS_D: "粒子初始速度的随机量（最终值随机取属性值~属性值+随机量）",
  FE_47_TYC_PTC_BASIC: "基础",
  FE_47_TYC_PTC_ENUM_BILLBOARD: "面向摄像机 ",
  FE_47_TYC_PTC_ENUM_BY_DIST: "按距离",
  FE_47_TYC_PTC_ENUM_GLOBAL: "世界空间",
  FE_47_TYC_PTC_ENUM_LOCAL: "本地空间",
  FE_47_TYC_PTC_ENUM_LOOP: "循环",
  FE_47_TYC_PTC_ENUM_OLDEST_IN_FRONT: "最旧优先",
  FE_47_TYC_PTC_ENUM_PING_PONG: "往返",
  FE_47_TYC_PTC_ENUM_RANDOM: "随机",
  FE_47_TYC_PTC_ENUM_YOUNGEST_IN_FRONT: "最新优先",
  FE_47_TYC_PTC_PARA: "粒子参数",
  FE_47_TYC_PTC_PROPERTY_FILE: "粒子参数文件",
  FE_47_TYC_PTC_PROPERTY_FILE_D: "粒子参数文件描述了粒子发射器以及粒子的具体行为。你不能在运行时修改其中的参数，但可以替换不同的粒子参数文件",
  FE_47_TYC_PTC_RENDERING: "渲染",
  FE_47_TYC_PTC_SHAPE: "形状",
  FE_47_TYC_SHD_BLENDMODE: "混合模式",
  FE_47_TYC_SHD_COLOR_CORRECTION: "颜色矫正",
  FE_47_TYC_SHD_CULL_BACK: "背面",
  FE_47_TYC_SHD_CULL_FRONT: "正面",
  FE_47_TYC_SHD_MAIN_ROTATION: "纹理主旋转",
  FE_47_TYC_SHD_MASK: "遮罩",
  FE_47_TYC_SHD_ON: "开",
  FE_47_TYC_SHD_Z_TEST: "深度测试",
  FE_47_TYC_SHD_Z_WRITE: "深度写入",
  FE_47_XXJ_ACCOUNTNOPERMISSION: "您的账号没有使用persona的权限",
  FE_47_XXJ_AUTOCLEAR: "单局结束后自动清除",
  FE_47_XXJ_IMPORTED: "该Persona已存在，请勿重复导入",
  FE_47_XXJ_LOGINTIMEOUT: "账号登录状态已过期，请重新登录",
  FE_47_XXJ_MEMORYTYPE: "记忆方式",
  FE_47_XXJ_NOCONECT: "网络连接异常",
  FE_47_XXJ_NOPERMISSION: "无该Persona的使用权限",
  FE_47_XXJ_NOTAUTOCLEAR: "不自动清除",
  FE_47_XXJ_PERSONAIDSEARCH: "输入Persona ID完成搜索",
  FE_47_XXJ_PERSONAOFFLINE: "该persona已下线，请勿使用",
  FE_47_XXJ_PERSONATOOTIP: "在PersonaCenter可创建、并复制PersonaID，在此处粘贴ID进行导入并使用",
  FE_47_XXJ_SELECTOBSERVOR: "请选择对话抄送对象（观察者）",
  FE_47_XYL_ASSETSTORE_TYPE: "资源商店分类",
  FE_47_XYL_IMAPGEUPDATEFAIL: "不支持上传当前格式的图片",
  FE_47_XYL_PROJECTTEMPLATE: "工程模板",
  FE_47_XYL_SHOPSEARCHCOUNT: "共{0}个搜索结果",
  FE_47_XYL_SHOPSELECTTYPE: "选择分类",
  FE_47_XYL_SHOPTAGS: "标签",
  FE_47_XYL_SHOPTYPENONEERROR: "资源的商店分类不能为空",
  FE_47_XYL_SHOP_CLASSNEWEST: "从新到旧",
  FE_47_XYL_SHOP_CLASSOLDEST: "从旧到新",
  FE_47_XYL_SHOP_ENTERTOADD: "按Enter键创建标签",
  FE_47_XYL_SHOP_TAGLIMITED: "标签上限",
  FE_47_XYL_SHOP_TAGRECOMMEND: "推荐标签",
  FE_47_XYL_STORE2DASSET: "2D资源",
  FE_47_XYL_STORE3ASSET: "3D资源",
  FE_47_ZCS_EDITOR_EXIT_REMINDER: "项目未保存",
  FE_47_ZCS_EDITOR_FILTER_NOTICE: "无法在搜索状态下进行粘贴",
  FE_48A_HZY_CUSTOMRES_ADDTIP: "您没有使用自定义资源的权限，使用该资源可能导致发布失败",
  FE_48A_HZY_CUSTOMRES_CONSOLETIP: "您没有使用该自定义资源的权限，请替换或删除",
  FE_48A_HZY_SAVEFAIL_TIP1: "保存失败",
  FE_48A_HZY_SAVEFAIL_TIP2: "以下文件可能存在只读状态，请修改文件属性后重新保存",
  FE_48A_HZY_SAVEFAIL_TIP3: "该文件可能为只读状态，请修改文件属性后重新保存",
  FE_48A_XXJ_LOOPWARNIG: "上一个片段类型为永远循环，因此该片段无法生效",
  FE_48A_XXJ_UNSELECT: "取消选择",
  FE_48A_XYL_NAVMESHSWITCH: "启用离线静态导航网格功能",
  FE_48A_ZCS_EDITOR_SELECTED_NOTICE: "已选中",
  FE_48_HL_REVIEW_MEANNING: "检测到{0}中语义存在敏感信息{1}",
  FE_48_HZY_COSTLIMIT_CONSOLETIPS: "{0}资源超上限，请酌情删减场景资源",
  FE_48_HZY_COSTLIMIT_TIPS1: "场景资源超出限制后将无法成功发布，请酌情添加",
  FE_48_HZY_COSTLIMIT_TIPS2: "由于场景：{0} 资源过多，发布失败，请查看具体报错并删减场景资源",
  FE_48_HZY_DEFINEDPATH: "定义路径",
  FE_48_HZY_ECA_TIP_ONLY_SCENE_SELECT: "只可选择场景内的物件",
  FE_48_HZY_EDITCUSTOMEVENT: "编辑信号",
  FE_48_HZY_FUNCTIONNAME: "函数名称",
  FE_48_HZY_GETEXFUNCTION: "调用外部函数",
  FE_48_HZY_GETEXVARIABLE: "获取外部变量",
  FE_48_HZY_GETVARIABLE: `获取变量
`,
  FE_48_HZY_RECEIVEEVENT: "接收信号",
  FE_48_HZY_SELECTENTITY: "发送实体",
  FE_48_HZY_SENDEVENT: "发射信号",
  FE_48_HZY_SETEXVARIABLE: "设置外部变量",
  FE_48_SD_ASSET_REGIST: "资产注册",
  FE_48_SD_QUICKREGIST: "快捷资产注册",
  FE_48_TYC_CONVEX_WARNING_RIGIDBODY: "此碰撞体形状包含非凸网格， 所以无法作为动态或运动学刚体使用。要使设置生效，请使用凸网格或拆分为多个更简单的碰撞体组合 ",
  FE_48_TYC_CONVEX_WARNING_TRIGGER: "此碰撞体形状包含非凸网格，所以无法将其设置为触发器。要使设置生效请使用凸网格或其他碰撞体形状类型",
  FE_48_TYC_SPECTATOR_FF: "Free Fire",
  FE_48_TYC_SPECTATOR_FF_RULE: "保持 Free Fire 观战规则",
  FE_48_TYC_SPECTATOR_TYPE: "观战类型",
  FE_48_TYC_SPECTATOR_UGC: "Craftland Studio",
  "FE_48_TYC_UI_ADAPT_SCREEN ": "适配屏幕大小",
  FE_48_TYC_UI_PENETRATABLE: "点击可穿透",
  FE_48_TYC_UI_PENETRATABLE_D: "启用后此控件不会遮挡点触事件，在此控件下方的控件也能响应点触",
  FE_48_XXJ_ADDBEHINDWAYPOINT: "向后添加路点",
  FE_48_XXJ_ADDBODYPARTTRACK: "添加身体部位轨道",
  FE_48_XXJ_ADDEVENT: "添加事件帧",
  FE_48_XXJ_ADDFRONTWAYPOINT: "向前添加路点",
  FE_48_XXJ_ADDITIVE: "叠加",
  FE_48_XXJ_ADDWAYPOINT: "添加路点",
  FE_48_XXJ_BASETRAK: "基础轨道",
  FE_48_XXJ_BETA: "Beta版本，可能存在BUG",
  FE_48_XXJ_BODY: "身体",
  FE_48_XXJ_BODYPART: "身体部位",
  FE_48_XXJ_BODYPARTCONFIG: "身体部位配置",
  FE_48_XXJ_BODYPARTTRACK: "身体部位轨道",
  FE_48_XXJ_BONESELECTOR: "骨骼选择器",
  FE_48_XXJ_COLLAPSEALL: "收起",
  FE_48_XXJ_CREATECLIP: "新建片段",
  FE_48_XXJ_DELETECURRENTWAYPOINT: "删除当前路点",
  FE_48_XXJ_DELETEEVENT: "删除事件帧",
  FE_48_XXJ_ENDTIME: "结束时间",
  FE_48_XXJ_EVENTTRACK: "事件轨道",
  FE_48_XXJ_EXPANDALL: "展开",
  FE_48_XXJ_HOLD: "维持",
  FE_48_XXJ_LOCK: "锁定",
  FE_48_XXJ_LOOP: "循环",
  FE_48_XXJ_LOOPFOREVER: "永远循环",
  FE_48_XXJ_MASK: "遮罩",
  FE_48_XXJ_MUTE: "屏蔽",
  FE_48_XXJ_NONE: "无",
  FE_48_XXJ_OVERRIDE: "覆盖",
  FE_48_XXJ_PAUSE: "暂停",
  FE_48_XXJ_PINGPONG: "来回",
  FE_48_XXJ_PLAY: "播放",
  FE_48_XXJ_PLAYBACKLENGHT: "播放长度",
  FE_48_XXJ_POSTEXTRA: "后空隙",
  FE_48_XXJ_PREAXTRA: "前空隙",
  FE_48_XXJ_PREGERTANGENTDRAG: "优先拖拽切线控制器",
  FE_48_XXJ_REPLAY: "重新播放",
  FE_48_XXJ_SELECTBONES: "选择骨骼点",
  FE_48_XXJ_SELECTEDBONES: "已选{0}个骨骼",
  FE_48_XXJ_SELECTEDWAYPOINT: "选中的路点",
  FE_48_XXJ_SETGAPEXTRA: "设置空隙外推方式",
  FE_48_XXJ_SETTOCAMERA: "设置到当前场景相机的位置",
  FE_48_XXJ_STARTTIME: "开始时间",
  FE_48_XXJ_TOGGLEALL: "全选",
  FE_48_XXJ_UNLOCK: "解除锁定",
  FE_48_XXJ_UNMUTE: "解除屏蔽",
  FE_48_XXJ_WAYPOINTS: "路点",
  FE_48_XXJ_WEIGHT: "权重",
  FE_48_XYL_CUTOFF: "Cutoff",
  FE_48_ZCS_EDITOR_CHECK_UPDATES: "检查更新中...",
  FE_48_ZCS_EDITOR_COMPILER_VERSION: "编译器版本",
  FE_48_ZCS_EDITOR_COPY_PATH: "复制路径信息",
  FE_48_ZCS_EDITOR_DELETE_INVALID_PROJECT: "删除所有失效项目",
  FE_48_ZCS_EDITOR_MANAGEMENT: "管理",
  FE_48_ZCS_EDITOR_OFFICIAL_WEBSITE: "官方网站",
  FE_48_ZCS_EDITOR_PRIVACY_POLICY: "隐私政策",
  FE_48_ZCS_EDITOR_REFRESH_PROJECTLIST: "刷新项目列表",
  FE_48_ZCS_EDITOR_TERMS_OF_SERVICE: "服务条款",
  FE_48_ZCS_EDITOR_UPDATES_ABOUT: "更新与关于",
  FE_49A_HJ_OPENDATAFILE: "打开数据存储文件",
  FE_49A_HZY_COLLIDER_LIMITTIP1: "性能优化后该文件碰撞网格面数仍超过4000面，使用该文件可能会导致发布失败",
  FE_49A_HZY_COLLIDER_LIMITTIP2: "{0}碰撞网格面数超过上限，请优化物理碰撞或替换该文件",
  FE_49A_HZY_COLLIDER_LIMITTIP3: "工程内包含碰撞网格面数超过上限的文件，发布失败，请至控制台查看具体报错信息",
  FE_49A_HZY_SHADER_ALPHABC_D: "半透明效果材质，支持颜色叠加和透明度控制，适用于简易特效、玻璃、UI或其他半透明材质效果。",
  FE_49A_HZY_SHADER_BUILDCARTOON_D: "卡通风格材质，支持渐变光照、法线、高光和Matcap效果，适合风格化建筑。",
  FE_49A_HZY_SHADER_BUMPDIFFUSE_D: "支持法线贴图的漫反射材质，适用于需要基础光影和法线细节的物体，如建筑、道具等。",
  FE_49A_HZY_SHADER_BUMPSPECULAR_D: "基于Blinn-Phong光照模型的高光反射材质，支持法线、高光贴图，适用于金属、塑料等需要高光表现的物体。",
  FE_49A_HZY_SHADER_DIFFUSECOLORMULTI_D: "多光源漫反射材质，在标准漫反射材质的基础上支持多光源效果，适合需要多光源材质表现的简单物件。",
  FE_49A_HZY_SHADER_DIFFUSECOLOR_D: "标准漫反射材质，支持基础光照和颜色叠加，适用于需要简单材质表现的场景物件、道具或角色。",
  FE_49A_HZY_SHADER_DIFFUSECWE_D: "带表面流光特效的漫反射材质，支持遮罩贴图和UV滚动特效动画，适用于需要视觉增强和动态特效的物件。",
  FE_49A_HZY_SHADER_PARTICLE_D: "标准特效材质，支持颜色叠加、亮度矫正、贴图旋转控制和遮罩混合，提供Opaque、AlphaBlend、Additive三种基本的混合模式，适合制作简单的粒子或UI界面效果。",
  FE_49A_HZY_SHADER_REFLECTIONBM_D: "多光源高光反射材质，支持法线、高光、环境反射和菲涅尔效果，同时也提供多种叠加模式，适合需要高品质效果和多光源表现的场景物件、道具或角色。",
  FE_49A_HZY_SHADER_SKYBOXPRO_D: "程序化天空盒材质，支持渐变颜色和太阳光晕，适合需要简单或卡通材质表现的天空效果。",
  FE_49A_HZY_SHADER_SKYBOX_D: "天空盒材质，支持六面贴图、贴图旋转和曝光调节，适用于天空盒渲染。",
  FE_49A_MX_ACTUAL_HEIGHT: "实际高度",
  FE_49A_MX_ACTUAL_WIDTH: "实际宽度",
  FE_49A_MX_TEXTURE_MAX_SIZE: "最大尺寸",
  FE_49A_XYL_STORE_BANNED: "资源被封禁",
  FE_49A_XYL_STORE_REVIEW_FAILED: "审核失败",
  FE_49_HJ_DEBUG_ERROR: "连接服务器失败，请稍后再试",
  FE_49_HJ_DEBUG_GAMEOVER: "对局已结束",
  FE_49_HJ_PLAYER_SlowMove_FIST: "慢速移动",
  FE_49_HJ_PLAYER_SlowMove_GUN: "慢速移动（持长枪）",
  FE_49_HJ_PLAYER_SlowMove_PISTOL: "慢速移动（持手枪）",
  FE_49_HZY_CONTROLLER: "播放控制器",
  FE_49_HZY_CONTROLLERATTACH: "可挂载播放控制器的实体组件",
  FE_49_HZY_CONTROLLER_DELETETIP: "未查找到物件",
  FE_49_HZY_CONTROLLER_FRAMEMOVE: `逐帧运动
`,
  FE_49_HZY_CONTROLLER_FRAMEMOVETIP: "设置是否为逐帧运动，true：普通逐帧运动，false：叠加绝对运动",
  FE_49_HZY_CONTROLLER_LIFETIME: "持续时间（ms）",
  FE_49_HZY_CONTROLLER_OVERRIDETIP: "与其他运动存在冲突：可播放实体{0}",
  FE_49_HZY_CONTROLLER_PLAYABLE: "可播放实体{0}",
  FE_49_HZY_CONTROLLER_STARTTIME: "延迟开始时间（ms）",
  FE_49_HZY_FFA: "自由竞技",
  FE_49_HZY_FFA_D: "自由竞技（FFA）玩法，玩家各自为战，每一回合会选择百慕大地图中的随机区域作为战场，购买武器并击杀敌人获得更高的分数，游戏内有实时展示玩家分数与排名的计分板。",
  FE_49_HZY_PARKOUR: "跑酷",
  FE_49_HZY_PARKOUR_D: "经典的跑酷地图，场景中包含了基础的检查点与终点，配合富有想象力的场景，创造有趣的跑酷玩法吧！",
  FE_49_HZY_TEMPLATE_COMPLEXITY_1: "低",
  FE_49_HZY_TEMPLATE_COMPLEXITY_2: "中",
  FE_49_HZY_TEMPLATE_COMPLEXITY_3: "高",
  FE_49_HZY_TEMPLATE_ECACOMPLEXITY: "ECA复杂度",
  FE_49_HZY_TEMPLATE_LEVEL1: "简单",
  FE_49_HZY_TEMPLATE_LEVEL2: "进阶",
  FE_49_HZY_TEMPLATE_LEVEL3: "专业",
  FE_49_HZY_TEMPLATE_SCENECOMPLEXITY: "场景复杂度",
  FE_49_HZY_TEMPLATE_TUTORIAL: `查看教程
`,
  FE_49_HZY_TEMPLATE_UICOMPLEXITY: "UI复杂度",
  FE_49_TYC_PHYS_FREEZE_POS_X: "锁定位置-X值",
  FE_49_TYC_PHYS_FREEZE_POS_Y: "锁定位置-Y值",
  FE_49_TYC_PHYS_FREEZE_POS_Z: "锁定位置-Z值",
  FE_49_TYC_PHYS_FREEZE_ROT_X: "锁定旋转-X值",
  FE_49_TYC_PHYS_FREEZE_ROT_Y: "锁定旋转-Y值",
  FE_49_TYC_PHYS_FREEZE_ROT_Z: "锁定旋转-Z值",
  FE_49_TYC_PHYS_HINT_ANGULAR_DRAG: "为物体施加与其当前角速度成正比的反向扭矩，使物体在旋转时逐渐停止旋转 ",
  FE_49_TYC_PHYS_HINT_DRAG: "为物体施加与其当前线速度成正比的反向力，使物体在无外力作用时逐渐减速 ",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS: "物体在物理模拟中的弹性值大小",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS_COMBINATION: `此属性定义物理模拟中两个物体相互接触时实际计算弹力的方式，包含以下几种：
平均：取两个弹性值的平均值
最小：取两个弹性值中的最小值
相乘：将两个弹性值相乘
最大：取两个弹性值中的最大值

当两个物体的此属性不同时，优先级顺序为： 平均 < 最小 < 相乘 < 最大`,
  FE_49_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "物体在物理模拟中的动摩擦值大小",
  FE_49_TYC_PHYS_MAT_HINT_FRICTION_COMBINATION: `此属性定义物理模拟中两个物体相互接触时实际计算摩擦力的方式，包含以下几种：
平均：取两个摩擦值的平均值
最小：取两个摩擦值中的最小值
相乘：将两个摩擦值相乘
最大：取两个摩擦值中的最大值

当两个物体的此属性不同时，优先级顺序为： 平均 < 最小 < 相乘 < 最大

例如，如果一个物体设置为平均，而另一个设置为最大，那么碰撞时将使用最大模式，即采用两个摩擦值中的较大值，从而产生更强的摩擦效果。`,
  FE_49_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "物体在物理模拟中的静摩擦值大小",
  FE_49_TYC_PHYS_OPTIMIZATION_MAX: "最大性能简省",
  FE_49_TYC_PHYS_OPTIMIZATION_MEDIUM: "中等性能简省",
  FE_49_TYC_PHYS_OPTIMIZATION_MIN: "轻微性能简省",
  FE_49_TYC_PHYS_OPTIMIZATION_NONE: "关闭",
  FE_49_TYC_SHADER_SKYBOX_ENUM_MAIN_COLOR: "使用场景光源颜色",
  FE_49_TYC_SHADER_SKYBOX_ENUM_SUN_COLOR: "使用太阳颜色",
  FE_49_TYC_SHADER_SKYBOX_EXPOSURE: "曝光度",
  FE_49_TYC_SHADER_SKYBOX_GROUND_COLOR: "地面颜色",
  FE_49_TYC_SHADER_SKYBOX_GROUND_GRADIENT: "地面渐变",
  FE_49_TYC_SHADER_SKYBOX_GROUND_HORIZON_COLOR: "地面地平线颜色",
  FE_49_TYC_SHADER_SKYBOX_ROTATION: "旋转",
  FE_49_TYC_SHADER_SKYBOX_SKY_COLOR: "天空颜色",
  FE_49_TYC_SHADER_SKYBOX_SKY_GRADIENT: "天空渐变",
  FE_49_TYC_SHADER_SKYBOX_SKY_HORIZON_COLOR: "天空地平线颜色",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR: "太阳颜色",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR_MODE: "太阳颜色模式",
  FE_49_TYC_SHADER_SKYBOX_SUN_SIZE: "太阳大小",
  FE_49_TYC_SHADER_SKYBOX_TEX_BACK: "后方贴图",
  FE_49_TYC_SHADER_SKYBOX_TEX_DOWN: "底部贴图",
  FE_49_TYC_SHADER_SKYBOX_TEX_FRONT: "前方贴图",
  FE_49_TYC_SHADER_SKYBOX_TEX_LEFT: "左侧贴图",
  FE_49_TYC_SHADER_SKYBOX_TEX_RIGHT: "右侧贴图",
  FE_49_TYC_SHADER_SKYBOX_TEX_UP: "上方贴图",
  FE_49_TYC_SHADER_SKYBOX_TINT_COLOR: "色调",
  FE_49_TYC_SKY_CUSTOM_MATERIAL: "天空盒材质",
  FE_49_TYC_SKY_MAT_TYPE_WARNING: "建议使用适配天空盒的材质与着色器",
  FE_49_XXJ_CUSTOMEVENT: "自定义事件",
  FE_49_XXJ_EVENT: "代码定义事件",
  FE_49_XXJ_EVENTMGR: "事件管理器",
  FE_49_XXJ_EVENTPRAM: "事件发送参数",
  FE_49_XXJ_EVENTPRAM_D: "发送自定义事件时，可以选择通过参数传递一些数据，此处为预先配置参数的名字与类型",
  FE_49_XXJ_NOEVENT: "暂无自定义事件",
  FE_49_XXJ_PERFORMANCE_1: "请选择一个Performance资源开始编辑",
  FE_49_XXJ_PERFORMANCE_10: "暂停播放",
  FE_49_XXJ_PERFORMANCE_11: "跳转至开始",
  FE_49_XXJ_PERFORMANCE_12: "跳转至结束",
  FE_49_XXJ_PERFORMANCE_13: "前进1帧",
  FE_49_XXJ_PERFORMANCE_14: "后退1帧",
  FE_49_XXJ_PERFORMANCE_15: "播放范围",
  FE_49_XXJ_PERFORMANCE_16: "管理子轨道",
  FE_49_XXJ_PERFORMANCE_17: "已锁定",
  FE_49_XXJ_PERFORMANCE_18: "已屏蔽",
  FE_49_XXJ_PERFORMANCE_19: "接收者",
  FE_49_XXJ_PERFORMANCE_2: "打开资源选择器",
  FE_49_XXJ_PERFORMANCE_20: "预览中",
  FE_49_XXJ_PERFORMANCE_21: "多选中同时包含已绑定演员轨道的对象和未绑定演员轨道的对象，禁止编辑",
  FE_49_XXJ_PERFORMANCE_3: "组轨道",
  FE_49_XXJ_PERFORMANCE_4: "时长计算方式",
  FE_49_XXJ_PERFORMANCE_5: "固定",
  FE_49_XXJ_PERFORMANCE_6: "自动计算",
  FE_49_XXJ_PERFORMANCE_7: "开始录制",
  FE_49_XXJ_PERFORMANCE_8: "停止录制",
  FE_49_XXJ_PERFORMANCE_9: "开始播放",
  FE_49_XXJ_RECEIVEEVENT: "当接收事件{0}时",
  FE_49_XXJ_RECEIVERTYPE: "接收者的类型",
  FE_49_XXJ_RECEIVERTYPE_D: "发送自定义事件时，需要将接收事件的实体作为参数填入，此处为接收者实体类型的预配置，选择指定类型，届时编辑器会辅助做类型检测，若类型不确定，接收者实体类型选择为【实体】即可",
  FE_49_XXJ_SENDEVENT: "发送事件{0}",
  FE_49_XYL_GAMEPLAYOBJECTTIPDESC: "具备功能的物件",
  FE_49_ZCS_FEASSETSTORENOT_SUPPORT_ITEM: "没有可选物件类",
  FE_49_ZCS_FEASSETSTORE_CLPACKAGE: "资源类型",
  FE_49_ZCS_FEASSETSTORE_CLSETTING: "Craftland 上传设置",
  FE_49_ZCS_FEASSETSTORE_COMMON_CANTUPLOAD_ITEMBYTES: "你的工程无法上传到物件流的商品中",
  FE_49_ZCS_FEASSETSTORE_COST: "消耗",
  FE_49_ZCS_FEASSETSTORE_CUSTOM_SELECTION: "自定义区域",
  FE_49_ZCS_FEASSETSTORE_DEFAULTTEXT_UI: "描述关于{0}物件的信息",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_CATAGORY: "默认类别",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_VALUE: "默认值",
  FE_49_ZCS_FEASSETSTORE_ENTITYTYPE: "物件类名",
  FE_49_ZCS_FEASSETSTORE_ERROR_ASSET_SELECT: "你只能选择Assets目录下的资源打包",
  FE_49_ZCS_FEASSETSTORE_ERROR_CANTBUILD: "没有选择要打包的资源",
  FE_49_ZCS_FEASSETSTORE_ERROR_NOASSET: "没有找到商品",
  FE_49_ZCS_FEASSETSTORE_EXPAND_DETAIL: "展开细节",
  FE_49_ZCS_FEASSETSTORE_EXPORT_ALL: "导出全部",
  FE_49_ZCS_FEASSETSTORE_FESETTING: "Craftland Studio上传设置",
  FE_49_ZCS_FEASSETSTORE_HIDE_SOURCEFILE: "隐藏源文件",
  FE_49_ZCS_FEASSETSTORE_ITEMBYTES_ADVANCED: "你可手动修改manifest 与description.ecad，来达到更多效果。",
  FE_49_ZCS_FEASSETSTORE_ITEM_CATAGORY: "物件分类",
  FE_49_ZCS_FEASSETSTORE_ITEM_DESC: "描述",
  FE_49_ZCS_FEASSETSTORE_ITEM_NAME: "物件名",
  FE_49_ZCS_FEASSETSTORE_MAX_VALUE: "最大值",
  FE_49_ZCS_FEASSETSTORE_MIN_VALUE: "最小值",
  FE_49_ZCS_FEASSETSTORE_NOTSELECT_PREFEB: "没有选择任何预制件",
  FE_49_ZCS_FEASSETSTORE_SCALE: "尺寸",
  FE_49_ZCS_FEASSETSTORE_SCALING_RANGEERROR: "范围错误，数值应在 {0} ~ {1} 之间 ",
  FE_49_ZCS_FEASSETSTORE_SCALING_SIZEERROR: "尺寸参数错误，请确保最小值小于等于最大值",
  FE_49_ZCS_FEASSETSTORE_SELECTION_SIZE: "选择区域大小",
  FE_49_ZCS_FEASSETSTORE_SELECTION_TIP: "从资源包中选择单个物件进行使用",
  FE_49_ZCS_FEASSETSTORE_SELECT_PLATFORMS: "选择可发布平台",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_ANNO: "暂时没有可选择物件",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_COST: "总消耗",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO: "小物件信息",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO_TIPS: "本物件来源于原物件包，可单独使用或与其他物件组合搭配",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_SELECTALL: "选择全部",
  FE_49_ZCS_FEASSETSTORE_STEP_VALUE: "步进值",
  FE_49_ZCS_FEASSETSTORE_TAG_NOTICE: "输入文字后创建自定义标签",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_ALL: "所有",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_CL: "Craftland平台",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_DUAL: "双平台",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_FE: "Craftland Studio 平台",
  FE_49_ZCS_PREFABCHANGE_WARNING: "你的操作会让预制体的结构会发生改变，场景内的预制体并不会发生改变，请自行进行替换",
  FE_50A_M_UNPUBLISH: "取消发布",
  FE_50A_M_UNPUBLISH2: "正在取消工程发布，请稍等……",
  FE_50A_SJZ_MANAGE_ASAVESC: "自动保存成功",
  FE_50A_SJZ_MANAGE_ASAVETIME: "自动保存时间间隔",
  FE_50A_SJZ_MANAGE_HOUR: "{0}小时",
  FE_50A_SJZ_MANAGE_MIN: "{0}分钟",
  FE_50A_SJZ_MANAGE_NEVER: "从不",
  FE_50A_SJZ_MANAGE_SAVEAS: "另存为",
  FE_50A_SJZ_MANAGE_SAVEASSC: "另存为成功",
  FE_50A_SJZ_MANAGE_SEC: "{0}秒",
  FE_50A_SJZ_SEL_ACT: "已关闭活动状态",
  FE_50A_SJZ_SEL_HID: "隐藏",
  FE_50A_SJZ_SEL_LOC: "锁定",
  FE_50A_SJZ_SEL_VIS: "已关闭可见性",
  FE_50A_XXJ_PREVIEW_PREFAB: "暂不支持预览prefab",
  FE_50A_XYL_PREFABSCREENSHOTSGEN: "生成Prefab截图",
  FE_50_HJ_COL_ALLCOL: "设置列信息",
  FE_50_HJ_COL_COLNUMWARNING: "列数已达最大限制",
  FE_50_HJ_COL_ISUID: "Key可识别为玩家UID",
  FE_50_HJ_COL_ISUID_TIP: "是否使用玩家UID作为Key",
  FE_50_HJ_COL_KEYNAME: "KEY",
  FE_50_HJ_COL_TABLENAME: "多列数据表",
  FE_50_MX_Action_Enumeration: "Persona{0}的行为枚举",
  FE_50_MX_Persona_Action_ID_Check: "Persona{0}行为{1}不存在",
  FE_50_MX_Persona_ID_Check: "Persona{0}不存在，请检查是否使用",
  FE_50_M_CANCELPUBLISH: "发布已经取消，如有需要可重新发布",
  FE_50_M_PUBLISHING: "正在发布中",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME: "粒子加速度曲线",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME_DESC: "此属性控制粒子加速度如何随着生命时间而变化",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME: "粒子角度曲线",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME_DESC: "此属性控制粒子角度如何随着生命时间而变化",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD: "水平广告版",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD_DESC: "产生的粒子以面片渲染，方向朝向World Y+；粒子旋转时以Y+轴为旋转轴",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD: "垂直广告版",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD_DESC: "产生的粒子以面片渲染，朝向始终沿水平面面向相机；粒子旋转时以面片法向为旋转轴",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME: "粒子大小曲线",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME_DESC: "此属性控制粒子大小如何随着生命时间而变化",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME: "粒子速度曲线",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME_DESC: "此属性控制粒子速度如何随着生命时间而变化",
  FE_50_TYC_TRS: "TRS插值",
  FE_50_TYC_TRS_BLEND_RATIO: "应用比例 ",
  FE_50_TYC_TRS_BLEND_RATIO_DESC: "调整预测数值被应用的比例，例如0.8会使用20%当前数据+80%预测数据作为最终结果 ",
  FE_50_TYC_TRS_ENUM_EXTRAPOLATION: "外插值",
  FE_50_TYC_TRS_ENUM_INTRAPOLATION: "内插值",
  FE_50_TYC_TRS_INTERPOLATION_METHOD: "插值方式",
  FE_50_TYC_TRS_INTERPOLATION_METHOD_DESC: `外插：物体的位置比实际位置更靠前，可能会有短暂的穿透
内插：物体的位置比实际位置稍有延迟，物体碰撞抖动可能被消除一部分`,
  FE_50_TYC_TRS_MAX_ERROR: "最大误差限制 ",
  FE_50_TYC_TRS_MAX_ERROR_DESC: "若误差量超过这个值则立刻纠正误差（表现像偶尔瞬移） ",
  FE_50_TYC_TRS_MAX_ERROR_TIME: "误差纠正时限 ",
  FE_50_TYC_TRS_MAX_ERROR_TIME_DESC: "当误差超过一定值，就会按照这个值计时，之后会强制纠正误差（表现像瞬移） ",
  FE_50_TYC_TRS_MIN_ERROR: "误差阈值 ",
  FE_50_TYC_TRS_MIN_ERROR_DESC: "当误差超过这个值就会开始计时，之后会强制纠正误差（表现像瞬移） ",
  FE_50_TYC_TRS_PREDICT_RATIO: "预测比例 ",
  FE_50_TYC_TRS_PREDICT_RATIO_DESC: `调整外插值预测的幅度比例，例如1.2会使用更多20%的数值作为结果
若物体速度经常变化则应适当减少这个值`,
  FE_50_XXJ_ACONCE: "单次",
  FE_50_XXJ_ACPOSTEXTRA: "向后外推",
  FE_50_XXJ_ACWRAPMODE: "循环模式",
  FE_50_XXJ_PERFORMANCE_BETA: "演出(BETA)",
  FE_50_XXJ_RESLENGTH: "资源长度",
  FE_50_XXJ_TIMELINE_TRACK_ID: "轨道ID",
  FE_50_XXJ_TL_CLIP_RESET_ALL: "重置全部",
  FE_50_XXJ_TL_CLIP_RESET_DURATION: "重置时长",
  FE_50_XXJ_TL_CLIP_RESET_SPEED: "重置速度",
  FE_50_XXJ_TL_MISSING_ENTITY: "所选接收者缺少该事件需要的{0}组件",
  FE_50_XXJ_TL_PROP_MANAGER: "管理属性轨道",
  FE_51_HJ_FIRE: "投掷手雷",
  FE_51_HJ_FIRE_CRAWL: "俯卧投掷手雷",
  FE_51_HJ_FIRE_CROUCH: "蹲下投掷手雷",
  FE_51_HJ_GRENADE_CRAWL: "俯卧（持手雷）",
  FE_51_HJ_GRENADE_CROUCH: "蹲下（持手雷）",
  FE_51_HJ_GRENADE_IDLE: "站立（持手雷）",
  FE_51_HZY_CUSTOMSTORE_BUNDLE: "组合商品",
  FE_51_HZY_CUSTOMSTORE_CUSTOMITEM: "自定义商品",
  FE_51_HZY_FILTER_CUSTOMPROP: "包含自定义属性",
  FE_51_HZY_GSEARCH: "全局搜索",
  FE_51_HZY_GSEARCH_SHORTCUT: "全局搜索 Ctrl+K",
  FE_51_HZY_KALAHARI: "卡拉哈里",
  FE_51_HZY_KALAHARI_D: "不含任何代码，默认地形为卡拉哈里的工程",
  FE_51_HZY_NEXTERRA: "未来城",
  FE_51_HZY_NEXTERRA_D: "不含任何代码，默认地形为未来城的工程",
  FE_51_HZY_SEARCH_BLOCK: "图元",
  FE_51_HZY_SEARCH_COMPONENTS: "组件	",
  FE_51_HZY_SEARCH_MENU: "菜单",
  FE_51_HZY_SEARCH_NULL: "在{0}中未找到相关结果",
  FE_51_HZY_SEARCH_UICONTROL: "UI控件",
  FE_51_HZY_SHADER_APECULARINTENSITY: "高光强度",
  FE_51_HZY_SHADER_CLIPPING: "裁切",
  FE_51_HZY_SHADER_CONTRAST: "光暗对比度",
  FE_51_HZY_SHADER_DEST: "目标混合因子",
  FE_51_HZY_SHADER_EMISSIONCOLOR: "自发光颜色",
  FE_51_HZY_SHADER_EMISSIONINTENSITY: "自发光强度",
  FE_51_HZY_SHADER_EXPRESSIONTEX: "表情贴图",
  FE_51_HZY_SHADER_EXPRESSIONTEXTO: "表情贴图平铺/偏移",
  FE_51_HZY_SHADER_GLOSS: "高光光泽度",
  FE_51_HZY_SHADER_HAIR1: "头发颜色1",
  FE_51_HZY_SHADER_HAIR2: "头发颜色2",
  FE_51_HZY_SHADER_HAIR3: "头发颜色3",
  FE_51_HZY_SHADER_HAIR4: "头发颜色4",
  FE_51_HZY_SHADER_HAIRSHIFT: "高光偏移贴图",
  FE_51_HZY_SHADER_MAKEUPTEX: "面妆贴图",
  FE_51_HZY_SHADER_MAKEUPTEXTO: "面妆贴图平铺/偏移",
  FE_51_HZY_SHADER_MINIAVATARHAIR: "UGC迷你角色的头发材质，支持通过多参数(白底细节纹理贴图、法线、光照、Rim、自发光、各向异性高光等)调整，实现多种发色（含纯色、挑染、渐变等）与光效组合的高自由度效果。",
  FE_51_HZY_SHADER_MINIAVATARSKIN: "UGC迷你角色的皮肤材质，支持底色渐变、妆容与表情贴图叠加，以及肤色、环境光、高光、法线、Rim等多种参数调节，以实现丰富的皮肤表现。",
  FE_51_HZY_SHADER_MINIAVATARSTANDARD: "UGC迷你角色的标准基础材质，支持不透明与半透明、CutOff剔除渲染模式切换，支持自定义贴图叠加，基础颜色贴图、法线/光泽、高光、反射（MatCap）、自发光、Rim等参数调节，以实现适用于角色的衣物、道具等表现。",
  FE_51_HZY_SHADER_MINLIGHTINTENSITY: "场景主光源强度",
  FE_51_HZY_SHADER_NORMALINTENSITY: "法线强度",
  FE_51_HZY_SHADER_PREMULTIPLAY: "预乘透明度",
  FE_51_HZY_SHADER_REFELECTION: "反射",
  FE_51_HZY_SHADER_REFELECTIONTEX: "反射贴图",
  FE_51_HZY_SHADER_RIMCOLOR: "边缘颜色",
  FE_51_HZY_SHADER_RIMINTENSITY: "边缘强度",
  FE_51_HZY_SHADER_RIMPOWER: "边缘范围",
  FE_51_HZY_SHADER_SER: "R：高光贴图mask，G：自发光贴图mask，B：反射贴图mask",
  FE_51_HZY_SHADER_SHADOWINTENSITY: "阴影强度",
  FE_51_HZY_SHADER_SHADOWSPECULARINTENSITY: "阴影高光强度",
  FE_51_HZY_SHADER_SHINECOLOR: "下层高光颜色",
  FE_51_HZY_SHADER_SHINEINTENSITY: "下层高光强度",
  FE_51_HZY_SHADER_SHINEVALUE: "下层高光参数",
  FE_51_HZY_SHADER_SHINEVALUE_D: "Pos(x)：下层高光位置，Range(y)：下层高光范围，Length(z)：下层高光长度",
  FE_51_HZY_SHADER_SKINCOLOR: "肤色",
  FE_51_HZY_SHADER_SOURCE: "源混合因子",
  FE_51_HZY_SHADER_SPECULARCOLOR: "高光颜色",
  FE_51_HZY_SHADER_SPECULARMAP: "高光贴图",
  FE_51_HZY_SHADER_SPECULARVALUE_D: "Pos(x)：上层高光位置，Range(y)：上层高光范围，Length(z)：上层高光长度",
  FE_51_HZY_SHADER_TINTCOLOR: "贴图颜色",
  FE_51_HZY_SHADER_TOPSPECULARCOLOR: "上层高光颜色",
  FE_51_HZY_SHADER_TOPSPECULARINTENSITY: "上层高光强度",
  FE_51_HZY_SHADER_TOPSPECULARVALUE: "上层高光参数",
  FE_51_HZY_SOLARA: "索拉",
  FE_51_HZY_SOLARA_D: "不含任何代码，默认地形为索拉的工程",
  FE_51_MX_IMAGE_READ_WRITE: "读写",
  FE_51_MX_IMAGE_READ_WRITE_TIP: "仅需在需要脚本或运行时动态修改粒子网格/纹理时才打开“读写”，其他情况建议关闭以提升性能。",
  FE_51_MX_PERSONA_NAME: "角色名",
  FE_51_MX_PERSONA_OBSERVER: "观察者",
  FE_51_MX_PERSONA_UPDATETIME: "更新时间",
  FE_51_MX_VOICE_TIP: `语音ID：{0}
需在图元编写逻辑后生效`,
  FE_51_MX_VOICE_VOICEID: "语音ID",
  FE_51_MX_VOICE_VOICETITLE: "语音",
  FE_51_TYC_PHYS_MAT_AVERAGE: "平均",
  FE_51_TYC_PHYS_MAT_DYNAMIC_FRICTION: "动摩擦系数",
  FE_51_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "刚体发生滑动摩擦时的摩擦系数",
  FE_51_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "刚体静止时的摩擦系数",
  FE_51_TYC_PHYS_MAT_MAX: "最大",
  FE_51_TYC_PHYS_MAT_MIN: "最小",
  FE_51_TYC_PHYS_MAT_MULTIPLY: "相乘",
  FE_51_TYC_PHYS_MAT_STATIC_FRICTION: "静摩擦系数",
  FE_51_XXJ_ANIMATIONTARGET: "父轨道实体缺少组件{0}",
  FE_51_XXJ_ONPROPERTYCHANGE_TIPS: "开启后，该自定义属性变化时会发送对应的事件到图元脚本或代码脚本。需注意，在服务器修改自定义属性，事件将发送给双端；但在客户端修改本地实体的自定义属性，事件仅会发送给本地",
  FE_51_XXJ_PREVIEW_FPV1: "开启后将由切换相机轨道控制预览视角，即最终观众视角",
  FE_51_XXJ_PREVIEW_FPV2: "锁定观众视角",
  FE_51_XYL_CLASSETNOVERSION: "暂时不支持发布多版本CL商品",
  FE_51_XYL_PREFAB_NOT_IDENTITY: "Prefab根节点存在坐标偏移，请检查是否需要修正",
  FE_51_XYL_WRONGACCOUNT: "账号错误",
  FE_OB43_TYC_HIERARCHY_HIDE_SHOW: "隐藏/显示",
  FF_47A_HZY_QUICKMESSAGE_LEVEL: "进阶-团队突袭",
  OB40A_UP_DB1: "调试功能更新",
  OB40A_UP_DB2: "新增中途加入调试、中退调试、弱网调试",
  OB40A_UP_T1: "多处体验优化和bug修复",
  OB40A_UP_W1: "武器生成器",
  OB40A_UP_W2: "在inspector设置枪皮时，支持场景内刷新枪皮样式",
  OB40_UP_DB1: "数据存储功能更新",
  OB40_UP_DB2: `1.【数据中心】中【数据管理】，新增搜索，排序，编辑功能 
2.读写频率扩增 
--每分钟的写频率 30→ 40 
--每分钟的读频率 50→ 60`,
  OB40_UP_O1: "其他",
  OB40_UP_O2: `1.自定义碰撞盒可作为【触发器】使用 
2.支持音频文件以Assetbundle的形式导入及使用 
3.在流程设置中增加断线重连开关.随进随出开关.挂机检测开关 
4.新增一批图元，请前往UGC WIKI查询`,
  OB40_UP_S1: "多场景编辑功能更新",
  OB40_UP_S2: `1.支持一局比赛内，不同玩家传送到不同场景中 
2.建议操作方式： 
--使用多场景功能的项目，建议不要使用模板场景，只使用空场景 
--建议开启自定义小地图功能，定制场景的小地图 
--不同场景（.scene文件）中物件的坐标建议不要重合（FE中多场景2.0的实现方式可以理解为：服务器将多个.scene文件拼合成一张大世界地图，每个客户端只加载一个.scene文件。坐标重合的话，涉及服务器处理的逻辑会有问题。）`,
  OB40_UP_T1: "地形编辑功能",
  OB40_UP_T2: `1.新增【Terrain】，可进行地形相关编辑操作 
2.新增植被刷样式 
3.可编辑地形面积扩大至150*150，支持多地形块`,
  OB40_UP_UI1: "UI编辑器更新",
  OB40_UP_UI2: `1.在【UI编辑器】中，将原有的Panel和Layout控件进行整合，保留原有的长宽和锚点锚框属性，新增背景填充和裁切功能
2.将原有的Layout功能迁移后重新进行修整，已经恢复到正常使用
3.新增ScrollView控件并开放相应属性，可以使用ScrollView制作屏幕滚动等效果
4.开放所有控件属性在图元中获取和调用`,
  OB41A_UP_1: "新增问题反馈通道",
  OB41A_UP_1_D: "1.点击右上角问号按钮，即可提交您宝贵的建议",
  OB41A_UP_2: "多处交互体验优化",
  OB41_UP_1: "新增动画状态机1.0",
  OB41_UP_1_D: `1.新增动画状态机功能，可以为僵尸和通过assetbundle导入的prefab添加状态机；
2.状态机为纯动画的控制器，需要通过eca图元撰写逻辑来切换动画状态；
3.当没有切换其他动画状态或其他状态播放完成后，都会回到Idle的动画状态`,
  OB41_UP_2: "UI编辑器优化",
  OB41_UP_2_D: `1.插值运动设置图元目前已支持UI控件；
2.新增3DContainer，可以将3D物件、特效等prefab添加至Container，并在HUD界面中显示；
3.在资源管理选择器中选择和替换需要的3D资源；
4.可以单独对挂载资源的旋转角度和整体缩放进行设置
5.新增Texture控件，开放九宫、平铺、填充等更多显示方式；
6.Image新增填充方式，同Texture保持一致；
7.新增头像控件，帮助创作者获取和展示玩家信息，制作排行榜等功能；
8.有两种样式提供给创作者选择，并可以单独开关需要显示的身份信息，包括昵称、纪念章、背景板、段位等`,
  OB41_UP_3: "脚本化2.0",
  OB41_UP_3_D: `1.更新插件功能
-错误提示
-语义高亮
-悬浮提示
-跳转定义
2.更新引擎支持
3.新增脚本名，可通过右键或快捷键更改下述功能的脚本名
-自定义组件
-自定义属性
-自定义枚举
-枚举内容
-自定义事件
-图元变量
-自定义函数
-ECA文件`,
  OB41_UP_4: "数据存储功能优化",
  OB41_UP_4_D: `1.新增统计数据表
2.新增定期清榜功能，可在发布后通过【数据中心】--【存档管理】–【定期清榜】进行设置
-清空设置与战场码绑定`,
  OB41_UP_5: "动态Navmesh",
  OB41_UP_5_D: `1.需要在流程设置中勾选【动态 navmesh】来开启功能
2.开启动态navmesh后，没有选择static navmesh属性的物件和动态生成的物件，其动态增、删、显、影均会影响僵尸等npc的寻路
3.debug栏可以选择导出运行中当前服务器navmesh文件进行查看`,
  OB42A_UP_1_D: `1.对编辑器基础操作进行了优化
2.对动画状态机、脚本等系统进行了功能更新`,
  OB42_UP_1: "新增资源商店",
  OB42_UP_1_D: `1.引用包的构建：用户自己制作的引用包是作为公有资源给其他用户下载使用的；
2.导入package流程中新增引用包文件类型，且支持自行选择根目录；
3.商店和资源库的登录接入；
4.资源包“制作-上传-下载-导入”的主流程跑通；`,
  OB42_UP_2: "支持骨骼模型与动画的导入及相应的简单应用",
  OB42_UP_2_D: `1.支持导入骨骼模型和动画文件；
2.动画文件支持预览，且可在时间轴上添加自定义事件；`,
  OB42_UP_3: "地形编辑优化",
  OB42_UP_3_D: `1.植被刷类型增加树木和石头；
2.增加植被刷擦除快捷键，选中植被刷+Shift：擦除范围内全部植被，选中植被刷+Ctrl：仅擦除当前所选植被
3.增加笔刷范围的显示
4.优化了平滑工具的雕刻逻辑，增加平整功能的笔刷大小调整功能`,
  OB42_UP_4: "新增可视化Debug工具",
  OB42_UP_4_D: `1.支持调试中查看实体在服务器的属性，修改实体位置
2.支持查看服务器实体数量，内存消耗`,
  OB42_UP_5: "优化物理系统",
  OB42_UP_5_D: `1.支持创建和编辑物理材质，使刚体具有弹力和摩擦力的表现
2.支持编辑全局重力
3.支持休眠和唤醒刚体`,
  OB42_UP_6: "其他优化",
  OB42_UP_6_D: `1.已使用图元支持全局（跨脚本文件）查找
2.ECA文件的挂载引用支持全局查找`,
  OB43A_UP_1: "提升编辑器的基础体验",
  OB43A_UP_1_D: `1.对Project内容进行显示优化
2.场景编辑器内增加操作提示
3.编辑器结构调整的遗留问题处理
4.其他BUG修复`,
  OB43_UP_1: "客户端逻辑支持",
  OB43_UP_1_D: `1.新增ECAC、FCGC文件，用于编写客户端相关图元、脚本逻辑
2.ECA和ECAC文件中，互通的图元会在两种文件中显示，不互通的、本端独有的图元只会出现在相应的文件中
3.服务器和客户端脚本之间的通信已经通过自定义事件的方式支持`,
  OB43_UP_2: "编辑器结构优化",
  OB43_UP_2_D: `1.更新编辑器结构框架
2.文件管理由编辑器层级变更为文件层级
3.菜单栏更新并展开
4.工具栏/调试功能/调试设置位置变更
5.问卷反馈&账号管理移除
6.模板功能关闭`,
  OB43_UP_3: "相机3.0",
  OB43_UP_3_D: "1.新增了一种相机类型 “新版第一人称相机视角相机”，使用时需勾选 “使用新版第一人称资源”选项，目前只支持SCAR枪型",
  OB43_UP_4: "物理3.0",
  OB43_UP_4_D: "1.新增角色控制器功能",
  OB43_UP_5: "FE对外准备工作",
  OB43_UP_5_D: `1.编辑器实现自动更新，在启动时检测版本，若有可用新版本则弹窗通知创作者
2.菜单栏中新增【检测更新】选项，点击可进行版本检测
3.提高图元编辑器性能，优化了图元过多时操作卡顿情况
4.化了场景编辑器性能，优化多选物件时的移动逻辑
5.场景编辑器中新增debug UI`,
  OB43_UP_6: "UGC自定义角色",
  OB43_UP_6_D: `1.支持选择【平台角色】或【预设角色】（文件）进入游戏
2.新建一种文件类型，用以存【预设角色】的所有配置信息
3.选择【预设角色】后可以配置角色的模型和所需的大部分动作
4.提供FF的rig文件供用户使用`,
  OB43_UP_7: "地图的性能优化",
  OB43_UP_7_D: `1.新增“静态”属性，开启静态的物件将仅做局内渲染，不作各种逻辑相关处理，降低性能消耗
2.现在可以自定义场景物件的Streaming，来控制物件的客户端加载逻辑（需要开启静态功能）
3.老的合批功能现在升级为“渲染性能优化”功能，有多种合批、合模型选项，具体使用方法见UGC官方文档
4.压缩了自定义资源的下载文件的大小`,
  OB43_UP_8: "脚本化4.0",
  OB43_UP_8_D: `1.新增脚本化资产注册功能
2.新增脚本插件对函数定义的快捷访问`,
  OB44_UP_1: "客户端逻辑更新",
  OB44_UP_1_D: `1.将有更多API支持客户端逻辑
2.场景物件可以通过属性来修改是否进行数据同步`,
  OB44_UP_2: "性能工具优化",
  OB44_UP_2_D: `1.支持设置服务器的场景加载范围，这个设置可以将服务器内存消耗降低
2.场景物件可以关闭静态寻路功能
3.增加自动减面功能，可以对模型做不同尺寸、不同距离的减面设置`,
  OB44_UP_3: "其他",
  OB44_UP_3_D: `1.脚本化将支持单元测试、插件自动更新、直接定义自定义内容
2.增加FF经典第一人称相机
3.物理系统将更强壮、局内支持更多对象使用物理
4.多处操作体验优化`,
  T_0_B_BotCanRevive: "机器人能否复活",
  T_0_B_ReviveCDTime: "复活CD时间",
  T_37_M_WS_CONTENTERROR: "内容不合法，请修改",
  T_37_M_WS_PARANULL: "属性值不能为空，请输入属性",
  T_37_WT_M_PARACHANGE: "设置失败，房间参数已达上限",
  T_38_M_WS_CONFIG: "参数配置",
  T_38_M_WS_CREATECONFIG: "房间参数配置",
  T_38_M_WS_CREATEDEL: "从房间参数中移除",
  T_38_M_WS_CREATENAME: "房间参数名称",
  T_38_M_WS_DELATT: "删除属性",
  T_38_M_WS_DELATTTIPS: "该属性已转换到【房间参数】类型中，确定要删除该属性吗？",
  T_38_M_WS_DISPLAYMODE: "参数显示方式",
  T_38_M_WS_DOWN: "向下移动",
  T_38_M_WS_EDIT: "编辑参数",
  T_38_M_WS_MODIFY: "修改为房间参数",
  T_38_M_WS_MUTIPLE: "多选列表",
  T_38_M_WS_RANGE: "范围选择",
  T_38_M_WS_ROOMPAR: "自定义房间参数",
  T_38_M_WS_SINGLE: "单选列表",
  T_38_M_WS_UP: "向上移动",
  T_46_TYC_ADD_SP_ERROR: "设置AOI错误：添加特别关注失败 观察目标={0}，观察者={1}",
  T_46_TYC_AOI_SP_PARAMS_ERROR: "设置AOI错误：参数错误 观察目标={0}，观察者={1}",
  T_46_TYC_AOI_SUPO_INVALID_OBSERVER_ERROR: "设置AOI错误：切换观察者时观察目标不是有效的玩家或者Transform实体 观察目标={0}，观察者={1}",
  T_46_TYC_AOI_SUPO_INVALID_USER_ERROR: "设置AOI错误：切换观察者时玩家不是有效的用户 观察目标={0}，观察者={1}",
  T_46_TYC_AOI_SUPO_PARAMS_ERROR: "设置AOI错误：切换观察者代理参数错误 观察目标={0}，观察者={1}",
  T_46_TYC_CLEAN_SP_ERROR: "设置AOI错误：清空特别关注失败 观察目标={0}",
  T_46_TYC_REMOVE_SP_ERROR: "设置AOI错误：移除特别关注失败 观察目标={0}，观察者={1}",
  T_46_TYC_SP_INVALID_USER_ERROR: "设置AOI错误：非法的观察者 观察目标={0}，观察者={1}",
  T_47_HL_CL_RECOMMEND_MORE: "查看更多",
  T_ACTIVATE_LOGIN_ACCOUNT: "已登录Craftland studio账户：",
  T_ACTIVATE_TITLE: "Craftland Studio激活",
  T_CONFIRMBOX_ACTIVATE_SUCCESS: "账户已激活",
  T_CONFIRMBOX_QUIT_CONTENT: "关闭后将退出Craftland Studio，确认嘛？",
  T_CONFIRMBOX_TITLE: "提示",
  T_DIALOG_CONFIRM: "激活",
  T_ENTER_ACTIVATE_CODE: "当前软件正处于测试阶段，请输入官方提供的激活码，验证成功后可以进入软件",
  UI_DES: "表格布局常用来制作背包系统，方便快速对子级元素进行排版",
  UI_DES_1: "填充版面布局帮助快速将子级元素均分在父级元素下",
  UI_NAME: "表格布局示例",
  UI_NAME_1: "填充版面布局示例"
};
export {
  _ as default
};
